import React, { forwardRef, useEffect, useRef, useImperativeHandle, useState, useMemo } from 'react';
import './formField.scss';
import { Picker, List, InputItem, TextareaItem, Modal, Toast, Radio, DatePickerView, ActivityIndicator, Tabs, Checkbox, Badge, Icon, NavBar, Card } from 'antd-mobile';
import { ImageViewer, Form, Button, Input, PickerView} from 'antd-mobile-v5';
import ImgCanvas from '../image-canvas/drawCanvas.jsx';
import formGoFill from '../../static/icon/formGoFill.svg';
import formGoPhoto from '../../static/icon/formGoPhoto.svg';
import noCollected from '../../static/icon/noCollected.svg';
import saveBtn from '../../static/icon/saveBtn.svg';
import create_question from '../../static/icon/create_question.svg';
import answer_question from '../../static/icon/answer_question.svg';
import answer_question_2 from '../../static/icon/answer_question_2.svg';
import close_question from '../../static/icon/close_question.svg';
import close_question_2 from '../../static/icon/close_question_2.svg';
import question_modify from '../../static/icon/question_modify.svg';
import IconAnswer from '../../static/icon/icon_answer.png';
import IconAnswerReply from '../../static/icon/icon_answer_reply.png';
import IconAnswerClosed from '../../static/icon/icon_answer_closed.png';
import moment from 'moment';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import { PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
import verify, { replaceFieldRemind, replaceFieldRule } from '../../utils/verify';
import dateUtils from '../../utils/date';
import ImagePicker from '../image-picker/index';
import Camera from '../camera';
import Video from '../video/index';
import FileComponent from '../file/index';
import tool from '../../utils/tool';
import more from '../../static/icon/more.svg';

import mExper from "./utils/operation.ts";
import OSS from "ali-oss";
import { debounce } from 'lodash';
import Utils from '../../utils/utils'
import { CheckFieldOptions, debounceCheckUnique, fieldRequired, getAllDuplicateCheckField } from './utils/checkField';
import SecondsPickerView from './SecondsPickerView';
import OCRAutofill from '../ocr-autofill/OCRAutofill';
import { makeUploadName, makeUploadOptions } from '../ocr-autofill/utils';
import { isReadOnly, JSFormLock } from './utils';
import { ExclamationCircleFill } from 'antd-mobile-icons';
import RegionSelect from '../region-select';
import { fieldRO, resolveRO } from '../../utils/ro';
const api = new ApiCore();
const RadioItem = Radio.RadioItem;
const CheckboxItem = Checkbox.CheckboxItem;
let photoId = 0;
let isFirstDesensitizate = true;
let isFirstSaveDefaultValue = true;
let isEditPhoto = false; // useState update replaced
let isOcr = false;
const matchUrlSensitive: {[key: string]: any} = {}; // 匹配敏感信息
let defaultChineseName = "不详"; // 时间组件默认值
let timerId = 0;

let annotationStyle = {
    borderColor: 'red'
}
let notAnnotationStyle = {
    borderColor: '#6287EC'
}

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: [
        '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
        '//at.alicdn.com/t/font_2857469_i2b7j58rf1.js'
    ],
});

// 校验规则之 date between
const parseDateBetweenRule = (rule?: string[])=> {
    const dateRegExp = new RegExp(/^(\d{4})-(\d{2})-(\d{2})$/);
    const dateTimeRegExp = new RegExp(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/)
    if(!Array.isArray(rule)) {
        return [undefined , undefined]
    }
    // 要填充的时间
    const fill = ['00:00:00', '23:59:59']
    // 只有日期时自动补充时间
    const pieces = rule.map((now: string, i: number)=> {
        if(dateRegExp.test(now)) {
            return `${now} ${fill[i]}`
        }
        return '';
    })
    for(const now of pieces) {
        if(!dateTimeRegExp.test(now)) {
            Toast.fail('日期格式配置错误', 2)
            return [undefined , undefined]
        }
    }

    return pieces.map((t: string)=> new Date(t))
}

function FormField(props: any, ref: any) {
    const [formInit, setFormInit] = useState<boolean>(false);
    // 操作类型
    const [operateType, setOperateType] = useState<any>("");
    // 全局值，方便计算
    const [globalValues, setGlobalValues] = useState<any>([]);
    const [basicColumns, setBasicColumns] = useState<any>([]);
    // 不详时间组件最大值、最小值
    const [maxUnknownDate, setMaxUnknownDate] = useState<any>();
    const [minUnknownDate, setMinUnknownDate] = useState<any>();
    const [autoValues, setAutoValues] = useState<any>([]);
    const [iframeUrl, setIframeUrl] = useState("");
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //当前表单的id
    const [formId, setFormId] = useState<any>();
    //设置表单域
    const [fieldList, setFieldList] = useState<any>([]);

    //是否显示填写表单的模态框
    const [showModal, setShowModal] = useState(false);

    //点击选中的表单元素
    const [selectField, setSelectField] = useState<any>();

    //选中的填写表单的备注类型
    const [selectNoteType, setSelectNoteType] = useState<any>();

    //当前tabs的索引
    const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);

    //当前表单的值
    const [currentValue, setCurrentValue] = useState<any>();

    //上次选择的值
    const [lastTimeValue, setLastTimeValue] = useState<any>(null);

    //当前表单的值
    const [isOnClickSelect, setIsOnClickSelect] = useState<boolean>(false);

    //当前表单已存的value
    const [savedValue, setSavedValue] = useState<any>([]);

    //当前表单的info
    const [currentFormInfo, setCurrentFormInfo] = useState<any>([]);

    //当前整个表单的dataAction
    const [dataAction, setDataAction] = useState<any>([]);
    //当前整个表单的原始dataAction 
    const [originalDataAction, setOriginalDataAction] = useState<any>([]);

    //整个表单的formAction
    const [formActions, setFormActions] = useState<any>([]);

    //表单是否可读状态
    const [formIsRead, setFormIsRead] = useState(true);

    //注释类型
    const [annotationType, setAnnotationType] = useState<any>([]);

    //当前选中的注解值
    const [annotationValue, setAnnotationValue] = useState<any>();

    //当前选中的备注值
    const [remarkValue, setRemarkValue] = useState<any>();

    //检查类型
    const [questionType, setQuestionType] = useState<any>([]);

    //当前选择的检查类型
    const [selectQuestionType, setSelectQuestionType] = useState<any>();

    //检查说明
    const [questionInf, setQuestionInf] = useState<any>();

    //当前选中的表单的数据质疑列表
    const [selectFieldQuestion, setSelectFieldQuestion] = useState<any>([]);

    //当前选中的question item的id
    const [selectQuestionItemId, setSelectQuestionItemId] = useState<any>();

    //回复质疑的操作类型
    const [answerQuestionType, setAnswerQuestionType] = useState<any>([]);

    //当前选中的质疑操作类型
    const [currentQuestionType, setCurrentQuestionType] = useState<any>();

    //补充说明
    const [supplementInf, setSupplementInf] = useState<any>();
    //修改值
    const [questionModifyValue, setQuestionModifyValue] = useState<any>();
    //数据稽查
    const [traceList, setTraceList] = useState<any>([]);
    //图片
    const [photos, setPhotos] = useState<any>([]);
    //上传成功的图片list
    const [uploadedPhotoList, setUploadedPhotoList] = useState<any>([]);
    //图片预览是否显示
    const [photoVisible, setPhotoVisible] = useState(false);
    //当前预览图片的index
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState<any>(0);
    //是否需要重新上传图片后载提交
    const [ifReUpload, setIfReUpload] = useState<boolean>(false);
    //图片上传状态
    const [uploadState, setUploadState] = useState<boolean>(false);
    //input
    const [inputValue, setInputValue] = useState<any>('');
    // input-select
    const [otherValue, setOtherValue] = useState<any>();
    const [selectValue, setSelectValue] = useState<any>('');
    const [inputMinValue, setInputMinValue] = useState<any>('');
    const [inputMaxValue, setInputMaxValue] = useState<any>('');

    //输入error
    const [inputError, setInputError] = useState<boolean>(false);
    // 设置当前显示的图片示例
    const [currPhotoRemark, setCurrPhotoRemark] = useState<string>('');
    // 设置图片是否可以脱敏
    const [infoPhotos, setInfoPhotos] = useState<any>([]);
    // 是否可以脱敏
    const [ifEditPhoto, setEditPhoto] = useState<any>();
    // 
    const [sensitiveData, setSensitiveData] = useState<any>([]);

    const [formCode] = useState<any>(props.formCode);

    const [version] = useState<any>(props.version);
    // 是否需要OCR识别显示
    const [needOcrRecongize, setOcrRecongize] = useState<boolean>(false);
    // 保存上传后需要提交的数据
    const [formUpdateParams, setFormUpdateParams] = useState<any>({});

    // 显隐按钮文字
    const [nextText, setNextText] = useState<any>('下一题');
    // 必填项是否为空
    let isNullValidationIs = false;
    // 获取OSS访问令牌
    const [ossData, setOssData] = useState<any>({});
    // 视频
    const [videos, setVideos] = useState<any>([]);
    //上传成功的视频list
    const [uploadedVideoList, setUploadedVideoList] = useState<any>([]);
    // 文件
    const [filesData, setFilesData] = useState<any>([]);
    //上传成功的文件list
    const [uploadedFileList, setUploadedFileList] = useState<any>([]);

    //视频上传进度
    const [vedioProgress, setVedioProgress] = useState<any>([null]);
    //视频文件
    const [vedioFile, setVideoFile] = useState<any>(null);

    // 范围异常提醒
    const [rangeAnnotation, setRangeAnnotation] = useState<any>(null);
    // 平铺的每个表单元素
    const [flatFormItem, setFlatFormItem] = useState<any>([]);

    //当前表单访视节点信息
    const [visitInfoList, setVisitInfoList] = useState<any>([]);

    const [ duplicateCheckField, setDuplicateCheckField ] = useState<CheckFieldOptions[]>([]);

    // props.readonly 质疑展示
    const [visibleQModal, setVisibleQModal] = useState<boolean>(false);

    // 进来的项目
    const _itemData = {
        projectCode: '',
        subjectCode: ''
    };
    let itemData = sessionStorage.getItem('toPhotoEditItem');
    itemData = itemData ? JSON.parse(itemData) : _itemData;
    let mRef = useRef();
    const mPhotoRef = useRef();
    const mVideoRef = useRef();
    const mFileRef = useRef();

    // 新属性-编辑状态
    const editModel = Number(sessionStorage.editModel);
    
    useEffect(()=>{
        if(selectField && selectField.type == 'unknownDate'){
            let allMax, allMin; // 所有比较最后的最大最小值
            let maxArr = []; // 最大值和最小值数组
            let minArr = [];
            let data = selectField;
            if (selectField && selectField.validationRules && selectField.validationRules.length > 0) {
                // 数据预处理 list类型规则数组
                const listAlls =  selectField.validationRules.filter((e: any)=> e.listAllValues === 'all');
                const extraArr: any = [];
                for(const e of listAlls){
                    for(const s of globalValues){
                        const Index = (s.dataCode).indexOf(`${e.rule}#`);
                        if(Index !== -1 ){
                            let ee = JSON.parse(JSON.stringify(e));
                            ee["rule"] = s.dataCode;
                            // 检查ee是否已经在extraArr中
                            if (!(extraArr|| []).some((extra:any)=>extra.rule === ee.rule)) {
                                extraArr.push(ee);
                            }
                        }
                    }
                   
                }
                const noListAlls = selectField.validationRules.filter((e: any)=> e.listAllValues !== 'all');
                // 换算新的时间的规则
                const newValidationRules = [...noListAlls, ...extraArr];
                for (let item of newValidationRules) {
                    let max;
                    let min;
                    if (item.type === 'range') {
                        if (item.condition === 'lte') {
                            if (item.rule === '${currDate}') {
                                max = new Date();
                            } else if (item.rule === 'visitDate') {
                                if (item.visit) {
                                    let _data = visitInfoList.find((v: any) => {
                                        return v.visitName == item.visit
                                    })
                                    if (_data && _data.visitDate) {
                                        if (item.space) {
                                            let newDate = dateUtils.getNewDateFormDays(_data.visitDate, item.space, 'reduce')
                                            max = new Date(newDate);
                                        } else {
                                            max = new Date(_data.visitDate);
                                        }
                                    }
                                }
                            } else {
                                min = new Date(item.rule);
                            }
                        }
                        else if (item.condition === 'gte') {
                            if (item.rule === '${currDate}') {
                                min = new Date();
                            } else if (item.rule === 'visitDate') {
                                if (item.visit) {
                                    let _data = visitInfoList.find((v: any) => {
                                        return v.visitName == item.visit
                                    })
                                    if (_data && _data.visitDate) {
                                        if (item.space) {
                                            let newDate = dateUtils.getNewDateFormDays(_data.visitDate, item.space, 'add')

                                            min = new Date(newDate);
                                        } else {
                                            min = new Date(_data.visitDate);
                                        }
                                    }
                                }
                            } else {
                                min = new Date(item.rule);
                            }
                        }
                        else if(item.condition === 'between') {
                            if(Array.isArray(item.rule)) {
                                
                                const unknowPieces = item.rule;
                                [min, max] = unknowPieces.map((t: string)=> new Date(t))
                            }
                        }
                    } else if (item.type === 'compare') {
                       
                        let compareData;
                        if (savedValue && savedValue.length > 0) {
                            let _index = -1; // 多组时当前下标
                            if (data && data["dataCode"] && data["dataCode"].indexOf('#') >= 0) {
                                _index = data["dataCode"].split('#')[1];
                            }
                            for (let value of savedValue) {
                                if ((item.rule == value["dataCode"]) || (item.rule == value["deCode"])) {
                                    compareData = value["value"];
                                }
                                // 多组
                                if (_index != -1) {
                                    // eg -> startTime12#{index}
                                    if (item.rule && item.rule.indexOf('#') >= 0) {
                                        let rulePre = item.rule.split('#')[0];
                                        let nowRule = rulePre + '#' + _index;
                                        if (nowRule == value["dataCode"]) {
                                            compareData = value["value"];
                                        }
                                    }
                                }
                            }
                          
                      
                        }
                        // 从全局找最新的值
                        if(!compareData){
                            const arr =  (globalValues|| []).filter((s:any) => s.dataCode === item.rule)
                            if(arr?.length){
                                compareData = arr[arr.length-1].value
                            }  
                        }

                        if (compareData && item.condition === 'lte') {
                            max = new Date(compareData);
                        } else if (compareData && item.condition === 'gte') {
                            min = new Date(compareData);
                        }
                        
                    }
                    if (max) {
                       maxArr.push(max)
                    }
                    if(min){
                       minArr.push(min)
                    }
                }
              
            }

            // 大于的时间和小于的时间做比较
            if(maxArr?.length){
                allMax =  Math.min(...maxArr.map((e:any) => e.getTime()));
            }
            if(minArr?.length){
                allMin =  Math.max(...minArr.map((e:any) => e.getTime()));
            }
            
            if (allMax && allMin) {
                setMaxUnknownDate(moment(allMax).format('YYYY-MM-DD'));
                setMinUnknownDate(moment(allMin).format('YYYY-MM-DD'));
            } else if (allMax) {
                setMaxUnknownDate(moment(allMax).format('YYYY-MM-DD'));
                setMinUnknownDate(null);
            } else if (allMin) {
                setMinUnknownDate(moment(allMin).format('YYYY-MM-DD'));
                setMaxUnknownDate(null);
            } 
        }
        
    }, [selectField])
    useEffect(() => {
        // 从小程序地图跳转的链接，作特殊处理
        const { formUrl } = Utils.getUrlParams()
        if(formUrl){
            localStorage.setItem("formUrl", formUrl)
            let item = JSON.parse(localStorage.getItem("currentItem") || '{}')
            const func = fillFormBtn(item, 'miniProgram')
            func()
        }
  
        // 进入
        isFirstDesensitizate = true;
        isFirstSaveDefaultValue = true;
        
        return () => {
            //  销毁
            isFirstDesensitizate = false;
            isFirstSaveDefaultValue = false;
        }
    }, [])

    useEffect(() => {
        if ((currentValue !== undefined && isOnClickSelect) || operateType ==="clear") {
            setIsOnClickSelect(false);
            // 已提交的onUpdate()，未提交的onSave()
            if (props.fieldList.formActions && props.fieldList.formActions.length == 0) {
                onUpdate()
            } else {
                // onSave()
            }
        }
       setOperateType("")

    }, [currentValue, operateType])

    useEffect(() => {
        if (props.formId) {
            setFormId(props.formId);
        }
    }, [props])

    useEffect(() => {
       // todo暂时修改，如果当前变量为空值，则启动计算
 
        if(props.formId){
            setFormInit(true); 
        }
      
    }, [props.formId])

    useEffect(() => {
       initData(props.fieldList, false)
    }, [props.fieldList])

    
    useEffect(()=>{
        if(selectField && selectField.type == 'unknownDate'){
            defaultChineseName = selectField?.defaultChineseName || '不详';
            const years= generateYearOptions();
            const months = generateMonthOptions();
            if(currentValue && currentValue.length){
                const dateArr = currentValue;
                const days = generateDayOptions(dateArr[0],dateArr[1]);
                setBasicColumns([years,  months, days]);
            }
        }

    }, [minUnknownDate, maxUnknownDate, currentValue])

    const generateYearOptions =  ()=> {  
        const currentYear = new Date().getFullYear();  
        let years = [];  
        let  maxYear = maxUnknownDate? maxUnknownDate.split("-")[0] : null;
        let  minYear = minUnknownDate? minUnknownDate.split("-")[0] : null;
        for (let year = currentYear; year >= 1920; year--) {  
            if ((maxYear && year > maxYear) || (minYear && year < minYear)) {
            }else{
                years.push({ label: year.toString()+'年', value: year.toString() });  
            }
         
        }  
        // 添加“不详”选项  
        years.unshift({ label: defaultChineseName, value: defaultChineseName });  
        return years;  
    }  
    const generateMonthOptions = ()=> {  
        const months = [  
            ...Array.from({ length: 12 }, (_, index) => ({ 
                label: (index + 1).toString()+'月', 
                value: index < 9 ? `${"0"+(index + 1)}`:`${(index + 1).toString()}`
            }))  
        ];  

        let  maxYear = maxUnknownDate? maxUnknownDate.split("-")[0] : null;
        let  maxMonth = maxUnknownDate? maxUnknownDate.split("-")[1] : null;
        let  minYear = minUnknownDate? minUnknownDate.split("-")[0] : null;
        let  minMonth = minUnknownDate? minUnknownDate.split("-")[1] : null;
        const currentYear = currentValue? currentValue[0] : null;

        const arr: any = [];
        months.forEach((e,index)=>{
            if ( (maxMonth  && e.value > maxMonth && currentYear == maxYear ) || (minMonth && e.value < minMonth  && currentYear == minYear)) {
                
            }else{
                if(currentYear!== defaultChineseName){
                    arr.push(e)
                }
            }
        
        })
        // 添加“不详”选项  
        arr.unshift({ label: defaultChineseName, value: defaultChineseName });  
        return arr;  
    }  

    const generateDayOptions = (year: any, month: any) => {  

        let  maxYear = maxUnknownDate? maxUnknownDate.split("-")[0] : null;
        let  maxMonth = maxUnknownDate? maxUnknownDate.split("-")[1] : null;
        let  maxDay = maxUnknownDate? maxUnknownDate.split("-")[2] : null;
        let  minYear = minUnknownDate? minUnknownDate.split("-")[0] : null;
        let  minMonth = minUnknownDate? minUnknownDate.split("-")[1] : null;
        let  minDay = minUnknownDate? minUnknownDate.split("-")[2] : null;
        const daysInMonth = new Date(year, month, 0).getDate(); // 获取指定月份的天数  
        const days = [  
  
            ...Array.from({ length: daysInMonth }, (_, index) => ({  
                label: (index + 1).toString()+'日',  
                value: index < 9 ? `${"0"+(index + 1)}`:`${(index + 1).toString()}`
            }))  
        ];  
        const currentYear = currentValue? currentValue[0] : null;
        const currentMonth = currentValue? currentValue[1] : null;
        const arr: any = [];
        days.forEach((e,index)=>{
            if ((maxDay && e.value > maxDay && currentYear == maxYear && currentMonth == maxMonth) 
                || (minDay && e.value < minDay && currentYear == minYear && currentMonth == minMonth)) {
                
            }else{
                arr.push(e)
            }
        })

        // 添加“不详”选项  
        arr.unshift({ label: defaultChineseName, value: defaultChineseName });  
        return arr;  
    } 

    // 日期选择变化
    const handlePickerChange = (value: any)=>{
        const days = generateDayOptions(value[0],value[1]);
        setBasicColumns([basicColumns[0], basicColumns[1], days]);
        // 年月日进行联动
        if(value && (value[0]== defaultChineseName || value[1]== defaultChineseName) ){
            setCurrentValue([value[0], value[1], defaultChineseName]);
        }else{
            setCurrentValue([value[0], value[1], value[2]]);
        }
       
    }

    const toMiniUrl = ()=> {
         (window as any).wx.miniProgram.navigateTo({
            url: `/pages/map/map`,
            success: function (e: any) {
                console.log('success:', e)
            },
            fail: function (e: any) {
                console.log('fail:', e)
            }
        })
    }

    const handleUpdateData = (params: any) => {
        api.updateData(params).then(res => {
            if (res.code == '0') {
            //   Toast.success('保存成功', 1)
            getDataById()
        }
            else {
        //   Toast.fail(res.message, 1)
            }
      
        })
        setLoading(false)
    }

    const debounceUpdateData = debounce((params) => handleUpdateData(params), 1)

    const isDesensitizateProject = () => {
        if (!isFirstDesensitizate) {
            return;
        }
        isFirstDesensitizate = false;
        api.isDesensitizateProject({
            // @ts-ignore 
            projectCode: itemData.projectCode
        }).then(res => {
            if (res.code + '' == '0') {
                // 是否需要脱敏 0：否 1：是 （oss图片上传，暂时屏蔽脱敏）
                // isEditPhoto = !!(res.data && res.data.isDesensitization);
                // isOcr = !!(res.data && res.data.isOcr);

                // setEditPhoto(true); // 暂时不用，更新有问题
            } else {
                isEditPhoto = false;
                isOcr = false;
                // setEditPhoto(false);
            }
            setEditPhoto(isEditPhoto);
        })
    }


    //初始数据处理
    const initData = async(data: any, handleLock=true) => {
        if (data) {
            // !!!君实 - 表单锁定特殊处理
            if (editModel === 1 && handleLock) {
                await JSFormLock.handlefast(props.formId, data)
            }

            props.readonly != true && isDesensitizateProject(); // 请求是否脱敏状态
            tool.dealFieldList(data);
            tool.dealFieldListByValues(data);
            let fieldList = data.body || [];
            let savedValue = data.values;
            let dataAction = data.dataActions;
            let formAction = data.formActions;
            let globalValues = data.globalValues || [];
            setGlobalValues(globalValues)
            let visitInfoLists = data.visitInfoList || [];
            // ↓ 默认选中暂存
            let defaultValues: any = [];
            const flatChildren = (arr: any) => {
                for (let i = 0; i < (arr || []).length; i++) {
                    let childrenArr: any = arr[i].children;
                    if (childrenArr) {
                        flatChildren(childrenArr);
                    } else {
                        defaultValues.push(arr[i]);
                    }
                }
            }
          
            // 初始化默认选中的数据
            if (savedValue && savedValue.length == 0) {
                flatChildren(fieldList)

                if (defaultValues && defaultValues.length > 0) {
                    defaultValues.forEach((item: any) => {
                        if (item.type != 'text' && item.defaultValue && !item.value) {
                            savedValue.push({
                                ...item,
                                value: item.defaultValue
                            })
                        } else if (item.logicOperations) {
                            // 初始化后面的访视节点需要默认设置(前面填过)的值
                            item.logicOperations.forEach((lo: any) => {

                                const filledBeforeItem = globalValues.find((v: any) => {

                                    //如果配置的visit为空从当前访视的表单取值
                                    let currentVisitInfo: any = sessionStorage.getItem('currentVisitInfo') || ''
                                    if (!lo.visit && currentVisitInfo) {
                                        lo.visit = JSON.parse(currentVisitInfo).name
                                    }

                                    if ((v.dataCode == lo.dataCode) && (v.visitName == lo.visit) && (v.formCode == lo.form)) {
                                        return v;
                                    }
                                })
                                filledBeforeItem && savedValue.push(filledBeforeItem)
                            });
                        }
                    });
                }
                if (isFirstSaveDefaultValue && savedValue && savedValue.length > 0) {
                    isFirstSaveDefaultValue = false; // 防止重复多次调用
                    // 暂存
                    const params = {
                        formId: props.formId,
                        submit: false,
                        values: [...savedValue]
                    }
                    api.saveForm(params);
                }

            } else {
                let autoSavedValue: any = []
                let globalLogicValues: any = [];
                flatChildren(fieldList)
                if (defaultValues && defaultValues.length > 0) {
                    defaultValues.forEach((item: any) => {
                        if (item.logicOperations && item.type == 'hide') {
                          
                            // 初始化后面的访视节点需要默认设置(前面填过)的值
                            item.logicOperations.forEach((lo: any) => {
                                const filledBeforeItem: any = globalValues.find((v: any) => {

                                    //如果配置的visit为空从当前访视的表单取值
                                    let currentVisitInfo: any = sessionStorage.getItem('currentVisitInfo') || ''
                                    if (!lo.visit && currentVisitInfo) {
                                        lo.visit = JSON.parse(currentVisitInfo).name
                                    }

                                    if ((v.dataCode == lo.dataCode) && (v.visitName == lo.visit) && (v.formCode == lo.form)) {
                                        v.type = item.type; // 对于type='hide'数据传给后端校验
                                        return v;
                                    }
                                })

                                filledBeforeItem && autoSavedValue.push(filledBeforeItem)
                            });
                            // 用作自动计算,收集隐藏映射值，如：item里dataCode是carDisease2,但logic里dataCode对应的是carDisease
                            item.logicOperations.forEach((lo: any) => {
                                let targetItem: any = null;
                                globalValues.some((v: any) => {
                                    if ((v.dataCode == lo.dataCode) && (v.visitName == lo.visit) && (v.formCode == lo.form)) {
                                        targetItem = {
                                            ...v,
                                            dataCode: item.dataCode,
                                            type: item.type // 对于type='hide'数据传给后端校验
                                        };
                                        return true;
                                    }
                                });
                                targetItem && globalLogicValues.push(targetItem);
                            });
                         
                        }
                    });
                }
                // 当前表单隐藏值替换更新
                savedValue = savedValue.map((item: any) => {
                   const sameItem = globalLogicValues.find((val: any) => (val.dataCode == item.dataCode));
                   if (sameItem) {
                    return {
                        ...item,
                        value: sameItem.value,
                        type: sameItem.type
                    }
                   } else {
                    return item;
                   }
                })
                // 去重，去除savedValue已有的值
                globalLogicValues = globalLogicValues.filter((item: any) => {
                   const hasExist = savedValue.some((val: any) => (val.dataCode == item.dataCode));
                   return !hasExist;
                })
                if (globalLogicValues?.length > 0) {
                    savedValue = savedValue.concat(globalLogicValues);
                }
                if (isFirstSaveDefaultValue && autoSavedValue && autoSavedValue.length > 0) {
                    isFirstSaveDefaultValue = false; // 防止重复多次调用
                    const params = {
                        formId: props.formId,
                        submit: false,
                        values: [...autoSavedValue]
                    }
                    api.saveForm(params);
                }

            }
            setFlatFormItem(defaultValues);
            // ↑ 默认选中暂存

            //dataAction
            if (dataAction && dataAction.length > 0) {
                let tabs = [];
                for (let item of dataAction) {
                    if (item == 'DataActionRead') {
                        tabs.push({
                            label: '数据值',
                            key: 'DataActionRead',
                        })
                    }
                    else if (item == 'DataActionRemarkRead') {
                        tabs.push({
                            label: '备注',
                            key: 'DataActionRemarkRead',
                        })
                    }
                    else if (item == 'DataActionAnnotationRead') {
                        tabs.push({
                            label: '注释',
                            key: 'DataActionAnnotationRead',
                        })
                    }
                    else if (item == 'DataActionInput') {
                        tabs.push({
                            label: '录入',
                            key: 'DataActionInput',
                        })
                    }
                    else if (item == 'DataActionUpdate') {
                        tabs.push({
                            label: '修改',
                            key: 'DataActionUpdate',
                        })
                    }
                    else if (item == 'DataActionRemark') {
                        tabs.push({
                            label: '备注',
                            key: 'DataActionRemark',
                        })
                    }
                    else if (item == 'DataActionAnnotation') {
                        tabs.push({
                            label: '注释',
                            key: 'DataActionAnnotation',
                        })
                    }
                    else if (item == 'DataActionQuestion') {
                        tabs.push({
                            label: '质疑',
                            key: 'DataActionQuestion',
                        })
                    }
                    else if (item == 'DataActionAnswer') {
                        tabs.push({
                            label: '回复质疑',
                            key: 'DataActionAnswer',
                        })
                    }
                    else if (item == 'DataActionTrace') {
                        tabs.push({
                            label: '痕迹稽查',
                            key: 'DataActionTrace',
                        })
                    }
                }
                //设置tabs
                setDataAction(tabs);
                setOriginalDataAction(tabs)
                //默认选中第一个tab
                setSelectNoteType(dataAction[currentTabIndex]);
                //根据选中的第一个值进行处理
                switch (dataAction[currentTabIndex]) {
                    //注释
                    case 'DataActionAnnotation':
                        setLoading(true);
                        const res = await api.getAnnotationType()
                        if (res.code == '0') {
                            setAnnotationType(res.data)
                        }
                        setLoading(false);
                        break;
                    //注释只读
                    case 'DataActionAnnotationRead':
                        setLoading(true);
                        const res1 = await api.getAnnotationType()
                        if (res1.code == '0') {
                            setAnnotationType(res1.data)
                        }
                        setLoading(false);
                        break;
                    //创建/关闭质疑
                    case 'DataActionQuestion':
                        setLoading(true);
                        const res3 = await api.getQuestionTypes()
                        if (res3.code == '0') {
                            if (res3.data && res3.data.length > 0) {
                                let filterArr = [];
                                for (let item of res3.data) {
                                    filterArr.push(
                                        {
                                            label: item.text,
                                            value: item.key
                                        }
                                    )
                                }
                                setQuestionType(filterArr)
                            }
                        }
                        setLoading(false);
                        break;
                    //回复质疑
                    case 'DataActionAnswer':
                        let answerType = [
                            {
                                label: '保留原值',
                                value: 'Retain'
                            },
                        ]

                        // 君实表单
                        if (props.editModel === 1) {
                            if (!resolveRO(selectField)) {
                                answerType.push(
                                    {
                                        label: '修改原值',
                                        value: 'Update'
                                    },
                                    {
                                        label: '置空原值',
                                        value: 'Empty'
                                    }
                                )
                            }
                        }

                        //回复的类型
                        setAnswerQuestionType(answerType);
                        if (!currentQuestionType) {
                            setCurrentQuestionType(answerType[0].value);
                        }
                        break;
                    //数据稽查
                    case 'DataActionTrace':
                        let params = {
                            formId: formId,
                            dataCode: selectField.dataCode,
                        }
                        setLoading(true);
                        const res4 = await api.getTrance(params)
                        if (res4.code == '0') {
                            setTraceList(res4.data)
                        }
                        else {
                            setTraceList([])
                        }
                        setLoading(false);
                        break;
                    default:
                        break;
                }
            }

            //角色code为ReadOnly 表单只读
            if ((sessionStorage.forceReadonly && props.fieldList?.freezeState === 'Complete' && props.fieldList?.subjectState === 'Withdraw') || isReadOnly(props.formCode)) {
                setFormIsRead(false);
            }else{
                     //判断表单是否处于可读状态
                if (formAction && formAction.length > 0) {
                    if (formAction.includes('FormActionRead')) {
                        setFormIsRead(false);
                    }
                }

                if (dataAction && dataAction.length == 0) {
                    setFormIsRead(false);
                }

            }
            setFieldList(fieldList);
            setSavedValue(savedValue);
            setFormActions(formAction);
            
            logicOperation(fieldList, savedValue, data);
           
        
            setVisitInfoList(visitInfoLists)

            setDuplicateCheckField(getAllDuplicateCheckField(fieldList))

        }
    }

    //从globalValues里面自动填充list值
    const fillFeildVlaue = (data: any, globalValues: any, values: any) => {
        let returnData: any = [];
        (data || []).forEach((item: any) => {
            if (item.children) {
                let _data1 = fillFeildVlaue(item.children, globalValues, values)
                returnData = [...returnData, ..._data1]
            } else {
                if (item.logicOperations) {
                    let hasData = values.find((a: any) => a.dataCode == item.dataCode)
                    if (hasData) {
                        return
                    }
                    let fillValues: any = []
                    item.logicOperations.forEach((v: any) => {
                        if (v.type == "globalValue" && globalValues && globalValues.length > 0) {
                            let arr = globalValues.filter((c: any) => {
                                if (c.visitName == v.visit && c.formCode == v.form) {
                                    return !c.dataCode.indexOf(v.dataCode) 
                                    // v在c的位置，如果找到则返回第一个匹配的索引值，如果找不到则返回 -1，然后结果取反，如果 indexOf() 找到了匹配的索引值，那么取反后的结果就是 false，表示匹配成功；如果 indexOf() 返回 -1，取反后的结果就是 true，表示匹配失败。
                                }
                            })
                            if (arr.length > 0) {
                                let sValues: any = []
                                arr.forEach((c: any) => {
                                    if (c.dataCode.indexOf('#') !== -1) {
                                        let _itemValue = {
                                            dataCode: `${item.deCode}#${c.dataCode.split('#')[1]}`,
                                            deCode: item.deCode,
                                            type: item.type,
                                            value: c.value
                                        }
                                        let Index = values.findIndex((_item: any) => _item.dataCode == _itemValue.dataCode)
                                        //判断字段内容是不是已填写，已经填写但是值不是最新，需更新
                                        if (Index == -1) {
                                            sValues.push(_itemValue)
                                        }
                                    }
                                });

                                sValues.forEach((element: any) => {
                                    let Index = savedValue.findIndex((_item: any) => _item.dataCode == element.dataCode)
                                   if (Index == -1 ) {
                                       fillValues.push(element)
                                    }
                                });
                              
                            }
                        }
                    })
                    if (fillValues.length > 0) {
                        returnData = [...returnData, ...fillValues]
                    }
                }
            }

        });
        return returnData
    }

    useEffect(() => {
        if (props.fieldList) {
            let autoValues = fillFeildVlaue(props.fieldList.body, props.fieldList.globalValues, props.fieldList.values)
            if (autoValues.length > 0 ) {
                let params = {
                    formId: formId,
                    submit: false,
                    values: autoValues
                }
                api.saveForm(params).then(res => {
                    if (res.code == '0') {
                        props.updateData();
                    }
                })
            }
        }
    }, [props])
    

    useEffect(() => {
        return () => {
            timerId = 0
        };
    }, []);


    const logicOperation =  (fieldList: any, savedValue: any, propsData: any) => {
       // || !savedValue || savedValue.length == 0
        if (!fieldList || fieldList.length == 0 ) {
            return;
        }
        for (let field of fieldList) {
            if (field.logicOperations && field.logicOperations.length > 0) {
                for (let logicOperation of field.logicOperations) {
                    // 可以拓展为表单初始化，年龄第一次取不计算，从后端取值
                    if (formInit && logicOperation.type == 'toAge') {
                        setFormInit(false)
                        continue
                    }
                   const reCorrectValues = mExper.handleLogicOperations(logicOperation, savedValue, field,  propsData);
                    // 自动计算的，但是手动修改后，仍然要保持自动计算的值的 
                   if (reCorrectValues == 'null' || !reCorrectValues) continue
                
                   // 年龄计算和常规计算提交后更改会做处理
                   if ((logicOperation.type == 'expr' || logicOperation.type == 'toAge') && reCorrectValues && Array.isArray(reCorrectValues) && reCorrectValues.length > 0) {
                        // let params: any = {
                        //     formId: formId,
                        //     submit: false,
                        //     values: reCorrectValues
                        // }
                        // 如果是提交状态才执行保存
                        // if(selectNoteType === 'DataActionInput'){
                        //     api.saveForm(params);
                        // }
                        // 更新
                        console.log(reCorrectValues)
                        if (formId) {
                            reCorrectValues.forEach( async(item: any) => {
                               let params = {
                                    formId: formId,
                                    dataCode: item.dataCode,
                                    deCode: item.deCode,
                                    value: item.value
                                };
                                setLoading(true);
                                // await debounceUpdateData(params)
                     
                                handleUpdateData(params)
                               
                                
                            })
                        }
                   }
                }
            }
            if (field["children"]) {
                logicOperation(field["children"], savedValue, propsData);
            }
        }
    }

    //根据formId更新当前表单状态
    const getDataById = () => {
        let params = {
            id: formId
        }
        api.getFormTemplateById(params).then(res => {
            if (res.code == '0' && res.data) {
                //初始化数据\
             
                initData(res.data);
            }
        })
    }

    useImperativeHandle(ref, () => ({
        // 
        initData,
        // changeVal 就是暴露给父组件的方法
        getSavedForm: () => {
            let _savedValue = savedValue;
            let _tobeSaved: any = []; // 添加的节点
            _savedValue = savedValue.map((val: any) => {
                // 添加的节点自动设置默认选中
                flatFormItem.forEach((fv: any) => {
                    if ((fv.dataCode != val.dataCode) && (fv.deCode == val.deCode) && fv.defaultValue) {
                        _tobeSaved.push({
                            ...fv,
                            value: fv.defaultValue
                        });
                    }
                });
                // 没有value时保存defaultValue
                let item = flatFormItem.find((v: any) => (v.dataCode == val.dataCode));
                if (!val.value && item && item.defaultValue) {
                    return {
                        ...val,
                        value: item.defaultValue
                    };
                } else {
                    return val;
                }
            })
            let _addTobeSaved: any = [];
            _addTobeSaved = _tobeSaved.filter((tv: any) => {
                let item = _savedValue.find((v: any) => (v.dataCode == tv.dataCode));
                return !item;
            });
            let formData = {
                formId: formId,
                submit: true,
                values: _savedValue.concat(_addTobeSaved)
            }
            return formData
        },
        // 相同大小视频处理
        dealSameVideo,
        vedioFile,
    }));

    const showPhotoRemark = (item: any) => {
        return () => {
            setCurrPhotoRemark(item["link"]);
        }
    }

    // 获取敏感信息
    const getSensitiveData = (imgUrl: any) => {
        return new Promise<void>((resolve, reject) => {
            api.GetOcrSensitiveRecord({
                imgUrl: imgUrl
            }).then(res => {
                if ((res.code + '') === '0') {
                    res.data && setSensitiveData(res.data);
                    res.data && res.data.forEach((item: any, index: any) => {
                        if (item.coordinate && (item.coordinate.length > 0)) {
                            matchUrlSensitive[item.imgId] = item.imgId;
                        }
                        resolve();
                        // @ts-ignore
                        // _imgUrl.forEach((val, index) => {
                        //     if (val.indexOf(item.imgId) >= 0) {
                        //         matchUrlSensitive[index] = item.imgId;
                        //     }
                        // })
                    })
                }
            });
        })
    }
    // 设置时间默认值
    const handleSetDateValue = (item: any) => {
        let already = false;
        if (item.validationRules && item.validationRules.length > 0) {
            for (let itemRule of item.validationRules) {
                if (itemRule.type === 'range') {
                    if (itemRule.condition === 'lte') {
                        already = true;
                        if (itemRule.rule === '${currDate}') {
                            setCurrentValue(new Date())
                        } else {
                            setCurrentValue(new Date(itemRule.rule))
                        }
                    } else if (itemRule.condition === 'gte') {
                        if (itemRule.rule === 'visitDate') {
                            let _activeTime = null

                            if (itemRule.visit) {
                                let _data: any = visitInfoList.find((v: any) => {
                                    return v.visitName == itemRule.visit
                                })
                                if (_data && _data.visitDate) {
                                    if (itemRule.space) {
                                        let newDate = dateUtils.getNewDateFormDays(_data.visitDate, itemRule.space, 'add')
                                        _activeTime = newDate;
                                    } else {
                                        _activeTime = _data.visitDate;
                                    }
                                }
                            }
                            already = true;
                            setCurrentValue(new Date(_activeTime))
                        }
                    } else if(itemRule.condition === 'between') {
                        const [_, bMax] = parseDateBetweenRule(itemRule.rule)
                        already = true;
                        setCurrentValue(bMax)
                    }
                }
            }
        }

        if(!already) {
            if (item.dateDefaultValue) {
                setCurrentValue(item.dateDefaultValue)
            } else {
                setCurrentValue(moment().format(item.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'))
            }
        }
    }

    //点击表单进行填写表单
    const fillFormBtn = (item: any, origin?: any) => {
        
        return () => {
            if (props.readonly || !formIsRead) {
                Toast.fail('当前表单为可读状态', 1)
                return
            }

            // !!!君时君时 表单锁定
            let index = 0
            if (editModel === 1) {
                if (item.ro) {
                    if (Array.isArray(item.ro.fields)) {
                        const [fields] = item.ro.fields
                        if (fields.includes(item.dataCode)) {
                            index = 1
                        } else {
                            index = 0
                        }
                    }
                }
            }

            //设置当前选中的action类型
            setSelectNoteType(dataAction[index]?.key)
            //设置tab索引
            setCurrentTabIndex(index);
            //设置弹框是否显示
            setShowModal(true)
            //设置当前选中的表单
            setSelectField(item);
            //清除输入error
            setInputError(false);
            //当前选中表单已存的value
            let currentItem;
            if(origin && item.type=='map'){
                // setSavedValue(JSON.parse(localStorage.getItem("savedValue") || "[]"))
                const storeSavedValue =  JSON.parse(localStorage.getItem("savedValue") || "[]")
                if(storeSavedValue){
                    currentItem = storeSavedValue.find((i: any) => {
                        return i.dataCode == item.dataCode
                    });
                }
                
            }else{
                
                currentItem = savedValue.find((i: any) => {
                    return i.dataCode == item.dataCode
                });
                // 存储当前操作的item
                if(item.type == 'map'){
                    localStorage.setItem("currentItem", JSON.stringify(item))
                    localStorage.setItem("savedValue", JSON.stringify(savedValue))
                }
            }
            
            // 如果是地图选择成功后跳转而来，进行当前的currentItem赋值
            const { location, formUrl } = Utils.getUrlParams()
            if(origin  && item.type=='map' && formUrl){
                if(!currentItem){
                    currentItem =  JSON.parse(localStorage.getItem("currentItem")|| '{}')
                }
                currentItem.value = location
            }
            // ↓ 初始进入再监测remind eg: (身高 -> 体重 -> 再改身高 -> 再进来时)
            if(item.remind || item.reminds) {
                if(item.remind) {
                    replaceFieldRemind(item.remind, savedValue)
                }
                if (['input', 'number', 'decimal'].includes(item.type)) {
                    if(currentItem && currentItem.value) {
                        setRangeAnnotation(
                            verify.checkValueAnnotation(
                                currentItem.value,
                                item,
                                props.formCenterCode,
                                savedValue
                            )
                        )
                    }
                }
            }

            // ↑
            if (currentItem) {
                //当类型为photo时设置图片地址
                if (['ocr-autofill', 'photo', 'photo-oss', 'camera'].includes(item.type)) {
                    if (currentItem.value) {
                        let filterArr: any = [];
                        let _imgUrl: any = [];
                        for (let photoItem of currentItem.value) {
                            filterArr.push(
                                {
                                    url: photoItem
                                }
                            )
                            _imgUrl.push(photoItem);
                        }
                        let suffixPhotos = changedPhoto(filterArr);
                        setPhotos(suffixPhotos);
                        // 获取敏感信息为空时不做处理，所以在这里先初始化
                        setInfoPhotos([])
                        //设置已经保存的图片
                        setUploadedPhotoList(currentItem.value);
                        //设置当前值
                        setCurrentValue(currentItem.value)
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                        // 获取敏感信息
                        getSensitiveData(_imgUrl).then(() => {
                            setInfoPhotos(getInfoTipPhoto(suffixPhotos));
                        });
                    }
                    else {
                        setCurrentValue(null);
                        setPhotos([]);
                        setInfoPhotos([]);
                        setUploadedPhotoList([]);
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                }
                //当类型为video时设置视频地址
                else if (item.type === 'video') {
                    if (currentItem.value) {
                        let filterArr: any = [];
                        let _videoUrl: any = [];
                        for (let videoItem of currentItem.value) {
                            filterArr.push(
                                {
                                    url: videoItem
                                }
                            )
                            _videoUrl.push(videoItem);
                        }
                        let suffixVideos = changedPhoto(filterArr);
                        setVideos(suffixVideos);
                        //设置已经保存的视频
                        setUploadedVideoList(currentItem.value);
                        //设置当前值
                        setCurrentValue(currentItem.value)
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                    }
                    else {
                        setCurrentValue(null);
                        setVideos([]);
                        setUploadedVideoList([]);
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                    }
                }
                //当类型为video时设置文件地址
                else if (item.type === 'file') {
                    if (currentItem.value) {
                        let filterArr: any = [];
                        let _fileUrl: any = [];
                        for (let fileItem of currentItem.value) {
                            filterArr.push(
                                {
                                    url: fileItem
                                }
                            )
                            _fileUrl.push(fileItem);
                        }
                        let suffixFiles = changedPhoto(filterArr);
                        setFilesData(suffixFiles);
                        //设置已经保存的文件
                        setUploadedFileList(currentItem.value);
                        //设置当前值
                        setCurrentValue(currentItem.value)
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                    }
                    else {
                        setCurrentValue(null);
                        setFilesData([]);
                        setUploadedFileList([]);
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                    }
                }
                else if (item.type === 'checkbox') {
                    if (currentItem.value) {
                        if (item.other) {
                            if (currentItem.value.indexOf(item.other.key) !== -1) {
                                setOtherValue(currentItem.value[currentItem.value.length - 1]);
                                let filterCurrentValue = [];
                                for (let i = 0; i < currentItem.value.length - 1; i++) {
                                    filterCurrentValue.push(currentItem.value[i])
                                }
                                setCurrentValue([...filterCurrentValue])
                            }
                            else {
                                setOtherValue('');
                                setCurrentValue([...currentItem.value])
                            }
                        }
                        else {
                            // 设置当前值
                            setCurrentValue([...currentItem.value])
                        }
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                    else {
                        setCurrentValue(Array(Object.keys(item.optional).length).fill(''));
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                }
                else if (item.type === 'input-select') {
                    // 兼容层
                    const old = compatibleInputSelectValue(item, currentItem.value)
                    
                    setInputMinValue(old.min)
                    setInputMaxValue(old.max)
                    setSelectValue(old.radio)
                    setOtherValue(old.other)
                    //设置注解信息
                    setAnnotationValue(currentItem.annotation)
                    //设置备注信息
                    setRemarkValue(currentItem.remark)
                    //设置已存在的质疑
                    setSelectFieldQuestion(currentItem.questions)
                }
                else if (item.type === 'date' || item.type === 'datetime' ) {
                    if (currentItem.value) {
                        //设置当前值
                        setCurrentValue(currentItem.value)
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                    else {
                        //设置注解信息
                        handleSetDateValue(item)
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                }else if(item.type === 'unknownDate'){
                    // 根据年月来实时计算日的范围
                    if(currentItem.value){  
                        const dateArr = currentItem.value.split("-");
                        setCurrentValue([dateArr[0],dateArr[1],dateArr[2]])
                    }else{       
                        const defaultName = item.defaultChineseName || '不详';       
                        setCurrentValue([defaultName, defaultName, defaultName])
                    }
                    
                    //设置注解信息
                    setAnnotationValue(currentItem.annotation)
                    //设置备注信息
                    setRemarkValue(currentItem.remark)
                    //设置已存在的质疑
                    setSelectFieldQuestion(currentItem.questions)
                    
                }
                else if (item.type === 'select') {
                    if (currentItem.value) {
                        if (item.other) {
                            if (item.optional[currentItem.value]) {
                                //设置当前值
                                setCurrentValue(currentItem.value);
                                //设置其他值
                                setOtherValue(null);
                            }
                            else {
                                //设置当前值
                                setCurrentValue(item.other.key);
                                //设置其他值
                                setOtherValue(currentItem.value)
                            }
                        }
                        else {
                            //设置当前值
                            setCurrentValue(currentItem.value)
                            //设置其他值
                            setOtherValue(null);
                        }
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                    else {
                        setCurrentValue(item.defaultValue)
                        setOtherValue(null);
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                }else if(['number', 'decimal'].includes(item.type)){
                    if (currentItem.value) {
                        // 格式化数据
                        const formatValue = verify.checkValue(currentItem.value, item)
                        setCurrentValue(formatValue);
                    }
                    else {
                        setCurrentValue(null);
                    }
                    setAnnotationValue(currentItem.annotation)
                    //设置备注信息
                    setRemarkValue(currentItem.remark)
                    //设置已存在的质疑
                    setSelectFieldQuestion(currentItem.questions)
                }
                else {
                    if (currentItem.value) {
                        //设置当前值
                        setCurrentValue(currentItem.value)
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                    else {
                        setCurrentValue(null);
                        //设置注解信息
                        setAnnotationValue(currentItem.annotation)
                        //设置备注信息
                        setRemarkValue(currentItem.remark)
                        //设置已存在的质疑
                        setSelectFieldQuestion(currentItem.questions)
                    }
                }
            }
            else {
                
                if (item.type === 'select') {
                    setCurrentValue(item.defaultValue)
                }
                else if (item.type === 'date' || item.type === 'datetime') {
                    handleSetDateValue(item)
                }
                else if (item.type === 'checkbox') {
                    setCurrentValue(Array(Object.keys(item.optional).length).fill(''));
                }else if(item.type === 'unknownDate'){
                    const defaultName = item.defaultChineseName || '不详';
                    setCurrentValue(`${defaultName}-${defaultName}-${defaultName}`);
                }
                else {
                    setCurrentValue(null);
                    setInputValue('');
                    setInputMinValue('');
                    setInputMaxValue('');
                    setSelectValue('');
                    setOtherValue('');
                    setPhotos([]);
                    setInfoPhotos([]);
                    setUploadedPhotoList([]);
                }
                // 重置备注
                setRemarkValue(null)
                setSelectFieldQuestion(null)
                //重置注释
                setAnnotationValue(null)
            }
            //重置质疑相关数据
            setSelectQuestionType(null);
            setQuestionInf(null);
        }
    }

    //当选择的tab发生变化
    const onChangeTab = (tab: any, index: number) => {

        // !!! 君实表单锁定需求，因不对动态变更标签数量，特在此做拦截
        let isRO = false

        if (editModel === 1) {
            // 当前操作的字段非禁用状态
            if (selectField.ro) {
                if (resolveRO(selectField)) {
                    isRO = true
                }
                // if (Array.isArray(selectField.ro.fields)) {
                //     const [fields] = selectField.ro.fields
                //     if (!fields.includes(selectField.dataCode)) {
                //         isRO = true
                //     }
                // }
            }

            if (isRO) {
                let times = 0
                for(const t of dataAction) {
                    if (['DataActionRead', 'DataActionUpdate'].includes(t.key)) {
                        times ++
                    }
                }
                if (times === 2 && tab.key === 'DataActionUpdate') {
                    return
                }
            }
        }

        setCurrentTabIndex(index);
        let type = tab.key
        setSelectNoteType(type);
        switch (type) {
            //注释
            case 'DataActionAnnotation':
                setLoading(true);
                api.getAnnotationType().then(res => {
                    if (res.code == '0') {
                        setAnnotationType(res.data)
                    }
                    setLoading(false);
                })
                break;
            //注释只读
            case 'DataActionAnnotationRead':
                setLoading(true);
                api.getAnnotationType().then(res => {
                    if (res.code == '0') {
                        setAnnotationType(res.data)
                    }
                    setLoading(false);
                })
                break;
            //创建/关闭质疑
            case 'DataActionQuestion':
                setLoading(true);
                api.getQuestionTypes().then(res => {
                    if (res.code == '0') {
                        if (res.data && res.data.length > 0) {
                            let filterArr = [];
                            for (let item of res.data) {
                                filterArr.push(
                                    {
                                        label: item.text,
                                        value: item.key
                                    }
                                )
                            }
                            setQuestionType(filterArr)
                        }
                    }
                    setLoading(false);
                })
                break;
            //回复质疑
            case 'DataActionAnswer':
                let answerType = [
                    {
                        label: '保留原值',
                        value: 'Retain'
                    },
                ]

                if (!isRO) {
                    answerType.push({
                        label: '修改原值',
                        value: 'Update'
                    },
                    {
                        label: '置空原值',
                        value: 'Empty'
                    })
                }

                //回复的类型
                setAnswerQuestionType(answerType);
                setCurrentQuestionType(answerType[0].value);
                break;
            //数据稽查
            case 'DataActionTrace':
                let params = {
                    formId: formId,
                    dataCode: selectField.dataCode,
                }
                setLoading(true);
                api.getTrance(params).then(res => {
                    if (res.code == '0') {
                        setTraceList(res.data)
                    }
                    else {
                        setTraceList([])
                    }
                    setLoading(false);
                })
                break;
            default:
                break;
        }
    }

    //当关闭模态框
    const onCloseModal = () => {
        setShowModal(false);
        setSelectField(null);
        setCurrentValue(null);
        setLastTimeValue(null);
    }

    //验证是否为空
    const validationIsNull = (item: any) => {
        //检查是否必须选项
        if (item.validationRules && item.validationRules.length > 0 && props.readonly != true) {
            // let isNotNull = false;
            for (let rule of item.validationRules) {
                if ((rule.condition === 'ne' && rule.rule === 'null') || fieldRequired(rule.type, rule.condition, rule.rule)) {
                    return (
                        <span className="necessary">*</span>
                    )
                }
                else {
                    return null
                }
            }
        }
    }

    //动态显示已经保存的值---html渲染层
    const showSavedValue = (item: any) => {
        let currentItem = savedValue.find((i: any) => {
            return i.dataCode === item.dataCode
        });
        let fieldListItem = fieldList.find((f: any) => {
            return f.dataCode === item.dataCode
        });


        if (currentItem) {
            if (item.type === 'select') {
                if (currentItem.value) {
                    if (item.optional[currentItem.value]) {
                        return item.optional[currentItem.value]
                    }
                    else if (item.other) {
                        if (item.other.type === 'input') {
                            return currentItem.value;
                        }
                        else if (item.other.type === 'date') {
                            return moment(currentItem.value).format('YYYY-MM-DD')
                        } else if (item.other.type === 'datetime') {
                            return moment(currentItem.value).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                    else {
                        return null;
                    }
                } else if (item.defaultValue) {
                    // 默认值设置
                    return item.optional[item.defaultValue]
                }
            }
            else if (item.type === 'date') {
                if (currentItem.value) {
                    return moment(currentItem.value).format('YYYY-MM-DD')
                } else if (item.defaultValue) {
                    return moment(item.defaultValue).format('YYYY-MM-DD')
                }
            }
            else if (item.type === 'datetime') {
                if (currentItem.value) {
                    return moment(currentItem.value).format('YYYY-MM-DD HH:mm:ss')
                } else if (item.defaultValue) {
                    return moment(item.defaultValue).format('YYYY-MM-DD HH:mm:ss')
                }

            }else if(item.type === 'unknownDate'){
                if (currentItem.value) {
                    // const dateArr = currentItem.value.split('-');
                    // const arr1 = dateArr[1]<10 ? '0' + dateArr[1]:dateArr[1];
                    // const arr2 = dateArr[2]<10 ? '0' + dateArr[2]:dateArr[2];
                    // return `${dateArr[0]}-${dateArr[1]}-${dateArr[2]}`
                    return  currentItem.value
                }
            }
            else if (item.type === 'checkbox') {
                if (currentItem.value) {
                    let filterArr = [];
                    for (let i of currentItem.value) {
                        if (i) {
                            if (item.other) {
                                if (i !== item.other.key) {
                                    if (item.optional[i]) {
                                        filterArr.push(item.optional[i]);
                                    }
                                }
                            }
                            else {
                                if (item.optional[i]) {
                                    filterArr.push(item.optional[i]);
                                }
                            }
                        }
                    }
                    if (item.other) {
                        if (currentItem.value.indexOf(item.other.key) !== -1) {
                            filterArr.push(currentItem.value[currentItem.value.length - 1])
                        }
                    }
                    return filterArr.join(',')
                }
            }
            else if (['photo', 'photo-oss', 'camera', 'ocr-autofill'].includes(item.type)) {
                if (currentItem.value && currentItem.value.length > 0) {
                    return props.readonly ? '' : '图片已上传，点击查看'
                }
                else {
                    return ''
                }
            }
            else if (item.type === 'video') {
                if (currentItem.value && currentItem.value.length > 0) {
                    return props.readonly ? '' : '视频已上传，点击查看'
                }
                else {
                    return ''
                }
            }
            else if (item.type === 'file') {
                if (currentItem.value && currentItem.value.length > 0) {
                    return props.readonly ? '文件已上传' : '文件已上传，点击查看'
                }
                else {
                    return ''
                }
            }
            else if (item.type === 'input-select') {
                if (!currentItem.value ) {
                    return ''
                }
               
                const transform = (key: string, radio: string, other: string, pieces: string[])=> {
                    const part = pieces.join('~')
                    // 当前选择的值是其他时
                    if(key === radio) {
                        if(type === 'input') {
                            return `${part} ${other}`
                        }
                        if(type === 'date') {
                            return `${part} ${moment(other).format('YYYY-MM-DD')}`
                        }
                    }
                    return `${part} ${item.optional[radio] ?? ''}`
                }

                const { min, max, radio, other } = compatibleInputSelectValue(item, currentItem.value)

                if(!item.other) {
                    if(item.inputType === 'inputrange') {
                        return transform('', radio, other, [min, max])
                    }
                    return transform('', radio, other, [min])
                }

                const { type, key } = item.other;
                
                // 范围类型时
                if(item.inputType === 'inputrange') {
                    return transform(key, radio, other, [min, max])
                }
                return transform(key, radio, other, [min])
            }else if(item.type === 'number' || item.type === 'decimal'){
                if (currentItem.value) {
                    // 展示就不格式化数据，格式化到输入框
                    //  const formatValue = verify.checkValue(currentItem.value, item)
                    //  return formatValue
                     return currentItem.value
                 }
            }
            else {
                if (currentItem.value === 0 || currentItem.value === '0' || currentItem.value) {
                    return item.unit ? `${currentItem.value}${item.unit}` : currentItem.value
                }
            }
        }
        else {
            if (item.type === 'select') {
                if (item.defaultValue) {
                    let _savedValues = savedValue
                    let defaultItem = {
                        dataCode: item.dataCode,
                        deCode: item.deCode,
                        value: item.defaultValue

                    }
                    _savedValues.push(defaultItem)
                    setSavedValue(_savedValues)

                    return item.optional[item.defaultValue]
                }
            }
            else {
                return null;
            }
        }
    }

    //select的点击事件
    const onClickSelect = (value: any) => {

        return () => {
            // setLastTimeValue(currentValue);
            setIsOnClickSelect(true);
            setCurrentValue(value);
            setTimeout(() => {
                setLastTimeValue(value);
            }, 1000);
        }
    }

    //checkbox的点击事件
    const onClickCheckbox = (value: any) => {
        return () => {
            let filterArr = currentValue;
            if (filterArr) {
                let i = filterArr.indexOf(value);
                if (i !== -1) {
                    filterArr.splice(i, 1, '');
                }
                else {
                    for (let i = 0; i < Object.keys(selectField.optional).length; i++) {
                        if (Object.keys(selectField.optional)[i] === value) {
                            // filterArr.splice(i, 1, value)
                            filterArr.push(value)
                        }
                    }
                }
            }

            if (selectField.validationRules) {
                selectField.validationRules.forEach((item: { type: string; condition: string; rule: any; }, index: any) => {
                    if (item.type === 'logic') {
                        if (item.condition === 'mutex') {
                            //当前的value在rule数组中的index
                            let arrIndex: any;
                            item.rule.forEach((ruleItem: string | any[], ruleItemIndex: any) => {
                                if (ruleItem.indexOf(value) !== -1) {
                                    arrIndex = ruleItemIndex;
                                }
                            })
                            if (arrIndex !== undefined) {
                                item.rule.forEach((ruleItem: any[], ruleItemIndex: any) => {
                                    if (ruleItemIndex !== arrIndex) {
                                        ruleItem.forEach((key: any) => {
                                            let i = filterArr.findIndex((v: any) => v == key);
                                            if (i !== -1) {
                                                filterArr[i] = '';
                                            }
                                        })
                                    }
                                })
                            }
                        }
                    }
                })
            }
            setCurrentValue(Object.assign([], filterArr || [value]));
        }
    }

    const getNextDate = (date: any, day: any) => {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "-" + m + "-" + d;
    };

    type RangeValueType = {
        min: string;
        max: string;
        radio: string;
        other: string;
    }
    // 因input-select组件的value由数组改为对象 这里是专门处理兼容问题
    const compatibleInputSelectValue = (item: any, value: string[] | RangeValueType | null | '')=> {
        const newValue: RangeValueType = {
            min: '',
            max: '',
            radio: '',
            other: ''
        }
        if(!value) {
            return item.defaultValue ?? newValue
        }

        if(Object.keys(value).length > 0) {
            const v = value as RangeValueType
            // 强制清空其他值信息
            if(item.other) {
                if(v.radio !== item.other.key) {
                    v.other = ''
                }
            }
           
            return value as RangeValueType;
        }

        let tmp = [...(value as string[])];

        // 处理 ['1-1', '1']
        if(tmp.length === 2 && tmp[0].includes('-')) {
            tmp = [...(tmp[0].split('-')), tmp[1]]
        }

        // 字段有其他选项处理
        if(item.other) {
            const last = tmp.pop() as string
            // 最后一项数据非其他时
            if(item.optional[last]) {
                newValue.other = '';
                newValue.radio = last;
            } else {
                newValue.radio = item.other.key;
                newValue.other = last;
            }
        }
        // 设置最小值
        if(tmp.length > 0) {
            newValue.min = tmp.shift() as string
        }
        // 如果还有那必定是最大值
        if(tmp.length > 0 && item.inputType === 'inputrange') {
            newValue.max = tmp.shift() as string
        }
         
        return newValue as RangeValueType
    }

    // 处理 input-select组件 range value
    const transformInputRangeData = (extendAttribute: string, isUpdate=false)=> {
        
        const [min, max] = [inputMinValue, inputMaxValue].map((value: string, index: number)=> {
            if(value.endsWith('.')) {
                const nValue = `${value}.0`
                index === 0 ? setInputMinValue(nValue) : setInputMaxValue(nValue)
                return nValue
            }
            return value
        })
        // 校验去掉 和web端保持一致，可能有不完整的数据填写
        // if(selectField.other  && isUpdate) {
        //     const { key } = selectField.other
        //     if(key === selectValue) {
        //         if(otherValue === '') {
        //             Toast.fail('请填写完整后再试！', 1);
        //             isNullValidationIs = true
        //             return
        //         }
        //     }
        // }

        let maxNg = true
        if(selectField.inputType === 'inputrange') {
            maxNg = max === ''                    
        }
        // if((maxNg || min === '') && isUpdate) {
        //     Toast.fail('请填写完整后再试！', 1);
        //     isNullValidationIs = true
        //     return
        // }

        const item: any = {
            dataCode: selectField.dataCode,
            deCode: selectField.deCode,
            value: {
                min,
                max,
                radio: selectValue,
                other: otherValue
            }
        }
        // 清空操作就将value置空
        console.log(selectField)
        if(item.value.min == "" && item.value.max == "" && item.value.radio == "" && item.value.other == ""){
            item.value = ""
        }
        
        if(isUpdate) {
            item.formId = formId
            return item
        }

        if (extendAttribute) {
            item.extendAttribute = extendAttribute
        }

      
        return {
            formId: formId,
            submit: false,
            values: [item]
        }
    }

    //暂存数据
    const onSave = () => {
        if (!inputError && selectField) {

            let extendAttribute = ''
            if (selectField.isAdd) {
                extendAttribute = 'isAdd=true'
            }

            // 标签有限制maxDate、minDate ，和这个判断逻辑重复，删除
            // if (selectField.type === 'date' || selectField.type === 'datetime' && currentValue) {
            //     let max: any;
            //     let min: any;
            //     let current = moment(currentValue);
            //     let data = selectField;
            //     if (data && data.validationRules && data.validationRules.length > 0) {
            //         for (let item of data.validationRules) {
            //             if (item.type === 'range') {
            //                 if (item.condition === 'lte') {
            //                     if (item.rule === '${currDate}') {
            //                         max = new Date();
            //                     }
            //                 }
            //                 else if (item.condition === 'gte') {
            //                     if (item.rule) {
            //                         // min = new Date(item.rule)
            //                         min = new Date(getNextDate(item.rule, -1))
            //                     }
            //                 }
            //             }
            //             else if (item.type === 'compare') {
            //                 if (savedValue && savedValue.length > 0) {
            //                     let compareData;
            //                     let _index = -1; // 多组时当前下标
            //                     if (data && data["dataCode"] && data["dataCode"].indexOf('#') >= 0) {
            //                         _index = data["dataCode"].split('#')[1];
            //                     }
            //                     for (let value of savedValue) {
            //                         if ((item.rule == value["dataCode"]) || (item.rule == value["deCode"])) {
            //                             compareData = value["value"];
            //                         }
            //                         // 多组
            //                         if (_index != -1) {
            //                             // eg -> startTime12#{index}
            //                             if (item.rule && item.rule.indexOf('#') >= 0) {
            //                                 let rulePre = item.rule.split('#')[0];
            //                                 let nowRule = rulePre + '#' + _index;
            //                                 if (nowRule == value["dataCode"]) {
            //                                     compareData = value["value"];
            //                                 }
            //                             }
            //                         }
            //                     }
            //                     if (compareData && item.condition === 'lte') {
            //                         max = new Date(compareData)
            //                     } else if (compareData && item.condition === 'gte') {
            //                         min = new Date(compareData)
            //                     }
            //                 }
            //             }
            //         }
            //     }
            //     if (max) {
            //         let maxExceed = current > moment(max).endOf('day');
            //         if (maxExceed) {
            //             Toast.fail(`时间不能超过${moment(max).format('YYYY-MM-DD')}`, 1.5);
            //             return;
            //         }
            //     }
            //     if (min) {
            //         let minExceed = current < moment(min).startOf('day');
            //         if (minExceed) {
            //             Toast.fail(`时间不能小于${moment(min).format('YYYY-MM-DD')}`, 1.5);
            //             return;
            //         }
            //     }
            // }
            if (selectField.type === 'input-select') {
               const params = transformInputRangeData(extendAttribute, false)
                
                if(!params) {
                    return
                }
                
                setLoading(true);
                api.saveForm(params).then(({ message, code, data })=> {
                    if (code == '0') {
                        setSavedValue(data)
                        setShowModal(false);
                        setSelectField(null);
                        setCurrentValue(null);
                    } else {
                        Toast.fail(message, 1);
                    }
                    props.updateData();
                    setLoading(false);
                })
            }
            else if (selectField.type === 'checkbox') {

                let value: any[] = [];
                let validation = true;
                //若包含other字段
                /* if (selectField.other) {
                    let filterValue;
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (otherValue) {
                            filterValue = currentValue.concat(otherValue.trim());
                        }
                        else {
                            filterValue = currentValue;
                        }
                    }
                    else {
                        filterValue = currentValue;
                    }
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: filterValue,
                    }];
                }
                else {
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: currentValue,
                    }];
                } */
                value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: (currentValue && currentValue.length > 0) ? currentValue.filter((item: any) => {
                        return item !== '' && item !== null && item !== undefined
                    }) : [],
                }];
                if (selectField.other) {
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (otherValue) {
                            value[0].value.concat(otherValue.trim());
                        }
                    }
                }

                /* let judgeNullArr = JSON.parse(JSON.stringify(value[0].value)) || [];
                for (let i = 0; i < judgeNullArr.length; i++) {
                    if (judgeNullArr[i] === '' || judgeNullArr[i] === null || judgeNullArr[i] === undefined) {
                        judgeNullArr.splice(i, 1)
                        i = i - 1;
                    }
                } */
                if (validationIsNull(selectField)) {
                    if (value[0].value && value[0].value.length > 0) {
                        if (selectField.other) {
                            if (value[0].value && value[0].value.indexOf(selectField.other.key) !== -1) {
                                if (otherValue && otherValue.trim()) {
                                    validation = true;
                                }
                                else {
                                    validation = false;
                                }
                            }
                        }
                        else {
                            validation = true;
                        }
                    } else {
                        validation = false;
                    }
                }

                // if (validation) {

                    if (extendAttribute) {
                        value[0].extendAttribute = extendAttribute
                    }
                    let params = {
                        formId: formId,
                        submit: false,
                        values: [...value]
                    }
                    setLoading(true);
                    api.saveForm(params).then(res => {
                        if (res.code == '0') {
                            let filterArr = res.data;
                            setSavedValue(filterArr)
                            setShowModal(false);
                            setSelectField(null);
                            setCurrentValue(null);
                        }
                        else {
                            Toast.fail(res.message, 1);
                        }
                        props.updateData();
                        setLoading(false);
                    })
                // }
                // else {
                //     Toast.fail('请填写完整后再试！', 1);
                //     isNullValidationIs = true
                // }
            }
            else if (selectField.type === 'select') {
                let value: any[] = [];
                let validation = true;
                //若包含other字段
                if (selectField.other) {
                    let filterValue;
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (selectField.other.type === 'input') {
                            if (otherValue && otherValue.trim()) {
                                filterValue = otherValue.trim();
                                validation = true;
                            }
                            else {
                                validation = false;
                            }
                        }
                        else if (selectField.other.type === 'date') {
                            if (otherValue) {
                                filterValue = otherValue;
                                validation = true;
                            }
                            else {
                                validation = true;
                                filterValue = new Date();
                            }
                        }
                    }
                    else {
                        filterValue = currentValue;
                        validation = true;
                    }
                    if(!filterValue){
                        return 
                    }
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: filterValue,
                    }];
                }
                else {
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: currentValue,
                    }];
                }
                // 清空对应的clearList
                let _action = (selectField?.actions || []).find((val: any) => val.type == 'clearList') || {};
                if (currentValue == _action?.rule) {
                    if (_action?.type == 'clearList') {
                        let _target = _action.target || [];
                        let _savedValues = savedValue;
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: currentValue,
                        }];
                        _target.forEach((tDataCode: string) => {
                            _savedValues.forEach((v: any) => {
                                let isClear = false;
                                if (v.dataCode.indexOf('#') >= 0) {
                                    let _v = v.dataCode.split('#')[0];
                                    isClear = (_v == tDataCode);
                                } else {
                                    isClear = (v.dataCode == tDataCode);
                                }
                                if (isClear) {
                                    // 清空对应的数据
                                    let values = [
                                        {
                                            dataCode: v.dataCode,
                                            deCode: v.deCode,
                                            value: ''
                                        }
                                    ]
                                    value = [...value, ...values];
                                }
                            });
                        });
                    }
                }
                // if (validation) {

                    if (extendAttribute) {
                        value[0].extendAttribute = extendAttribute
                    }

                    let params = {
                        formId: formId,
                        submit: false,
                        values: [...value]
                    }
                    setLoading(true);
                    api.saveForm(params).then(res => {
                        if (res.code == '0') {
                            let filterArr = res.data;
                            setSavedValue(filterArr)
                            setShowModal(false);
                            setSelectField(null);
                            setCurrentValue(null);
                            setTimeout(() => {
                                setLastTimeValue(null)
                            }, 1500);
                        // } else if(res.code == '50031411') {
                        //     // 跳过错误类型 该受试者信息已存在，重复受试者编码为：[QLXH200015]
                        //     Modal.alert('提示', res.message)
                        }
                        else {
                            Toast.fail(res.message, 1);
                        }
                        props.updateData();
                        setLoading(false);
                    })
                // }
                // else {
                //     if (lastTimeValue && lastTimeValue.indexOf(selectField.other.key) != -1) {
                //         Toast.fail('请填写完整后再试！', 1);
                //     }
                //     isNullValidationIs = true
                // }
            }
            else {
                if (['number', 'decimal', 'input'].includes(selectField.type)) {
                    // feature: 处理number字段和number字段数值比较
                    replaceFieldRule(selectField.validationRules, savedValue)

                    let judge = verify.checkValueByRange(currentValue, selectField)
                    let judge1 = verify.checkValueByRep(currentValue, selectField);

                    if (!judge) {
                        return false
                    }
                    if (!judge1) {
                        Toast.info('请输入正确的格式！', 1)
                        return false
                    }
                }
                let value: any[] = [];
                let validation = true;
                //自动补零
         
                if (typeof currentValue === 'string' && currentValue.indexOf(".") !== -1) {
                    if (currentValue.indexOf(".") === currentValue.length - 1) {
                        setCurrentValue(currentValue + '0');
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: currentValue + '0',
                        }];
                    } else {
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: currentValue,
                        }];
                    }
                } else {
                    if (((selectField.type == 'date') || (selectField.type == 'datetime')) ) {
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: currentValue? moment(currentValue).format(selectField.type == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'):'',
                        }];
                    } else if(selectField.type == 'unknownDate' && currentValue){
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: `${currentValue[0]}-${currentValue[1]}-${currentValue[2]}`,
                        }];
                    } else {
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value:  currentValue,
                        }];
                    }


                }

                validation = true;
                if (value[0].value) {
                    validation = true;
                }
                else {
                    validation = false
                }
                // if (validation) {

                    if (extendAttribute) {
                        value[0].extendAttribute = extendAttribute
                    }

                    let params = {
                        formId: formId,
                        submit: false,
                        values: [...value]
                    }
                    
                    setLoading(true);
                    api.saveForm(params).then(res => {
                        if (res.code == '0') {
                            let filterArr = res.data;
                            setSavedValue(filterArr)
                            setShowModal(false);
                            setSelectField(null);
                            setCurrentValue(null);
                        }
                        else {
                            // 该受试者信息已存在，重复受试者编码为：[QLXH200015]
                            // if(res.code == '50031411') {
                            //     Modal.alert('提示', res.message)
                            // } else {
                                
                            // }
                            Toast.fail(res.message, 1);
                        }
                        props.updateData();
                        setLoading(false);
                    })
                // }
                // else {
                    // Toast.fail('请填写完整后再试！', 1);
                    // isNullValidationIs = true
                // }
            }
        } else {
            Toast.fail('请输入正确的格式！', 1);
            isNullValidationIs = true;
        }
    }

    /**
     * 递归查找下一题的配置信息
     * @param config   配置信息
     * @param dataCode 当前字段的数据编码
     * @param isNextNode 是否下一个目标节点
     * @returns nextFieldConfig 下一个字段胡配置信息
     */
    const deepNextField: any = (config: any, dataCode: string, isNextNode: boolean) => {
        // console.log('deepNextField-config:',config,',deepNextField-dataCode:',dataCode,',deepNextField-isNextNode:',isNextNode)
        // console.log('deepNextField-currentValue',currentValue)
        let result = {
            item: undefined,
            isNextNode: isNextNode
        };
        if (!config || config.length == 0) {
            return result;
        }
        for (let item of config) {
            // 显隐逻辑处理
            if (item.display) {
                let display = false;
                // 判断显隐逻辑是否满足 dataCode/target currentValue/rule
                // if (item.display.type === 'ValueCascade') {
                //     if (item.display.condition === 'eq') {
                //         // dataCode='' currentValue=''/[] rule='' target=''
                //         if (
                //             dataCode == item.display.target &&
                //             (currentValue == item.display.rule || currentValue.includes(item.display.rule))
                //         ) {
                //             display = true;
                //         }

                //     } else if (item.display.condition === 'oreq') {
                //         // dataCode='' currentValue=[] rule=[] target=''
                //         if (currentValue instanceof Array) {
                //             for (let i = 0; i < currentValue.length; i++) {
                //                 if (
                //                     dataCode == item.display.target &&
                //                     item.display.rule.includes(currentValue[i])
                //                 ) {
                //                     display = true;
                //                 }
                //             }

                //         } 
                //         // dataCode='' currentValue='' rule=[] target=''
                //         else {
                //             if (
                //                 dataCode == item.display.target &&
                //                 item.display.rule.includes(currentValue)
                //             ) {
                //                 display = true;
                //             }
                //         }
                //     } else if (item.display.condition === 'andEq') {
                //         // dataCode='' currentValue=[] rule=[] target=[]
                //         if (currentValue instanceof Array) {
                //             let target = item.display.target
                //             let rule = item.display.rule
                //             for (let i = 0; i < target.length-1; i++) {
                //                 if (
                //                     dataCode == target[i] && currentValue.includes(rule[i])
                //                 ) {
                //                     display = true;
                //                 }
                //             }
                //         } 
                //         // dataCode='' currentValue='' rule=[] target=[]
                //         else {
                //             let target = item.display.target
                //             let rule = item.display.rule
                //             for (let i = 0; i < target.length-1; i++) {
                //                 if (
                //                     dataCode == target[i] && currentValue == rule[i]
                //                 ) {
                //                     display = true;
                //                 }
                //             }
                //         }
                //     }
                // }
                //-----------------------------------------------------------------------------------------------------------
                if (item.display.type === 'ValueCascade') {
                    if (item.display.condition === 'eq') {
                        //当前选中表单已存的value
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == item.display.target
                        });
                        if (currentItem) {
                            if (!((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule))) {
                                display = true;
                            }
                        }
                    }
                    else if (item.display.condition === 'oreq') {
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == item.display.target
                        });
                        if (currentItem && currentItem.value) {
                            if (currentItem.value instanceof Array) {
                                currentItem.value.length > 0 && currentItem.value.map((i: any) => {
                                    if (item.display.rule.includes(i)) {
                                        display = true;
                                    }
                                })
                            } else {
                                if (item.display.rule.includes(currentItem.value)) {
                                    display = true;
                                }
                            }
                        }
                    }
                    else if (item.display.condition === 'andEq') {
                        let list = savedValue.filter((i: any) => {
                            return item.display.target.includes(i.dataCode)
                        });

                        if (list && list.length > 0) {
                            for (let i = 0; i < list.length - 1; i++) {
                                if (list[i].value instanceof Array) {
                                    if (
                                        (list[i].dataCode == item.display.target[i] && list[i].value.includes(item.display.rule[i])) &&
                                        (list[i + 1].dataCode == item.display.target[i + 1] && list[i + 1].value.includes(item.display.rule[i + 1]))
                                    ) {
                                        display = true;
                                    }
                                } else {
                                    if (
                                        (list[i].dataCode == item.display.target[i] && list[i].value == item.display.rule[i]) &&
                                        (list[i + 1].dataCode == item.display.target[i + 1] && list[i + 1].value == item.display.rule[i + 1])
                                    ) {
                                        display = true;
                                    }
                                }
                            }
                        }
                    }
                }
                else if (currentValue instanceof Array) {
                    if (item.display.target instanceof Array) {
                        let i = item.display.target.indexOf(dataCode);
                        if (item.display.target[i] == dataCode) {
                            if (item.display.rule[i] instanceof Array) {
                                currentValue.map(rItem => {
                                    if (!item.display.rule[i].includes(rItem)) {
                                        display = true;
                                    }
                                })
                            } else {
                                if (!currentValue.includes(item.display.rule[i])) {
                                    display = true;
                                }
                            }
                        }
                    } else {
                        if (!currentValue.includes(item.display.rule) && item.display.target == dataCode) {
                            display = true;
                        }
                    }

                } else {
                    if (item.display.target instanceof Array) {
                        let i = item.display.target.indexOf(dataCode);
                        if (item.display.target[i] == dataCode && item.display.rule[i] != currentValue) {
                            display = true;
                        }
                    } else {
                        if (item.display.rule != currentValue && item.display.target == dataCode) {
                            display = true;
                        }
                    }
                }
                //-------------------------------------------------------------------------------------------------
                // if (currentValue instanceof Array) {

                //     if (item.display.condition === 'eq') {
                //         if (item.display.target == dataCode && currentValue.includes(item.display.rule)) {
                //             display = true;
                //         }
                //     }
                //     else if (item.display.condition === 'oreq') {
                //         for (let i = 0; i < currentValue.length - 1; i++) {
                //             if (item.display.target == dataCode && item.display.rule.includes(currentValue[i])) {
                //                 display = true;
                //             }
                //         }
                //     }
                //     else if (item.display.condition === 'andEq') {
                //         for (let i = 0; i < currentValue.length - 1; i++) {
                //             if (item.display.rule.includes(currentValue[i]) && item.display.target[i] == dataCode) {
                //                 display = true;
                //             }
                //         }
                //     }

                // } else {
                //     if (item.display.condition === 'eq') {
                //         if (item.display.target == dataCode && item.display.rule == currentValue) {
                //             display = true;
                //         }
                //     }
                //     else if (item.display.condition === 'oreq') {
                //         if (item.display.target == dataCode && item.display.rule.includes(currentValue)) {
                //             display = true;
                //         }
                //     }
                //     else if (item.display.condition === 'andEq') {
                //         let target = item.display.target
                //         let rule = item.display.rule
                //         for (let i = 0; i < rule.length - 1; i++) {
                //             if (currentValue == rule[i] && dataCode == target[i]) {
                //                 display = true;
                //             }
                //         }
                //     }
                // }

                if (display) {
                    continue;
                }
            }
            // 递归子节点
            if (item.children) {
                let nextConfig = deepNextField(item.children, dataCode, result.isNextNode);
                if (nextConfig.item) {
                    return nextConfig;
                } else {
                    result.isNextNode = nextConfig.isNextNode;
                    continue;
                }
            }
            // 如果当前节点是下一个节点，直接返回配置
            if (item.dataCode && result.isNextNode) {
                result.item = item;
                return result;
            }
            // 处理当前节点
            if (item.dataCode == dataCode) {
                result.isNextNode = true;
                continue;
            }

        }
        return result;
    }

    // 下一题
    // const nextTopic = () => {
    //     // console.log('nextTopic-selectField:',selectField)

    //     /* setPhotos([]);
    //     setInfoPhotos([]); */

    //     // 必填项不跳转
    //     if (
    //         selectField.type != 'select' && selectField.type != 'input-select' && selectField.type != 'date' &&
    //         selectField.type != 'photo' && selectField.type != 'photo-oss' &&  selectField.type != 'camera' && 
    //         selectField.type != "video" && selectField.type != "file" && validationIsNull(selectField) &&
    //         (!currentValue || currentValue == '' || currentValue == 'undefined')
    //     ) {
    //         // console.log('validationIsNull(selectField):',validationIsNull(selectField),',currentValue:',currentValue)
    //         setLoading(false)
    //         Toast.fail('请填写完整后再试！', 1)
    //         return
    //     }
    //     if (validationIsNull(selectField) && (selectField.type == 'photo' && (!photos || photos.length == 0))) {
    //         setPhotos([]);
    //         setInfoPhotos([]);
    //         setLoading(false)
    //         Toast.fail('请填写完整后再试！', 1)
    //         return
    //     }
    //     if (validationIsNull(selectField) && (selectField.type == 'photo-oss' && (!photos || photos.length == 0))) {
    //         setPhotos([]);
    //         setInfoPhotos([]);
    //         setLoading(false)
    //         Toast.fail('请填写完整后再试！', 1)
    //         return
    //     }

    //     if (validationIsNull(selectField) && (selectField.type == 'camera' && (!photos || photos.length == 0))) {
    //         setPhotos([]);
    //         setInfoPhotos([]);
    //         setLoading(false)
    //         Toast.fail('请填写完整后再试！', 1)
    //         return
    //     }

    //     if (validationIsNull(selectField) && (selectField.type == 'video' && (!videos || videos.length == 0))) {
    //         setVideos([])
    //         setLoading(false)
    //         Toast.fail('请填写完整后再试！', 1)
    //         return
    //     }

    //     if (validationIsNull(selectField) && (selectField.type == 'file' && (!filesData || filesData.length == 0))) {
    //         setFilesData([])
    //         setLoading(false)
    //         Toast.fail('请填写完整后再试！', 1)
    //         return
    //     }

    //     if (selectField.type != 'input-select' && selectField.type != "select" && selectField.type != "photo" && selectField.type != "photo-oss" && selectField.type != "camera"  && selectField.type != "video" && selectField.type != "file") {
    //         /* if(validationIsNull(selectField)) {
    //             if(selectNoteType == 'DataActionUpdate') {
    //                 onUpdate();
    //             }else {
    //                 onSave()
    //             }
    //         } */
    //         // 更新重复了，先删除
    //         // if (selectNoteType == 'DataActionUpdate') {
    //         //     onUpdate()
    //         // } else {
    //         //     onSave()
    //         // }
    //         onSave()
    //     }
    //     if (isNullValidationIs) {
    //         return;
    //     }

    //     setCurrentValue(null)

    //     // console.log('执行getNextTopic')
    //     let nextFieldConfig = deepNextField(fieldList, selectField.dataCode, false);
    //     // console.log('nextFieldConfig:',nextFieldConfig)
    //     if (nextFieldConfig.item) {
    //         let currentItem = savedValue.find((i: any) => {
    //             return i.dataCode == nextFieldConfig.item.dataCode
    //         });

    //         if (currentItem) {
    //             if (nextFieldConfig.item.type === 'photo' || nextFieldConfig.item.type === 'photo-oss' || nextFieldConfig.item.type === 'camera' || nextFieldConfig.item.type === 'video' || nextFieldConfig.item.type === 'file') {
    //                 let filterArr: any = [];
    //                 let _url: any = [];
    //                 for (let Item of currentItem.value) {
    //                     filterArr.push(
    //                         {
    //                             url: Item
    //                         }
    //                     )
    //                     _url.push(Item);
    //                 }
    //                 let suffixPhotos = changedPhoto(filterArr);

    //                 if (nextFieldConfig.item.type === 'photo' || nextFieldConfig.item.type === 'photo-oss' || nextFieldConfig.item.type === 'camera') {
    //                     setPhotos(suffixPhotos);
    //                     setInfoPhotos(getInfoTipPhoto(suffixPhotos));
    //                 }
    //                 else if (nextFieldConfig.item.type === 'video') {
    //                     setVideos(suffixPhotos)
    //                 }
    //                 else if (nextFieldConfig.item.type === 'file') {
    //                     setFilesData(suffixPhotos)
    //                 }
    //             }

    //             setCurrentValue(currentItem.value)

    //         } else {
    //             /* if (selectField.type == "date") {
    //                 setCurrentValue(new Date())
    //             } */
    //             // 如果下一题是date类型，将当前时间设为默认填写值
    //             if (nextFieldConfig.item.type == 'date') {
    //                 setCurrentValue(new Date())
    //             }
    //             else if (nextFieldConfig.item.type === 'checkbox') {
    //                 setCurrentValue(Array(Object.keys(nextFieldConfig.item.optional).length).fill(''));
    //             }
    //             else if (nextFieldConfig.item.type === 'photo' || nextFieldConfig.item.type === 'photo-oss' || nextFieldConfig.item.type === 'camera') {
    //                 setPhotos([]);
    //                 setInfoPhotos([]);
    //             }
    //             else if (nextFieldConfig.item.type === 'video') {
    //                 setVideos([])
    //             }
    //             else if (nextFieldConfig.item.type === 'file') {
    //                 setFilesData([])
    //             }
    //         }

    //         setSelectField(nextFieldConfig.item)
    //         fillFormBtn(nextFieldConfig.item)
    //     }
    //     else {
    //         if (nextFieldConfig.isNextNode) {
    //             setShowModal(false);
    //         }
    //     }
    // }

    // 清空按钮
    const onClear = ()=>{
        Modal.alert("确定清空数据吗？", "", [
            {
              text: "取消",
              onPress() {},
            },
            {
              text: "确定",
              onPress: async()=> {

                if (!selectField) {
                    return
                }
            
                // if(selectField.type === 'ocr-autofill'){
                //     setCurrentValue([])
                //     const scopeConfig = searchFieldScope(selectField.dataCode, filterChildrenByDataCode(fieldList, selectField.dataCode))
                //     const fillFields = pickOcrFillFields(scopeConfig)
                //     const cleans = Object.keys(fillFields)
                //     savedValue.forEach((item : ValueItem)=> {
                //       if(item.dataCode !== selectField.dataCode && cleans.includes(item.dataCode)) {
                //         item.value = '';
                //       }
                //     })
                //     const params = {
                //         formId: String(formId),
                //         submit: false,
                //         values: [
                //           ...savedValue,
                //         ]
                //       }
                //       api.saveForm(params)
                // }else{
                //     setInputMaxValue("")
                //     setInputMinValue("")
                //     setOtherValue("")
                //     setSelectValue("")
                //     setCurrentValue("")
                // }
                setInputMaxValue("")
                setInputMinValue("")
                setOtherValue("")
                setSelectValue("")
                setCurrentValue("")
                setOperateType("clear")

              }
            }
        ])
     
     
    }
    //修改数据
    // closeModal 质疑回复 - 修改原值
    const onUpdate = async(closeModal = true) => {
        if (inputError) {
            Toast.fail('请输入正确的格式！', 1);
            return
        }

        if (!selectField) {
            return
        }

        if (selectField.type === 'input-select') {
            const params = transformInputRangeData('', true)
            if(!params) {
                return
            }

            setLoading(true);
            const { code, message } = await api.updateData(params)
            setLoading(false);
            if (code == '0') {
                Toast.success('修改成功！', 1)
                //更新当前表单数据
                getDataById();
                closeModal && onCloseModal()
            } else {
                Toast.fail(message, 1)
            }
            props.updateData();
            return
        }

        

        if (selectField.type === 'checkbox') {

            let value;
            let validation = true;
            let flag = false;

            //若包含other字段
            if (selectField.other) {
                if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                    if (otherValue) {
                        flag = true
                        value = currentValue.concat(otherValue.trim());
                    }
                }
            }
            // 兜底
            if (false === flag) {
                value = currentValue
            }

            let judgeNullArr = JSON.parse(JSON.stringify(value));
            for (let i = 0; i < judgeNullArr.length; i++) {
                if (judgeNullArr[i] == '' || judgeNullArr[i] == null || judgeNullArr[i] == undefined) {
                    judgeNullArr.splice(i, 1)
                    i = i - 1;
                }
            }
            if (judgeNullArr && judgeNullArr.length > 0) {
                if (selectField.other) {
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (otherValue && otherValue.trim()) {
                            validation = true;
                        } else {
                            validation = false;
                        }
                    }
                }
            }
            else {
                // 是否必填项
                for(const dd of selectField.validationRules) {
                    if (dd.type === 'integrity' && dd.rule === 'null' && dd.condition === 'ne') {
                        validation = false;
                        break
                    }
                }
            }

            if (!validation) {
                Toast.fail('请填写完整后再试！', 1);
                isNullValidationIs = true
                return
            }

            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                value: value
            }
            setLoading(true);
            const {code, message} = await api.updateData(params)
            setLoading(false);

            if (code == '0') {
                Toast.success('修改成功！', 1)
                //更新当前表单数据
                getDataById();
                closeModal && onCloseModal()
            } else {
                Toast.fail(message, 1)
            }
            props.updateData();
            return
        }

        let value;
        let validation = true;
        if (selectField.type === 'select') {
            value = currentValue;
            //若包含other字段
            if (selectField.other) {
                if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                    if (selectField.other.type === 'input') {
                        if (otherValue && otherValue.trim()) {
                            value = otherValue.trim();
                            validation = true;
                        }
                        else {
                            validation = false;
                        }
                    }
                    else if (selectField.other.type === 'date') {
                        if (otherValue) {
                            value = otherValue;
                            validation = true;
                        }
                        else {
                            validation = true;
                            value = new Date();
                        }
                    }
                }
                else {
                    value = currentValue;
                    validation = true;
                }
            }
            else {
                value = currentValue;
            }
        } else if (selectField.type === 'decimal') {
            //自动补零
            if (currentValue.indexOf(".") !== -1) {
                if (currentValue.indexOf(".") === currentValue.length - 1) {
                    setCurrentValue(currentValue + '0');
                    value = currentValue + '0'
                } else {
                    value = currentValue
                }
            }
            else {
                value = currentValue
            }
        } else if(selectField.type === 'unknownDate'){
            value = currentValue ? [...currentValue].splice(0, 3).join('-') : ''
        } else {
            value = currentValue;
        }


        if (['input', 'number', 'decimal'].includes(selectField.type)) {

            // feature: 处理number字段和number字段数值比较
            replaceFieldRule(selectField.validationRules, savedValue)

            let judge = verify.checkValueByRange(currentValue, selectField)
            let judge1 = verify.checkValueByRep(currentValue, selectField);

            if (!judge) {
                return false
            }
            if (!judge1) {
                Toast.info('请输入正确的格式！', 1)
                return false
            }
        }

        if (!validation) {
            Toast.fail('请填写完整后再试！', 1);
            isNullValidationIs = true
            return
        }

        let params = {
            formId: formId,
            deCode: selectField.deCode,
            dataCode: selectField.dataCode,
            value: value
        }
        setLoading(true);
        const {code, message} = await api.updateData(params)
        setLoading(false);

        if (code == '0') {
            Toast.success('修改成功！', 1)
            //更新当前表单数据
            getDataById();
            closeModal && onCloseModal()
        } else {
            Toast.fail(message, 1)
        }
        props.updateData();
    }

    //当选择了注释
    const onAnnotationChange = (value: any) => {
        return () => {
            setAnnotationValue(value)
        }
    }

    //注释表单
    const onAnnotation = () => {
        if (annotationValue) {
            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                annotation: annotationValue,
            }
            setLoading(true);
            api.annotationData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('注释成功！', 1);
                    //更新当前表单数据
                    getDataById();
                    // setShowModal(false);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1);
                    }
                    else {
                        Toast.fail('注释失败！', 1);
                    }
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('请选择后再试！', 1);
        }
    }

    //当备注表单
    const onRemark = () => {
        if (remarkValue && remarkValue.trim()) {
            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                remark: remarkValue.trim(),
            }
            setLoading(true);
            api.remarkData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('备注成功！', 1);
                    //更新当前表单数据
                    getDataById();
                    // setShowModal(false);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1);
                    }
                    else {
                        Toast.fail('备注失败！', 1);
                    }
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('请输入备注内容后再提交！', 1);
        }
    }

    //当质疑操作
    const onQuestion = () => {
        if (selectQuestionType && questionInf) {
            let params = {
                content: questionInf,
                dataCode: selectField.dataCode,
                deCode: selectField.deCode,
                formActions: formActions,
                formId: formId,
                // sendTo: '',
                type: selectQuestionType[0]
            }
            setLoading(true);
            api.addQuestion(params).then(res => {
                if (res.code == '0') {
                    Toast.success('创建质疑成功！', 1)
                    setSelectFieldQuestion(res.data);
                    //清空检查的类型
                    setSelectQuestionType(null);
                    //清空检查说明
                    setQuestionInf(null);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('创建质疑失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('请填写完整后再提交质疑', 1)
        }
    }

    //痕迹稽查
    const onTrance = () => {

    }

    //回复质疑
    const onAnswerQuestion = async() => {

        // 质疑回复 - 修改原值时
        let type = currentQuestionType
        // 修改值后会自动关闭弹窗的组件
        const saveAutoCloseModal = ['select', 'photo-oss', 'ocr-autofill'].includes(selectField.type)

        // 质疑回复 - 修改原值
        if (currentQuestionType === 'Update') {
            // 已经自动保存了，不需要再次提交
            if (saveAutoCloseModal) {
                // 这里强制修改为保留原值
                type = 'Retain'
            } else {
                // 这里需要提交一次新增
                await onUpdate(false)
            }
        }

        let params = {
            content: supplementInf,
            dataCode: selectField.dataCode,
            deCode: selectField.deCode,
            formId: formId,
            questionId: selectQuestionItemId,
            type: type,
            value: questionModifyValue
        }
        
        setLoading(true);
        const {code, message, data} = await api.answerQuestion(params)
        setLoading(false);

        if (code == '0') {
            setSelectFieldQuestion(data);
            Toast.success('保存成功！', 1);
            //更新表单数据
            getDataById();
            setSupplementInf('');
            setQuestionModifyValue('');
            setSelectQuestionItemId(null);
        } else {
            Toast.fail(message || '保存失败', 1)
        }
    }

    //关闭质疑
    const closeQuestion = (id: any) => {
        return () => {
            let params = {
                dataCode: selectField.dataCode,
                deCode: selectField.deCode,
                formId: formId,
                questionId: id,
            }
            setLoading(true);
            api.closeQuestion(params).then(res => {
                if (res.code == '0') {
                    setSelectFieldQuestion(res.data);
                    Toast.success('关闭成功！', 1);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('关闭失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //重新打开质疑
    const reopenQuestion = (id: any) => {
        return () => {
            let params = {
                dataCode: selectField.dataCode,
                deCode: selectField.deCode,
                formId: formId,
                questionId: id,
            }
            setLoading(true);
            api.reopenQuestion(params).then(res => {
                if (res.code == '0') {
                    setSelectFieldQuestion(res.data);
                    Toast.success('重新打开成功！', 1);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('重新打开失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //当图片选择改变时
    const onPhotoChange = (files: any) => {
        setPhotos(files)
        setInfoPhotos(getInfoTipPhoto(files));
    }

    /**
     * 当视频选择改变时
     * @param files 
     */
    const onVideoChange = (files: any) => {
        setVideos(files)
    }

    /**
     * 当文件选择改变时
     * @param files 
     */
    const onFileChange = (files: any) => {
        setFilesData(files)
    }

    const afterUploadSaveData = () => {
        // @ts-ignore
        if (formUpdateParams && formUpdateParams.selectNoteType === 'DataActionInput') {
            saveFormRequest();
            // @ts-ignore
        } else if (formUpdateParams && formUpdateParams.selectNoteType === 'DataActionUpdate') {
            updateDataRequest();
        }
    }

    // 保存1
    const saveFormRequest = () => {
        const params = {
            formId: formUpdateParams.formId,
            submit: formUpdateParams.submit,
            values: formUpdateParams.values
        }
        // @ts-ignore
        api.saveForm(params).then(res => {
            if (res.code == '0') {
                let filterArr = res.data;
                setSavedValue(filterArr);
            }
            else {
                Toast.fail(res.message, 1);
            }
            props.updateData();
        })
    }

    // 保存2
    const updateDataRequest = () => {
        const params = {
            formId: formUpdateParams.formId,
            deCode: formUpdateParams.deCode,
            dataCode: formUpdateParams.dataCode,
            value: formUpdateParams.value
        }
        api.updateData(params).then(res => {
            if (res.code == '0') {
                //更新当前表单数据
                getDataById();
            }
            else {
                Toast.fail(res.message, 1)
            }
            setLoading(false);
        })
    }

       // 实时上传方法
     const onUploadCamera = async (item: any): Promise<object | undefined> => {
        const pieces = await makeUploadOptions();

        if (!pieces) {
            return;
        }

        const [prefix, options] = pieces;
        
        const client = new OSS(options);

        return new Promise((resolve, reject) => {
            const file = item.file;
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const pathname = makeUploadName(prefix, file);

                if (!pathname) {
                    return;
                }
                // oss上传
                client.put(
                    pathname,
                    file,
                ).then((res: any) => {
                    let url = res.url;
                    let isDesensitization = 0; // 0不脱敏，1脱敏，（oss图片上传，暂时屏蔽脱敏）
                    resolve({ url: url });
                    photos.push(
                        {
                            url: url
                        }
                    )
                    //若当前为录入权限
                    setLoading(true);
                    if (selectNoteType === 'DataActionInput') {
                        //暂存数据
                        if (photos) {
                            let filterPhotos = [];
                            for (let item of photos) {
                                // 上传时还原来的图片地址
                                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                                filterPhotos.push(_originUrl)
                            }
                            let value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: filterPhotos,
                            }];
                            let params = {
                                formId: formId,
                                submit: false,
                                values: [...value]
                            }
                            setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
                            // 需要脱敏，脱敏完成后再保存，自动跳转
                            if (isDesensitization == 1 || isOcr) {
                                setOcrRecongize(true)
                                setLoading(false);
                                setCurrentPhotoIndex(filterPhotos.length - 1);
                                setPhotoVisible(true);
                                setShowModal(false);
                            } else {

                                api.saveForm(params).then(res => {
                                    if (res.code == '0') {
                                        let filterArr = res.data;
                                        setSavedValue(filterArr);
                                        props.updateData();
                                        Toast.success('保存成功！', 1);
                                    }
                                    else {
                                        Toast.fail(res.message, 1);
                                    }
                                    setLoading(false);
                                })
                            }
                        }
                    }
                    else if (currentQuestionType === 'Update' || selectNoteType === 'DataActionUpdate') {
                        let filterPhotos = [];
                        for (let item of photos) {
                            // 上传时还原来的图片地址
                            let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                            filterPhotos.push(_originUrl)
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: filterPhotos
                        }
                        setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
                        // 需要脱敏，脱敏完成后再保存
                        if (isDesensitization == 1 || isOcr) {
                            setOcrRecongize(true)
                            setLoading(false);
                            setCurrentPhotoIndex(filterPhotos.length - 1);
                            setPhotoVisible(true);
                            setShowModal(false);
                        } else {
                            api.updateData(params).then(res => {
                                if (res.code == '0') {
                                    Toast.success('保存成功', 1)
                                    //更新当前表单数据
                                    getDataById();
                                }
                                else {
                                    Toast.fail(res.message, 1)
                                }
                                props.updateData();
                                setLoading(false);
                            })
                        }
                    }
                    else {
                        Toast.fail('您尚无此权限！', 1);
                        setLoading(false);
                    }
                })
            }
        });

    };

    // 实时上传方法
    const onUpload = async (item: any): Promise<object | undefined> => {
        const pieces = await makeUploadOptions();

        if (!pieces) {
            return;
        }

        const [prefix, options] = pieces;
        
        const client = new OSS(options);

        return new Promise((resolve, reject) => {
            const file = item.file;
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const pathname = makeUploadName(prefix, file);

                if (!pathname) {
                    return;
                }
                // oss上传
                client.put(
                    pathname,
                    file,
                ).then((res: any) => {
                    let url = res.url;
                    let isDesensitization = 0; // 0不脱敏，1脱敏，（oss图片上传，暂时屏蔽脱敏）
                    resolve({ url: url });
                    photos.push(
                        {
                            url: url
                        }
                    )
                    //若当前为录入权限
                    setLoading(true);
                    if (selectNoteType === 'DataActionInput') {
                        //暂存数据
                        if (photos) {
                            let filterPhotos = [];
                            for (let item of photos) {
                                // 上传时还原来的图片地址
                                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                                filterPhotos.push(_originUrl)
                            }
                            let value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: filterPhotos,
                            }];
                            let params = {
                                formId: formId,
                                submit: false,
                                values: [...value]
                            }
                            setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
                            // 需要脱敏，脱敏完成后再保存，自动跳转
                            if (isDesensitization == 1 || isOcr) {
                                setOcrRecongize(true)
                                setLoading(false);
                                setCurrentPhotoIndex(filterPhotos.length - 1);
                                setPhotoVisible(true);
                                setShowModal(false);
                            } else {

                                api.saveForm(params).then(res => {
                                    if (res.code == '0') {
                                        let filterArr = res.data;
                                        setSavedValue(filterArr);
                                        props.updateData();
                                        Toast.success('保存成功！', 1);
                                    }
                                    else {
                                        Toast.fail(res.message, 1);
                                    }
                                    setLoading(false);
                                })
                            }
                        }
                    }
                    else if (currentQuestionType === 'Update' || selectNoteType === 'DataActionUpdate') {
                        let filterPhotos = [];
                        for (let item of photos) {
                            // 上传时还原来的图片地址
                            let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                            filterPhotos.push(_originUrl)
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: filterPhotos
                        }
                        setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
                        // 需要脱敏，脱敏完成后再保存
                        if (isDesensitization == 1 || isOcr) {
                            setOcrRecongize(true)
                            setLoading(false);
                            setCurrentPhotoIndex(filterPhotos.length - 1);
                            setPhotoVisible(true);
                            setShowModal(false);
                        } else {
                            api.updateData(params).then(res => {
                                if (res.code == '0') {
                                    Toast.success('保存成功', 1)
                                    //更新当前表单数据
                                    getDataById();
                                }
                                else {
                                    Toast.fail(res.message, 1)
                                }
                                props.updateData();
                                setLoading(false);
                            })
                        }
                    }
                    else {
                        Toast.fail('您尚无此权限！', 1);
                        setLoading(false);
                    }
                })
            }
        });

        // return new Promise((resolve, reject) => {
        //     let uploadFormData = new FormData();
        //     uploadFormData.append("file", item.file);
        //     // 识别图片成功

        //     // axios.post("/data/data/image", uploadFormData, {{ // 之前的图片上传
        //     axios.post("/file/image/upload", uploadFormData, {
        //         headers: {
        //             "Content-Type": "multipart/form-data",
        //             "x-formId-code": formId,
        //             // @ts-ignore 首页进来时点击条目的projectCode
        //             "x-projectCode-code": itemData.projectCode,
        //             // @ts-ignore 首页进来时点击条目的subjectCode
        //             "x-subjectCode-code": encodeURIComponent(itemData.subjectCode)
        //         }
        //     }).then(res => {
        //         if (res.data.code == '0') {
        //             // let url = res.data.data; // 之前的图片上传数据结构
        //             let url = res.data.data.url;
        //             let isDesensitization = res.data.data.isDesensitization;
        //             resolve({ url: url });
        //             photos.push(
        //                 {
        //                     url: url
        //                 }
        //             )
        //             //若当前为录入权限
        //             setLoading(true);
        //             // console.log('selectNoteType:',selectNoteType)
        //             // console.log('selectNoteType:',selectNoteType)
        //             if (selectNoteType === 'DataActionInput') {
        //                 //暂存数据
        //                 if (photos) {
        //                     let filterPhotos = [];
        //                     for (let item of photos) {
        //                         // 上传时还原来的图片地址
        //                         let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
        //                         filterPhotos.push(_originUrl)
        //                     }
        //                     let value = [{
        //                         dataCode: selectField.dataCode,
        //                         deCode: selectField.deCode,
        //                         value: filterPhotos,
        //                     }];
        //                     let params = {
        //                         formId: formId,
        //                         submit: false,
        //                         values: [...value]
        //                     }
        //                     setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
        //                     // 需要脱敏，脱敏完成后再保存，自动跳转
        //                     if (isDesensitization == 1 || isOcr) {
        //                         setOcrRecongize(true)
        //                         setLoading(false);
        //                         setCurrentPhotoIndex(filterPhotos.length - 1);
        //                         setPhotoVisible(true);
        //                         setShowModal(false);
        //                     } else {

        //                         api.saveForm(params).then(res => {
        //                             if (res.code == '0') {
        //                                 let filterArr = res.data;
        //                                 setSavedValue(filterArr);
        //                                 props.updateData();
        //                                 Toast.success('保存成功！', 1);
        //                             }
        //                             else {
        //                                 Toast.fail(res.message, 1);
        //                             }
        //                             setLoading(false);
        //                         })
        //                     }
        //                 }
        //             }
        //             else if (selectNoteType === 'DataActionUpdate') {
        //                 let filterPhotos = [];
        //                 for (let item of photos) {
        //                     // 上传时还原来的图片地址
        //                     let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
        //                     filterPhotos.push(_originUrl)
        //                 }
        //                 let params = {
        //                     formId: formId,
        //                     deCode: selectField.deCode,
        //                     dataCode: selectField.dataCode,
        //                     value: filterPhotos
        //                 }
        //                 setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
        //                 // 需要脱敏，脱敏完成后再保存
        //                 if (isDesensitization == 1 || isOcr) {
        //                     setOcrRecongize(true)
        //                     setLoading(false);
        //                     setCurrentPhotoIndex(filterPhotos.length - 1);
        //                     setPhotoVisible(true);
        //                     setShowModal(false);
        //                 } else {
        //                     api.updateData(params).then(res => {
        //                         if (res.code == '0') {
        //                             Toast.success('保存成功', 1)
        //                             //更新当前表单数据
        //                             getDataById();
        //                         }
        //                         else {
        //                             Toast.fail(res.message, 1)
        //                         }
        //                         props.updateData();
        //                         setLoading(false);
        //                     })
        //                 }
        //             }
        //             else {
        //                 Toast.fail('您尚无此权限！', 1);
        //                 setLoading(false);
        //             }
        //         }
        //         else {
        //             reject('图片上传失败！')
        //             Toast.fail('图片上传失败！', 1);
        //         }
        //     })
        // });
    };

    // 查看大图方法
    const onGetPreviewUrl = (index: number): Promise<string> => {
        return new Promise((resolve, reject) => {
            // 点击查看肯定是否OCR识别过
            setOcrRecongize(false)
            // 设置当前点击的图片索引
            setCurrentPhotoIndex(index)
            // 设置显示预览
            setPhotoVisible(true);
            // 关闭弹框
            setShowModal(false)
        });
    };

    // 只读查看大图方法
    const onReadOnlyPreview = (index: number, item: any): Promise<string> => {
        return new Promise((resolve, reject) => {
            setCurrentPhotoIndex(index)
            // 设置显示预览
            setPhotos(item);
            setPhotoVisible(true);
        });
    };

    /**
     * 查看视频
     * @param index 
     * @returns 
     */
    const onGetVideoPreviewUrl = (index: number): Promise<string> => {
        return new Promise((resolve, reject) => {
            // 点击查看肯定是否OCR识别过
            // setOcrRecongize(false)
            // 设置当前点击的图片索引
            setCurrentPhotoIndex(index)
            // 设置显示预览
            // setPhotoVisible(true);
            // 关闭弹框
            setShowModal(false)
        });
    }

    /**
     * 查看文件
     * @param index 
     * @returns 
     */
    const onGetFilePreviewUrl = (index: number): Promise<string> => {
        return new Promise((resolve, reject) => {
            // 点击查看肯定是否OCR识别过
            // setOcrRecongize(false)
            // 设置当前点击的图片索引
            setCurrentPhotoIndex(index)
            // 设置显示预览
            // setPhotoVisible(true);
            // 关闭弹框
            setShowModal(false)
        });
    }

    /**
     * 相同大小视频处理
     */
    const dealSameVideo = () => {
        api.getDealSameVideo({
            // @ts-ignore
            projectCode: itemData.projectCode || '',
            // @ts-ignore
            subjectCode: itemData.subjectCode || '',
            videoName: vedioFile.name || '',
            videoSize: vedioFile.size || '',
        }).then(res => {
            if (res.code == '0') {
                // console.log('相同大小视频处理')
            }
        })
    }

    /**
     * 上传视频
     * @param item 
     * @returns 
     */
    const onVideoUpload = async (item: any): Promise<object | undefined> => {
        const pieces = await makeUploadOptions('video')

        if (!pieces) {
            return;
        }

        const [prefix, options] = pieces;

        let client = new OSS(options);

        return new Promise((resolve, reject) => {
            const file = item.file;
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            let start = Date.now();
            reader.onloadend = (e) => {
                const pathname = makeUploadName(prefix, file)

                if (!pathname) {
                    return
                }

                client.multipartUpload(
                    pathname,
                    file,
                    {
                        // 获取分片上传进度、断点和返回值。
                        progress: (p, cpt, res) => {
                            let timer;
                            if (p > 0) {
                                timer = Math.floor((Date.now() - start) * (1 - p) / p / 1000);
                                timer = timer > 60 ? Math.floor(timer / 60) + "分" + timer % 60 + "秒" : timer + "秒";
                            } else {
                                timer = '计算中';
                            }
                            setVedioProgress({
                                pre: Math.floor(p * 1000) / 10 + '%',
                                rt: Math.floor(res.rt / 100) + 'kb/s',
                                timer: timer
                            })
                        },
                        // 设置并发上传的分片数量。
                        parallel: 4,
                        // 设置分片大小。默认值为1 MB，最小值为100 KB。
                        partSize: 1024 * 1024 * 10,
                        mime: "text/plain",
                        timeout: 600 * 1000
                    }
                ).then((res: any) => {
                    setVedioProgress(null)
                    if (res.res.status !== 200) {
                        Toast.info(`视频上传失败，请重试！`);
                        return;
                    }
                    let url = res.res.requestUrls[0];
                    url = url.substring(0, url.indexOf("?"));
                    resolve({ url: url });
                    videos.push(
                        {
                            url: url
                        }
                    )
                    //若当前为录入权限
                    setLoading(true);
                    if (selectNoteType === 'DataActionInput') {
                        //暂存数据
                        if (videos) {
                            let filterVideos = [];
                            for (let item of videos) {
                                // 上传时还原来的图片地址
                                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                                filterVideos.push(_originUrl)
                            }
                            let value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: filterVideos,
                            }];
                            let params = {
                                formId: formId,
                                submit: false,
                                values: [...value]
                            }
                            setFormUpdateParams({ ...params, selectNoteType });
                            api.saveForm(params).then(res => {
                                if (res.code == '0') {
                                    let filterArr = res.data;
                                    setSavedValue(filterArr);
                                    // 相同大小视频处理 
                                    setVideoFile(file)
                                }
                                else {
                                    Toast.fail(res.message, 1);
                                }
                                setLoading(false);
                            })
                        }
                    }
                    else if (currentQuestionType === 'Update' || selectNoteType === 'DataActionUpdate') {
                        let filterVideos = [];
                        for (let item of videos) {
                            // 上传时还原来的图片地址
                            let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                            filterVideos.push(_originUrl)
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: filterVideos
                        }
                        setFormUpdateParams({ ...params, selectNoteType });
                        api.updateData(params).then(res => {
                            if (res.code == '0') {
                                Toast.success('保存成功', 1)
                                // 相同大小视频处理 
                                setVideoFile(file)
                                //更新当前表单数据
                                getDataById();
                            }
                            else {
                                Toast.fail(res.message, 1)
                            }
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('您尚无此权限！', 1);
                        setLoading(false);
                    }
                })
            }
        });
    };

    /**
     * 上传文件
     * @param item 
     * @returns 
     */
    const onFileUpload = async (item: any): Promise<object | undefined> => {
        const pieces = await makeUploadOptions('file')
        if (!pieces) {
            return
        }
        const [prefix, opitons] = pieces

        let client = new OSS(opitons);

        return new Promise((resolve, reject) => {
            const file = item.file;
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const pathname = makeUploadName(prefix, file);

                if (!pathname) {
                    return;
                }
                // oss上传
                client.put(
                    pathname,
                    file,
                ).then((res: any) => {
                    let url = res.url;
                    resolve({ url: url });
                    filesData.push(
                        {
                            url: url
                        }
                    )
                    //若当前为录入权限
                    setLoading(true);
                    if (selectNoteType === 'DataActionInput') {
                        //暂存数据
                        if (filesData) {
                            let filterFile = [];
                            for (let item of filesData) {
                                // 上传时还原来的图片地址
                                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                                filterFile.push(_originUrl)
                            }
                            let value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: filterFile,
                            }];
                            let params = {
                                formId: formId,
                                submit: false,
                                values: [...value]
                            }
                            setFormUpdateParams({ ...params, selectNoteType });
                            api.saveForm(params).then(res => {
                                if (res.code == '0') {
                                    let filterArr = res.data;
                                    setSavedValue(filterArr);
                                    Toast.success('保存成功！', 1);
                                }
                                else {
                                    Toast.fail(res.message, 1);
                                }
                                setLoading(false);
                            })
                        }
                    }
                    else if (currentQuestionType === 'Update' || selectNoteType === 'DataActionUpdate') {
                        let filterFile = [];
                        for (let item of filesData) {
                            // 上传时还原来的图片地址
                            let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                            filterFile.push(_originUrl)
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: filterFile
                        }
                        setFormUpdateParams({ ...params, selectNoteType });
                        api.updateData(params).then(res => {
                            if (res.code == '0') {
                                Toast.success('保存成功', 1)
                                //更新当前表单数据
                                getDataById();
                            }
                            else {
                                Toast.fail(res.message, 1)
                            }
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('您尚无此权限！', 1);
                        setLoading(false);
                    }
                })
            }
        });
    };

    //当点击了添加list按钮
    const onClickAddList = (item: any) => {
        return async() => {
            // 更新list
            let _fieldList = tool.addList(JSON.parse(JSON.stringify(fieldList)), item.id);
            setFieldList(_fieldList);
            // 更新节点设置
            let defaultValues: any = [];
            const flatChildren = (arr: any) => {
                for (let i = 0; i < arr.length; i++) {
                    let childrenArr: any = arr[i].children;
                    if (childrenArr) {
                        flatChildren(childrenArr);
                    } else {
                        defaultValues.push(arr[i]);
                    }
                }
            }
            flatChildren(_fieldList)
            setFlatFormItem(defaultValues);
        }
    }

    //当图片删除
    const onPhotoDelete = (fileList: any) => {
        //若当前为录入权限
        setLoading(true);
        if (selectNoteType === 'DataActionInput') {
            //暂存数据
            if (fileList) {
                let filterPhotos = [];
                for (let item of fileList) {
                    // 上传时还原来的图片地址
                    let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                    filterPhotos.push(_originUrl)
                }
                let value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: filterPhotos,
                }];
                let params = {
                    formId: formId,
                    submit: false,
                    values: [...value]
                }
                api.saveForm(params).then(res => {
                    if (res.code == '0') {
                        let filterArr = res.data;
                        setSavedValue(filterArr);
                        Toast.success('删除成功！', 1);
                    }
                    else {
                        Toast.fail(res.message, 1);
                    }
                    setLoading(false);
                    props.updateData()
                })
            }
        }
        else if (currentQuestionType === 'Update' || selectNoteType === 'DataActionUpdate') {
            let filterPhotos = [];
            for (let item of fileList) {
                // 上传时还原来的图片地址
                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                filterPhotos.push(_originUrl)
            }

            let userInfo = sessionStorage.getItem('token');
            let userData = userInfo ? JSON.parse(userInfo) : {}

            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                value: filterPhotos,
                dataTenantCode: userData.tenantCode || ''
            }
            api.DeleteImageData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('删除成功！', 1)
                    //更新当前表单数据
                    getDataById();
                }
                else {
                    Toast.fail(res.message, 1)
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('您尚无此权限！', 1);
            setLoading(false);
        }
    }

    /**
     * 删除视频
     * @param fileList 
     */
    const onVideoDelete = (fileList: any) => {
        //若当前为录入权限
        setLoading(true);
        if (selectNoteType === 'DataActionInput') {
            //暂存数据
            if (fileList) {
                let filterVideos = [];
                for (let item of fileList) {
                    // 上传时还原来的图片地址
                    let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                    filterVideos.push(_originUrl)
                }
                let value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: filterVideos,
                }];
                let params = {
                    formId: formId,
                    submit: false,
                    values: [...value]
                }
                api.saveForm(params).then(res => {
                    if (res.code == '0') {
                        let filterArr = res.data;
                        setSavedValue(filterArr);
                        Toast.success('删除成功！', 1);
                    }
                    else {
                        Toast.fail(res.message, 1);
                    }
                    setLoading(false);
                })
            }
        }
        else if (currentQuestionType === 'Update' || selectNoteType === 'DataActionUpdate') {
            let filterVideos = [];
            for (let item of fileList) {
                // 上传时还原来的图片地址
                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                filterVideos.push(_originUrl)
            }

            let userInfo = sessionStorage.getItem('token');
            let userData = userInfo ? JSON.parse(userInfo) : {}

            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                value: filterVideos,
                dataTenantCode: userData.tenantCode || ''
            }
            api.DeleteImageData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('删除成功！', 1)
                    //更新当前表单数据
                    getDataById();
                }
                else {
                    Toast.fail(res.message, 1)
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('您尚无此权限！', 1);
            setLoading(false);
        }
    }

    /**
     * 删除文件
     * @param fileList 
     */
    const onFileDelete = (fileList: any) => {
        //若当前为录入权限
        setLoading(true);
        if (selectNoteType === 'DataActionInput') {
            //暂存数据
            if (fileList) {
                let filterVideos = [];
                for (let item of fileList) {
                    // 上传时还原来的图片地址
                    let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                    filterVideos.push(_originUrl)
                }
                let value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: filterVideos,
                }];
                let params = {
                    formId: formId,
                    submit: false,
                    values: [...value]
                }
                api.saveForm(params).then(res => {
                    if (res.code == '0') {
                        let filterArr = res.data;
                        setSavedValue(filterArr);
                        Toast.success('删除成功！', 1);
                    }
                    else {
                        Toast.fail(res.message, 1);
                    }
                    setLoading(false);
                })
            }
        }
        else if (currentQuestionType === 'Update' || selectNoteType === 'DataActionUpdate') {
            let filterVideos = [];
            for (let item of fileList) {
                // 上传时还原来的图片地址
                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                filterVideos.push(_originUrl)
            }

            let userInfo = sessionStorage.getItem('token');
            let userData = userInfo ? JSON.parse(userInfo) : {}

            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                value: filterVideos,
                dataTenantCode: userData.tenantCode || ''
            }
            api.DeleteImageData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('删除成功！', 1)
                    //更新当前表单数据
                    getDataById();
                }
                else {
                    Toast.fail(res.message, 1)
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('您尚无此权限！', 1);
            setLoading(false);
        }
    }

    //判断是否加载更多
    const isAddMore = (item: any) => {
        // 患者撤回知情协议
        if (props?.fieldList?.subjectState === 'Withdraw') {
            return null
        }

        if (resolveRO(item) || (item.ro && !item.ro?.lost_control_add)) {
            return null
        }

        //角色code为ReadOnly 表单只读
        if (isReadOnly(props.formCode)) {
            return null
        }

        // 对于editModel==1显示加载更多
        // ?editNew == 1
        if (formActions.includes('FormActionSubmit') || editModel === 1) {
            return (
                <div className="addNextList" onClick={onClickAddList(item)}>
                    点击加载更多
                    <img src={more} alt="more" />
                </div>
            )
        }
    }

    //判断是否显示删除
    const isShowDelete = (i: any, item: any, list: any) => {
        // 表单冻结 & 患者撤回知情协议
        if (props?.fieldList?.freezeState === 'Complete' && props?.fieldList?.subjectState === 'Withdraw') {
            return null
        }

        if (resolveRO(item) || (item.ro && !item.ro?.lost_control_del)) {
            return null
        }

        //角色code为ReadOnly 表单只读
        if (isReadOnly(props.formCode)) {
            return null
        }

        const stylePartial = {
            fontSize: 14,
            marginLeft: 15,
            cursor: 'pointer',
            color: '#ff4d4f',
            display: i == 0 ? 'none' : (i + 1) !== list.length ? 'none' : '',
        }

        // ?少了一个 editNew === 1
        if (formActions.includes('FormActionSubmit') || editModel === 1) {
            if (item.addPosition && item.addPosition == 'top') {
                stylePartial.display = list.length == 1 ? 'none' : i == 0 ? '' : 'none'
            }
            return (
                <div onClick={() => deleteListItem(i, item, list)} style={{...stylePartial }}>[ 删除本节点 ]</div>
            )
        }
    }


    const findAllValues = (data: any) => {
        let returnData: any = []
        if (data.children) {
            data.children.forEach((v: any) => {
                if (v.type == "group") {
                    let _data = findAllValues(v)
                    returnData = [...returnData, ..._data]
                } else {
                    returnData.push(v)
                }
            });
        }
        return returnData
    }


    //list题型删除某一项
    const deleteListItem = (index: any, item: any, list: any) => {
        if (item.addPosition && item.addPosition == 'top') {
            index = list.length - 1 + globalHideCount
        }
        let { _data, _list } = tool.deleteListItem(JSON.parse(JSON.stringify(fieldList)), item.id, index)
       
        _list = findAllValues(_list)
        if (_list) {
            

            let deleteFormData: any = _list.map((v: any) => ({
                dataCode: v.dataCode,
                deCode: v.deCode,
            }))

            let params = {
                formId: formId,
                values: deleteFormData
            }
             // 判断是否能够删除
            api.isDisableDelete(params).then((res:any)=>{
                if(res.code == 0) {
                    if(res.data){

                        // 删除后清理ro标识 防止在删除后立即新增时节点为禁用状态
                        JSFormLock.handleclean(deleteFormData.map((t: any)=> t.dataCode), _data)

                        setFieldList(_data);
                        
                        let _savedValues = savedValue
                        _list.forEach((_item: any) => {
                            let Index = _savedValues.findIndex((v: any) => v.dataCode == _item.dataCode)
                            if (Index > -1) {
                                _savedValues.splice(Index, 1)
                            }
                        })
                        api.deleteData(params).then((res: any) => {
                            if (res.code == 0) {
                                // props.updateData();
                                setSavedValue(_savedValues)
                            }
                        })                    
                    }else{
                       return Toast.fail("该纪录已审核通过，不可删除！", 1)
                    }
                }
            })
          
        }
    }


    const displayPhoto = (item: any) => {
        const mPhoto = savedValue.filter((val: any) => {
            if (item.dataCode === val.dataCode) {
                return true;
            }
            return false;
        }).map((item: any) => {
            return item.value;
        });
        let diaplayPhotos = (mPhoto[0] || []).map((itemVal: any) => {
            return {
                url: itemVal
            }
        })
        let suffixPhotos = changedPhoto(diaplayPhotos);
        return (suffixPhotos && suffixPhotos.length > 0) ?
            <ImagePicker
                ref={mPhotoRef}
                filesList={suffixPhotos}
                multiple={false}
                max={8}
                mode="cover"
                width="22%"
                onGetPreviewUrl={(index: number) => onReadOnlyPreview(index, suffixPhotos) }
                config={['defaultDashed']}
                disabled={true}
            />
            :
            null
    }

    const displayVideo = (item: any) => {
        const mVideos = savedValue.filter((val: any) => {
            if (item.dataCode === val.dataCode) {
                return true;
            }
            return false;
        }).map((item: any) => {
            return item.value;
        });
        let diaplayVideos = mVideos.map((itemVal: any) => {
            return {
                url: itemVal
            }
        })
        let suffixVideos = changedPhoto(diaplayVideos);
        return (suffixVideos && suffixVideos.length > 0) ?
            <Video
                ref={mVideoRef}
                filesList={suffixVideos}
                multiple={false}
                max={1}
                mode="cover"
                width="22%"
                config={['defaultDashed']}
                disabled={true}
            />
            :
            null
    }

    //选择表单
    const switchField = (item: any, index?: any) => {
        //isAdd 代表是新增的list子项
        //isAdd为true走display，不走hides、displays。isAdd为false或者非list的，有配置hides、displays其中一个的，不走display
        if (item.isAdd) {
            if (item.display) {
                // ValueCascade
                if (item.display.type === 'ValueCascade') {
                    // eq
                    if (item.display.condition === 'eq') {
                        //当前选中表单已存的value
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == item.display.target
                        });
                        // console.log('switchField-item:',item,',switchField-currentItem:',currentItem)
                        if (currentItem) {
                            if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                                return chooseForm(item, index)
                            }
                        }
                    }
                    else if (item.display.condition === 'andEq') {
                        let judgeArr = [];
                        for (let i = 0; i < item.display.target.length; i++) {
                            let findedItem = savedValue.find((valueItem: any) => {
                                return valueItem.dataCode === item.display.target[i]
                            });
                            if (findedItem) {
                                if (findedItem.value instanceof Array) {
                                    if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                                else {
                                    if (findedItem.value !== item.display.rule[i]) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                            }
                            else {
                                judgeArr.push(false)
                            }
                        }
                        if (judgeArr.every(item => {
                            if (item === true) {
                                return true
                            }
                        })) {
                            return chooseForm(item, index)
                        }
                    }
                    else if (item.display.condition === 'orEq') {
                        let judgeArr = [];
                        for (let i = 0; i < item.display.target.length; i++) {
                            let findedItem = savedValue.find((valueItem: any) => {
                                return valueItem.dataCode === item.display.target[i]
                            });
                            if (findedItem) {
                                if (findedItem.value instanceof Array) {
                                    if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                                else {
                                    if (findedItem.value !== item.display.rule[i]) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                            }
                            else {
                                judgeArr.push(false)
                            }
                        }
                        if (judgeArr.indexOf(true) !== -1) {
                            return chooseForm(item, index)
                        }
                    }
                } else if (item.display.type === 'RemindsCascade') {
                    if (item.display.condition === 'alarm') {
                        let judgeArr: any = [];
                        item.display.rule.forEach((v: any) => {
                            if (v.site) {
                                if (v.site == props.formCenterCode) {
                                    let currentItem = savedValue.find((i: any) => {
                                        return i.dataCode == item.display.target
                                    })
                                    if (currentItem && currentItem.value) {
                                        judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                    }

                                } else if (v.site == '*') {
                                    let currentItem = savedValue.find((i: any) => {
                                        return i.dataCode == item.display.target
                                    })
                                    if (currentItem && currentItem.value) {
                                        judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                    }

                                }
                            } else {
                                let currentItem = savedValue.find((i: any) => {
                                    return i.dataCode == item.display.target
                                })
                                if (currentItem && currentItem.value) {
                                    judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                }
                            }
                        })

                        if (judgeArr.indexOf(true) !== -1) {
                            return chooseForm(item, index)
                        }
                    }
                } else if (item.display.type === 'eqOuter') {
                    if (item.display.condition === 'eq') {
                        let outerTarget = item.display.target
                        if (outerTarget.indexOf('#') !== -1) {
                            outerTarget = outerTarget.split('#')[0]
                        }
                        //当前选中表单已存的value
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == outerTarget
                        });
                        if (currentItem) {
                            if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                                return chooseForm(item, index)
                            }
                        }
                    }
                }
            } else {
                return chooseForm(item, index)
            }
        } else {
            if (item.displays) {
                if (item.displays instanceof Array) {
                    let judgeArr: any = [];
                    item.displays.forEach((displayItem: any) => {

                        if (displayItem.type === 'ValueCascade') {


                            if (displayItem.condition === 'andEq') {
                                let childJudgeArr = [];
                                for (let i = 0; i < displayItem.target.length; i++) {
                                    let findedItem = savedValue.find((valueItem: any) => {
                                        return valueItem.dataCode === displayItem.target[i]
                                    });
                                    if (findedItem) {
                                        if (findedItem.value instanceof Array) {
                                            if (findedItem.value.indexOf(displayItem.rule[i]) === -1) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                        else {
                                            if (findedItem.value !== displayItem.rule[i]) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                    }
                                    else {
                                        childJudgeArr.push(false)
                                    }
                                }
                                if (childJudgeArr.every(item => {
                                    if (item === true) {
                                        return true
                                    }
                                })) {
                                    judgeArr.push(true)
                                }
                            } else if (displayItem.condition === 'orEq') {
                                let childJudgeArr = [];
                                for (let i = 0; i < displayItem.target.length; i++) {
                                    let findedItem = savedValue.find((valueItem: any) => {
                                        return valueItem.dataCode === item.display.target[i]
                                    });
                                    if (findedItem) {
                                        if (findedItem.value instanceof Array) {
                                            if (findedItem.value.indexOf(displayItem.rule[i]) === -1) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                        else {
                                            if (findedItem.value !== displayItem.rule[i]) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                    }
                                    else {
                                        childJudgeArr.push(false)
                                    }
                                }
                                if (childJudgeArr.indexOf(true) !== -1) {
                                    judgeArr.push(false)
                                }
                            } else {
                                let currentItem = savedValue.find((i: any) => {
                                    return i.dataCode == displayItem.target
                                });
                                if (currentItem) {
                                    if (displayItem.condition === 'eq') {
                                        if (currentItem.value && currentItem.value == displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'lt') {
                                        if (currentItem.value && currentItem.value < displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'lte') {
                                        if (currentItem.value && currentItem.value <= displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'gt') {
                                        if (currentItem.value && currentItem.value > displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'gte') {
                                        if (currentItem.value && currentItem.value >= displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    }
                                } else {
                                    judgeArr.push(false)
                                }

                            }
                        }
                    })
                    if (judgeArr.indexOf(true) !== -1) {
                        return chooseForm(item, index)
                    }
                }
            } else if (item.hides) {
                if (item.hides instanceof Array) {
                    let judgeArr: any = [];
                    item.hides.forEach((displayItem: any) => {
                        if (displayItem.type === 'ValueCascade') {

                            if (displayItem.condition === 'andEq') {
                                let childJudgeArr = [];
                                for (let i = 0; i < displayItem.target.length; i++) {
                                    let findedItem = savedValue.find((valueItem: any) => {
                                        return valueItem.dataCode === displayItem.target[i]
                                    });
                                    if (findedItem) {
                                        if (findedItem.value instanceof Array) {
                                            if (findedItem.value.indexOf(displayItem.rule[i]) === -1) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                        else {
                                            if (findedItem.value !== displayItem.rule[i]) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                    }
                                    else {
                                        childJudgeArr.push(false)
                                    }
                                }
                                if (childJudgeArr.every(item => {
                                    if (item === true) {
                                        return true
                                    }
                                })) {
                                    judgeArr.push(true)
                                }
                            } else if (displayItem.condition === 'orEq') {
                                let childJudgeArr = [];
                                for (let i = 0; i < displayItem.target.length; i++) {
                                    let findedItem = savedValue.find((valueItem: any) => {
                                        return valueItem.dataCode === item.display.target[i]
                                    });
                                    if (findedItem) {
                                        if (findedItem.value instanceof Array) {
                                            if (findedItem.value.indexOf(displayItem.rule[i]) === -1) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                        else {
                                            if (findedItem.value !== displayItem.rule[i]) {
                                                childJudgeArr.push(false);
                                            }
                                            else {
                                                childJudgeArr.push(true);
                                            }
                                        }
                                    }
                                    else {
                                        childJudgeArr.push(false)
                                    }
                                }
                                if (childJudgeArr.indexOf(true) !== -1) {
                                    judgeArr.push(false)
                                }
                            } else {
                                let currentItem = savedValue.find((i: any) => {
                                    return i.dataCode == displayItem.target
                                });
                                if (currentItem) {
                                    if (displayItem.condition === 'eq') {
                                        if (currentItem.value && currentItem.value == displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'lt') {
                                        if (currentItem.value && currentItem.value < displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'lte') {
                                        if (currentItem.value && currentItem.value <= displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'gt') {
                                        if (currentItem.value && currentItem.value > displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    } else if (displayItem.condition === 'gte') {
                                        if (currentItem.value && currentItem.value >= displayItem.rule) {
                                            judgeArr.push(true)
                                        } else {
                                            judgeArr.push(false)
                                        }
                                    }
                                } else {
                                    judgeArr.push(true)
                                }

                            }
                        }
                    })
                    if (judgeArr.indexOf(true) == -1) {
                        return chooseForm(item, index)
                    }
                }
            } else if (item.display) {
                // ValueCascade
                if (item.display.type === 'ValueCascade') {
                    // eq
                    if (item.display.condition === 'eq') {
                        //当前选中表单已存的value
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == item.display.target
                        });
                        // console.log('switchField-item:',item,',switchField-currentItem:',currentItem)
                        if (currentItem) {
                            if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                                return chooseForm(item, index)
                            }
                        }
                    }
                    else if (item.display.condition === 'andEq') {
                        let judgeArr = [];
                        for (let i = 0; i < item.display.target.length; i++) {
                            let findedItem = savedValue.find((valueItem: any) => {
                                return valueItem.dataCode === item.display.target[i]
                            });
                            if (findedItem) {
                                if (findedItem.value instanceof Array) {
                                    if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                                else {
                                    if (findedItem.value !== item.display.rule[i]) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                            }
                            else {
                                judgeArr.push(false)
                            }
                        }
                        if (judgeArr.every(item => {
                            if (item === true) {
                                return true
                            }
                        })) {
                            return chooseForm(item, index)
                        }
                    }
                    else if (item.display.condition === 'orEq') {
                        let judgeArr = [];
                        for (let i = 0; i < item.display.target.length; i++) {
                            let findedItem = savedValue.find((valueItem: any) => {
                                return valueItem.dataCode === item.display.target[i]
                            });
                            if (findedItem) {
                                if (findedItem.value instanceof Array) {
                                    if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                                else {
                                    if (findedItem.value !== item.display.rule[i]) {
                                        judgeArr.push(false);
                                    }
                                    else {
                                        judgeArr.push(true);
                                    }
                                }
                            }
                            else {
                                judgeArr.push(false)
                            }
                        }
                        if (judgeArr.indexOf(true) !== -1) {
                            return chooseForm(item, index)
                        }
                    }
                } else if (item.display.type === 'RemindsCascade') {
                    if (item.display.condition === 'alarm') {
                        let judgeArr: any = [];
                        item.display.rule.forEach((v: any) => {
                            if (v.site) {
                                if (v.site == props.formCenterCode) {
                                    let currentItem = savedValue.find((i: any) => {
                                        return i.dataCode == item.display.target
                                    })
                                    if (currentItem && currentItem.value) {
                                        judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                    }

                                } else if (v.site == '*') {
                                    let currentItem = savedValue.find((i: any) => {
                                        return i.dataCode == item.display.target
                                    })
                                    if (currentItem && currentItem.value) {
                                        judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                    }

                                }
                            } else {
                                let currentItem = savedValue.find((i: any) => {
                                    return i.dataCode == item.display.target
                                })
                                if (currentItem && currentItem.value) {
                                    judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                }
                            }
                        })

                        if (judgeArr.indexOf(true) !== -1) {
                            return chooseForm(item, index)
                        }
                    }
                } else if (item.display.type === 'eqOuter') {
                    if (item.display.condition === 'eq') {
                        let outerTarget = item.display.target
                        if (outerTarget.indexOf('#') !== -1) {
                            outerTarget = outerTarget.split('#')[0]
                        }
                        //当前选中表单已存的value
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == outerTarget
                        });
                        if (currentItem) {
                            if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                                return chooseForm(item, index)
                            }
                        }
                    }
                }
            } else {
                return chooseForm(item, index)
            }
        }
    }

    // 异常提醒
    const formAnnotation = (item: any) => {
        let res: any = null;
        let currentItem = savedValue.find((i: any) => {
            return i.dataCode === item.dataCode
        });
        if (currentItem && currentItem.value) {
            res = currentItem.value
        }
        return res
    }

    //根据表单类型选择相应表单
    const chooseForm = (item: any, index?: any) => {
        let r = verify.checkValueAnnotation(formAnnotation(item), item, props.formCenterCode, savedValue);
        const type = item.type;
      
        if (item?.conditionalValues?.length) {
            let result = mExper.setConditionalValue(item, savedValue)
            let flag = savedValue.some((v: any) => v.dataCode == item.dataCode)

            if (result) {
                let _savedValue = savedValue
                if (flag) {
                    _savedValue = savedValue.map((v: any) => {
                        if (v.dataCode == item.dataCode) {
                            v.value = result
                        }
                        return v
                    })
                } else {
                    _savedValue.push({
                        dataCode: item.dataCode,
                        deCode: item.deCode,
                        value: result
                    })
                }
                setSavedValue(_savedValue)
            }
        }
        if (item.isAdd && item.dataCode?.includes('#') > -1 && item.type == 'select') {
            // console.log(item);
            let Index = savedValue.findIndex((v: any) => v.dataCode == item.dataCode)
            if (Index == -1) {
                let _savedValue = savedValue
                let _saveData = {
                    dataCode: item.dataCode,
                    deCode: item.deCode,
                    value: '',
                    extendAttribute: 'isAdd=true'
                }
                _savedValue.push(_saveData)
                setSavedValue(_savedValue)
            }
        }

        switch (type) {
            case 'map': 
            return (
                <>
                    <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                        {
                            r && r.status &&
                            <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                        }
                        <div className="field_label">
                            {validationIsNull(item)}
                            <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{item.label}</span>
                        </div>
                        <>{renderAnswer(item)}</>

                        <div className="field_right">
                            <div className="defaultValue">
                                <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{showSavedValue(item)}</span>
                            </div>
                            {
                                props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                            }
                        </div>

                    </div>
              </>
            )
            //选择
            case 'select':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            {
                                r && r.status &&
                                <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                            }
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>

                            <div className="field_right">
                                <span className="defaultValue">
                                    {showSavedValue(item)}
                                </span>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>

                        </div>
                    </>
                )
            //只读文本
            case 'text':
                return (
                    <>
                        <div className="content" style={{ backgroundColor: item.background ? item.background : '' }}>
                            <div className="field_label text_field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            {/*<div className="field_right">*/}
                            {/*    <div className="defaultValue">*/}
                            {/*        {showSavedValue(item)}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </>
                )
            // 拍照备注
            case 'photo-remark':
                return (
                    formIsRead ? (
                        <>
                            <div className="content" onClick={showPhotoRemark(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                                <div className="field_label field_label_remark">
                                    {validationIsNull(item)}
                                    {item.label}
                                </div>
                                <>{renderAnswer(item)}</>
                                {
                                    props.readonly != true &&
                                    <div className="field_right">
                                        <div className="defaultValue">查看示例</div>
                                        <img src={formGoFill} alt="前往表单操作" />
                                    </div>
                                }
                            </div>
                            <ImageViewer
                                image={item["link"]}
                                visible={item["link"] === currPhotoRemark}
                                onClose={() => {
                                    setCurrPhotoRemark("")
                                }}
                            />
                        </>
                    ) : <></>
                )
            //输入框
            case 'input':
            case 'region-select': 
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            {
                                r && r.status &&
                                <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                            }
                            <div className="field_label">
                                {validationIsNull(item)}
                                <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{item.label}</span>
                            </div>
                            <>{renderAnswer(item)}</>

                            <div className="field_right">
                                <div className="defaultValue">
                                    <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{showSavedValue(item)}</span>
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>

                        </div>
                    </>
                )
            //输入框
            case 'number':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            {
                                r && r.status &&
                                <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                            }
                            <div className="field_label">
                                {validationIsNull(item)}
                                <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{item.label}</span>
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{showSavedValue(item)}</span>
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //日期不详的组件
            case 'unknownDate':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            {
                                r && r.status &&
                                <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                            }
                            <div className="field_label">
                                {validationIsNull(item)}
                                <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{item.label}</span>
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{showSavedValue(item)}</span>
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //时间表单
            case 'date':
            case 'datetime':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            {
                                r && r.status &&
                                <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                            }
                            <div className="field_label">
                                {validationIsNull(item)}
                                <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{item.label}</span>
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{showSavedValue(item)}</span>
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //文本域
            case 'textarea':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            
            //photo
            case 'photo':
            case 'photo-oss':
            case 'ocr-autofill':
                let renderPhoto = null;
                if (props.readonly) {
                    renderPhoto = displayPhoto(item);
                }
                return (
                    <>
                        <div className={`content ${renderPhoto ? 'content_has_photo' : ''}`} onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoPhoto} alt="前往拍照上传" /> : null
                                }
                            </div>
                        </div>
                        {
                            props.readonly && renderPhoto &&
                            <div style={{ marginTop: '5px', borderBottom: '1px solid #D8D8D8' }}>
                                {renderPhoto}
                            </div>
                        }
                    </>
                )
            //camera
            case 'camera':
                let renderCamera = null;
                if (props.readonly) {
                    renderCamera = displayPhoto(item);
                }
                return (
                    <>
                        <div className={`content ${renderCamera ? 'content_has_photo' : ''}`} onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoPhoto} alt="前往拍照上传" /> : null
                                }
                            </div>
                        </div>
                        {
                            props.readonly && renderCamera &&
                            <div style={{ marginTop: '5px', borderBottom: '1px solid #D8D8D8' }}>
                                {renderCamera}
                            </div>
                        }
                    </>
                )
            // video
            case 'video':
                let renderVideo = null;
                if (props.readonly) {
                    renderVideo = displayVideo(item);
                }
                return (
                    <>
                        <div className={`content ${renderVideo ? 'content_has_video' : ''}`} onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoPhoto} alt="前往上传视频" /> : null
                                }
                            </div>
                        </div>
                        {
                            props.readonly && renderVideo &&
                            <div style={{ marginTop: '5px' }}>
                                {renderVideo}
                            </div>
                        }
                    </>
                )
            // file
            case 'file':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoPhoto} alt="前往上传文件" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //checkbox
            case 'checkbox':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            {
                                r && r.status &&
                                <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                            }
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //input-select
            case 'input-select':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //decimal
            case 'decimal':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)} style={{ backgroundColor: item.background ? item.background : '' }}>
                            {
                                r && r.status &&
                                <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, r.message)}>!</span>
                            }
                            <div className="field_label">
                                {validationIsNull(item)}
                                <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{item.label}</span>
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    <span style={{ color: r && r.status ? 'red' : '#2E2F33' }}>{showSavedValue(item)}</span>
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //多个表单组
            case 'group':
                return (
                    <React.Fragment>
                        {item.label ? <div className="title">
                            &ensp;{item.label}
                        </div> : null}
                        {
                            item.children.map((field: any, i: any) => {
                                // 解析字段配置项 ro 字段只读
                                field.ro = item.ro
                                //
                                let renderDom = switchField(field, i);

                                return renderDom ? (
                                    <div className="field aaaaaa" key={i}>
                                        {renderDom}
                                    </div>
                                ) : null
                            })
                        }
                    </React.Fragment>
                )
            //list类型
            case 'list':
                let cloneData = []
                if (item.children) {
                    cloneData = JSON.parse(JSON.stringify(item.children))
                    if (item.addPosition && item.addPosition == 'top') {
                        cloneData = cloneData.reverse()
                    }
                }

                let deepData: any = []
                let hideCount = 0
                cloneData.forEach((itemData: any) => {
                    // 解析字段配置项 ro 字段只读
                    itemData.ro = item.ro

                    dealIsAddFlag(itemData);

                    if (isAddFlag) {
                        itemData = handleIsAdd(itemData)
                        isAddFlag = false
                    }

                    let list = dealListItemShow(itemData)
                    if (list && list.length > 0) {
                        itemShowList = []
                        deepData.push(itemData)
                    } else {
                        hideCount = hideCount + 1
                    }
                });
                globalHideCount = hideCount

                return (
                    <React.Fragment>
                        {item.label ? <div className="title">
                            &ensp;{item.label}
                        </div> : null}
                        <div className={`list#${index}`}>
                            {
                                deepData.map((field: any, i: any) => {
                                    return (
                                        <div style={{ width: '100%' }} key={i}>
                                            <div style={{ width: '100%', display: 'flex', alignItems: 'baseline' }}>

                                                {
                                                    item.children.length >= 1 ? <Badge style={{ backgroundColor: '#6287EC', color: '#ffffff' }} text={i + 1} overflowCount={item.maxNumber} /> : null
                                                }
                                                {
                                                    isShowDelete(i, item, deepData)
                                                }
                                            </div>
                                            {switchField(field)}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {
                            isAddMore(item)
                        }
                    </React.Fragment>
                )
            default:
                break;
        }
    }


    let isAddFlag = false

    /**判断是不是当前表单新增的List子项 */
    const dealIsAddFlag = (data: any) => {
        if (data.children) {
            data.children.forEach((item: any) => {
                dealIsAddFlag(item)
            });
        } else {
            let currentItem = savedValue.find((i: any) => {
                return i.dataCode == data.dataCode
            });
            if (currentItem && currentItem.extendAttribute && currentItem.extendAttribute.includes('isAdd=true')) {
                isAddFlag = true
            }
        }
    }

    /**给所有子项都加上isAdd */
    const handleIsAdd = (data: any) => {
        if (data.children) {
            data.children.forEach((item: any) => {
                handleIsAdd(item)
            });
        } else {
            data.isAdd = true
        }
        return data
    }




    let globalHideCount = 0

    let itemShowList: any = []

    const dealListItemShow = (data: any) => {
        if (data.children) {
            data.children.forEach((item: any) => {
                dealListItemShow(item)
            });
        } else {
            let reult = dealFildShow(data)
            if (reult) {
                itemShowList.push('true')
            }
        }
        return itemShowList
    }


    /**
     * 判断list子项是不是符合条件控制显示
     * @param item     
     * @returns 显示返回true 
     */
    const dealFildShow = (item: any) => {
        //isAdd代表是新增的list子项
        if (item.isAdd) {
            return 'true'
        }
        if (item.displays) {
            if (item.displays instanceof Array) {
                let judgeArr: any = [];
                item.displays.forEach((displayItem: any) => {
                    if (displayItem.type === 'ValueCascade') {
                        if (displayItem.condition === 'andEq') {
                            let childJudgeArr = [];
                            for (let i = 0; i < displayItem.target.length; i++) {
                                let findedItem = savedValue.find((valueItem: any) => {
                                    return valueItem.dataCode === displayItem.target[i]
                                });
                                if (findedItem) {
                                    if (findedItem.value instanceof Array) {
                                        if (findedItem.value.indexOf(displayItem.rule[i]) === -1) {
                                            childJudgeArr.push(false);
                                        }
                                        else {
                                            childJudgeArr.push(true);
                                        }
                                    }
                                    else {
                                        if (findedItem.value !== displayItem.rule[i]) {
                                            childJudgeArr.push(false);
                                        }
                                        else {
                                            childJudgeArr.push(true);
                                        }
                                    }
                                }
                                else {
                                    childJudgeArr.push(false)
                                }
                            }
                            if (childJudgeArr.every(item => {
                                if (item === true) {
                                    return true
                                }
                            })) {
                                judgeArr.push(true)
                            }
                        } else if (displayItem.condition === 'orEq') {
                            let childJudgeArr = [];
                            for (let i = 0; i < displayItem.target.length; i++) {
                                let findedItem = savedValue.find((valueItem: any) => {
                                    return valueItem.dataCode === item.display.target[i]
                                });
                                if (findedItem) {
                                    if (findedItem.value instanceof Array) {
                                        if (findedItem.value.indexOf(displayItem.rule[i]) === -1) {
                                            childJudgeArr.push(false);
                                        }
                                        else {
                                            childJudgeArr.push(true);
                                        }
                                    }
                                    else {
                                        if (findedItem.value !== displayItem.rule[i]) {
                                            childJudgeArr.push(false);
                                        }
                                        else {
                                            childJudgeArr.push(true);
                                        }
                                    }
                                }
                                else {
                                    childJudgeArr.push(false)
                                }
                            }
                            if (childJudgeArr.indexOf(true) !== -1) {
                                judgeArr.push(true)
                            }
                        } else {

                            let currentItem = savedValue.find((i: any) => {
                                return i.dataCode == displayItem.target
                            });
                            if (currentItem) {
                                if (displayItem.condition === 'eq') {
                                    if (currentItem.value && currentItem.value == displayItem.rule) {
                                        judgeArr.push(true)
                                    } else {
                                        judgeArr.push(false)
                                    }
                                } else if (displayItem.condition === 'lt') {
                                    if (currentItem.value && currentItem.value < displayItem.rule) {
                                        judgeArr.push(true)
                                    } else {
                                        judgeArr.push(false)
                                    }
                                } else if (displayItem.condition === 'lte') {
                                    if (currentItem.value && currentItem.value <= displayItem.rule) {
                                        judgeArr.push(true)
                                    } else {
                                        judgeArr.push(false)
                                    }
                                } else if (displayItem.condition === 'gt') {
                                    if (currentItem.value && currentItem.value > displayItem.rule) {
                                        judgeArr.push(true)
                                    } else {
                                        judgeArr.push(false)
                                    }
                                } else if (displayItem.condition === 'gte') {
                                    if (currentItem.value && currentItem.value >= displayItem.rule) {
                                        judgeArr.push(true)
                                    } else {
                                        judgeArr.push(false)
                                    }
                                }
                            } else {
                                judgeArr.push(false)
                            }

                        }
                    }
                })
                if (judgeArr.indexOf(true) !== -1) {
                    return 'true'
                }
            }
        } else if (item.hides) {
            if (item.hides instanceof Array) {
                let judgeArr: any = [];
                item.hides.forEach((displayItem: any) => {
                    if (displayItem.type === 'ValueCascade') {
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == displayItem.target
                        });
                        if (currentItem) {
                            if (displayItem.condition === 'eq') {
                                if (currentItem.value && currentItem.value == displayItem.rule) {
                                    judgeArr.push(true)
                                } else {
                                    judgeArr.push(false)
                                }
                            } else if (displayItem.condition === 'lt') {
                                if (currentItem.value && currentItem.value < displayItem.rule) {
                                    judgeArr.push(true)
                                } else {
                                    judgeArr.push(false)
                                }
                            } else if (displayItem.condition === 'lte') {
                                if (currentItem.value && currentItem.value <= displayItem.rule) {
                                    judgeArr.push(true)
                                } else {
                                    judgeArr.push(false)
                                }
                            } else if (displayItem.condition === 'gt') {
                                if (currentItem.value && currentItem.value > displayItem.rule) {
                                    judgeArr.push(true)
                                } else {
                                    judgeArr.push(false)
                                }
                            } else if (displayItem.condition === 'gte') {
                                if (currentItem.value && currentItem.value >= displayItem.rule) {
                                    judgeArr.push(true)
                                } else {
                                    judgeArr.push(false)
                                }
                            }
                        } else {
                            judgeArr.push(true)
                        }
                    }
                })
                if (judgeArr.indexOf(true) == -1) {
                    return 'true'
                }
            }

        } else if (item.display) {
            // ValueCascade
            if (item.display.type === 'ValueCascade') {
                // eq
                if (item.display.condition === 'eq') {
                    //当前选中表单已存的value
                    let currentItem = savedValue.find((i: any) => {
                        return i.dataCode == item.display.target
                    });
                    if (currentItem) {
                        if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                            return 'true'
                        }
                    }
                }
                else if (item.display.condition === 'andEq') {
                    let judgeArr = [];
                    for (let i = 0; i < item.display.target.length; i++) {
                        let findedItem = savedValue.find((valueItem: any) => {
                            return valueItem.dataCode === item.display.target[i]
                        });
                        if (findedItem) {
                            if (findedItem.value instanceof Array) {
                                if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                            else {
                                if (findedItem.value !== item.display.rule[i]) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                        }
                        else {
                            judgeArr.push(false)
                        }
                    }
                    if (judgeArr.every(item => {
                        if (item === true) {
                            return true
                        }
                    })) {
                        return 'true'
                    }
                }
                else if (item.display.condition === 'orEq') {
                    let judgeArr = [];
                    for (let i = 0; i < item.display.target.length; i++) {
                        let findedItem = savedValue.find((valueItem: any) => {
                            return valueItem.dataCode === item.display.target[i]
                        });
                        if (findedItem) {
                            if (findedItem.value instanceof Array) {
                                if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                            else {
                                if (findedItem.value !== item.display.rule[i]) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                        }
                        else {
                            judgeArr.push(false)
                        }
                    }
                    if (judgeArr.indexOf(true) !== -1) {
                        return 'true'
                    }
                }

            } else if (item.display.type === 'RemindsCascade') {
                if (item.display.condition === 'alarm') {
                    let judgeArr: any = [];
                    item.display.rule.forEach((v: any) => {
                        if (v.site) {
                            if (v.site == props.formCenterCode) {
                                let currentItem = savedValue.find((i: any) => {
                                    return i.dataCode == item.display.target
                                })
                                if (currentItem && currentItem.value) {
                                    judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                }

                            } else if (v.site == '*') {
                                let currentItem = savedValue.find((i: any) => {
                                    return i.dataCode == item.display.target
                                })
                                if (currentItem && currentItem.value) {
                                    judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                                }

                            }
                        } else {
                            let currentItem = savedValue.find((i: any) => {
                                return i.dataCode == item.display.target
                            })
                            if (currentItem && currentItem.value) {
                                judgeArr = verify.checkRemindValueByRange(v.condition, v.rule, currentItem.value)
                            }
                        }
                    })

                    if (judgeArr.indexOf(true) !== -1) {
                        return 'true'
                    }
                }
            } else if (item.display.type === 'eqOuter') {
                if (item.display.condition === 'eq') {
                    let outerTarget = item.display.target
                    if (outerTarget.indexOf('#') !== -1) {
                        outerTarget = outerTarget.split('#')[0]
                    }
                    //当前选中表单已存的value
                    let currentItem = savedValue.find((i: any) => {
                        return i.dataCode == outerTarget
                    });
                    if (currentItem) {
                        if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                            return 'true'
                        }
                    }
                }
            }
        } else {
            if (item.type != 'hide') {
                return 'true'
            }
        }
    }



    //验证输入规则是否副歌正则标准
    const checkInputFormat = (value: any, selectField: any) => {
        if (verify.checkValueByRep(value, selectField)) {
            setInputError(false)
        } else {
            setInputError(true)
        }
    }

    // 请求校验结果
    const debounceValidateResult = useMemo(()=> {
        return debounceCheckUnique(savedValue, duplicateCheckField, (msg: string)=> {
            Toast.fail(msg, 2);
        })
    }, [savedValue, duplicateCheckField])

    // 值改变时
    const changeValues = (value: any) => {
        if (selectField) {
            if (selectField.type == 'input') {
                setCurrentValue(value);
                checkInputFormat(value, selectField)
                setRangeAnnotation(verify.checkValueAnnotation(value, selectField, props.formCenterCode, savedValue))
            } else if (selectField.type == 'number' || selectField.type == 'decimal') {
                let v = verify.checkValue(value, selectField);
                setCurrentValue(v);
                setRangeAnnotation(verify.checkValueAnnotation(v, selectField, props.formCenterCode, savedValue))
            }else{
                setCurrentValue(value);
            }
            debounceValidateResult({
                value,
                formId,
                dataCode: selectField.dataCode,
                deCode: selectField.deCode,
            })
        }
    }

    // 范围异常提醒框
    const onRangeAnnotation = (e: any, message: any) => {
        e.stopPropagation();
        Toast.info(message, 2);
    }

    // 处理时间数据
    const handleUnknownDate = (value:any)=>{
        if (value) {
            const pieces = Array.isArray(value) ? value : value.split('-')
            const real = [...pieces].splice(0, 3)
            const last = real.map((v: string)=> {
                if (/^\d{1,2}$/.test(v)) {
                    const vv = Number(v)
                    return vv > 9 ? vv : `0${vv}`
                }
                return v
            })
            return last.join('-')
        }
        return "暂无数据"
    }
    
    // 识别成功回调 删除回调
    const onOCRAutofillUpdateFun = (values: any[])=> {
        // 
        const oldMap: any = {}
        if(savedValue.length > 0) {
            savedValue.map((t: any)=> {
                oldMap[t.dataCode] = t
            })
        }
        
        values.forEach(({dataCode, deCode, value})=> {
            if(selectField.dataCode === dataCode) {
                setCurrentValue(value)
            }
            if(oldMap[dataCode]) {
                oldMap[dataCode].value = value
            } else {
                oldMap[dataCode] = {
                    dataCode,
                    deCode,
                    value
                }
            }
        })
        
        setSavedValue(Object.values(oldMap))
    }

    //选择表单具体元素
    // 质疑回复 - 修改原值
    const switchForm = (currentNoteType?: string) => {
        const noteType = currentNoteType ?? selectNoteType
        //录入权限 || 修改权限
        if (noteType === 'DataActionInput' || noteType === 'DataActionUpdate') {
            if (selectField) {
                const type = selectField.type;
                const inputType = selectField.inputType;
                const remind = selectField.remind;

                switch (type) {
                    case 'map':
                        return (   
                            <div className='field_map'>
                                <div className="field_noFlex field_content">
                                 <TextareaItem  disabled  rows={2} autoFocus={true} placeholder='请选择地址' value={currentValue} onChange={(value) => changeValues(value)}/>
                                </div>
                                <div className="field_btn">
                                     <a onClick={toMiniUrl} >{currentValue?'修改地址':'选择地址'}</a>
                                </div>
                             </div>
                  
                        )
                    //输入框
                    case 'input':
                        return (
                            <div style={{ border: inputError || (remind && rangeAnnotation && rangeAnnotation.status) ? '1px solid red' : '' }} className="field_form">
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={selectField?.placeholder || `请输入${selectField?.label}`}
                                    onChange={(value) => changeValues(value)}
                                    value={currentValue}
                                    autoFocus={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                                {/* 范围异常提醒 */}
                                {
                                    remind && rangeAnnotation && rangeAnnotation.status && <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, rangeAnnotation.message)}>!</span>
                                }
                            </div>
                        )
                    //输入框
                    case 'region-select':
                        return (
                            <div className="field_form">
                                <RegionSelect onChange={(value: string) => changeValues(value)} value={currentValue} placeholder={selectField.placeholder || `请选择${selectField.label}`}/>
                            </div>
                        )
                    case 'unknownDate':
                       
                         return ( 
                            <div className="field_noFlex" >
                              
                                <PickerView  value={currentValue} columns={basicColumns}  onChange={handlePickerChange} />
                            </div> 
                        )
                    //时间选择器
                    case 'date':
                    case 'datetime':
                        let maxDate;
                        let minDate;
                        if (selectField.validationRules && selectField.validationRules.length > 0) {
                            for (let item of selectField.validationRules) {
                                if (item.type === 'range') {
                                    if (item.condition === 'lte') {
                                        if (item.rule === '${currDate}') {
                                            maxDate = new Date();
                                        } else if (item.rule === 'visitDate') {
                                            if (item.visit) {
                                                let _data = visitInfoList.find((v: any) => {
                                                    return v.visitName == item.visit
                                                })
                                                if (_data && _data.visitDate) {
                                                    if (item.space) {
                                                        let newDate = dateUtils.getNewDateFormDays(_data.visitDate, item.space, 'reduce')
                                                        maxDate = new Date(newDate);
                                                    } else {
                                                        maxDate = new Date(_data.visitDate);
                                                    }
                                                }
                                            }
                                        } else {
                                            maxDate = new Date(item.rule);
                                        }
                                    }
                                    else if (item.condition === 'gte') {
                                        if (item.rule === '${currDate}') {
                                            minDate = new Date();
                                        } else if (item.rule === 'visitDate') {
                                            if (item.visit) {
                                                let _data = visitInfoList.find((v: any) => {
                                                    return v.visitName == item.visit
                                                })
                                                if (_data && _data.visitDate) {
                                                    if (item.space) {
                                                        let newDate = dateUtils.getNewDateFormDays(_data.visitDate, item.space, 'add')

                                                        minDate = new Date(newDate);
                                                    } else {
                                                        minDate = new Date(_data.visitDate);
                                                    }
                                                }
                                            }
                                        } else {
                                            minDate = new Date(item.rule);
                                        }
                                    }
                                    else if(item.condition === 'between') {
                                        [minDate, maxDate] = parseDateBetweenRule(item.rule)
                                    }
                                } else if (item.type === 'compare') {
                                    if (savedValue && savedValue.length > 0) {
                                        let compareData;
                                        for (let value of savedValue) {
                                            if (item.rule === value["dataCode"]) {
                                                compareData = value["value"];
                                            }
                                        }
                                        if (compareData && item.condition === 'lte') {
                                            maxDate = new Date(compareData);
                                        } else if (compareData && item.condition === 'gte') {
                                            minDate = new Date(compareData);
                                        }
                                    }
                                }
                            }
                        }

                        const datePickerValue = currentValue ? new Date(currentValue) : new Date()

                        return (
                            <div className="field_noFlex">
                                <div className='field_calc'>
                                    <DatePickerView
                                        mode={type}
                                        prefixCls={type === 'datetime' ? 'dpview-col5' : 'dpview-flex'}
                                        value={datePickerValue}
                                        maxDate={maxDate ? maxDate : new Date(2030, 0, 1)}
                                        minDate={minDate ? minDate : new Date(1920, 0, 1)}
                                        onChange={(value) => {
                                            
                                            const real = moment(value).format(type == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')
                                            setCurrentValue(real)

                                            debounceValidateResult({
                                                formId,
                                                value: real,
                                                deCode: selectField.deCode,
                                                dataCode: selectField.dataCode,
                                            })
                                        }}
                                    />
                                    {type === 'datetime' && <SecondsPickerView
                                    value={datePickerValue}
                                    onChange={(value)=> {
                                        datePickerValue.setSeconds(Number(value));

                                        const real = moment(datePickerValue).format('YYYY-MM-DD HH:mm:ss')

                                        setCurrentValue(real)

                                        debounceValidateResult({
                                            formId,
                                            value: real,
                                            deCode: selectField.deCode,
                                            dataCode: selectField.dataCode,
                                        })
                                    }}
                                    className='dpview-col'/>}
                                </div>
                            </div>
                        )
                    //选择
                    case 'select':
                        let selectFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            selectFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem
                                }
                            )
                        }
                        return (
                            <div className="field_noFlex">
                                {
                                    selectFilterArr.length > 0 && selectFilterArr.map((item: any, index: any) => (
                                        <RadioItem key={index} checked={item.value === currentValue} onClick={onClickSelect(item.value)}>
                                            {item.label}
                                        </RadioItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //checkbox
                    case 'checkbox':
                        let checkboxFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            checkboxFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem,
                                    checked: currentValue && currentValue.indexOf(optionItem) !== -1 ? true : false
                                }
                            )
                        }
                        return (
                            <div className="field_noFlex">
                                {
                                    checkboxFilterArr.length > 0 && checkboxFilterArr.map((item: any, index: any) => (
                                        <CheckboxItem checked={item.checked} key={index} onClick={onClickCheckbox(item.value)}>
                                            {item.label}
                                        </CheckboxItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //文本域
                    case 'textarea':
                        return (
                            <div className="field_noFlex">
                                <TextareaItem
                                    id="input"
                                    rows={3}
                                    count={1000}
                                    clear
                                    placeholder={selectField?.placeholder || `请输入${selectField?.label}`}
                                    value={currentValue}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    autoFocus={true}
                                ></TextareaItem>
                            </div>
                        )
                    //数字输入
                    case 'number':
                        return (
                            <div className="field_form" style={remind && rangeAnnotation && rangeAnnotation.status ? annotationStyle : notAnnotationStyle}>
                                <InputItem
                                    id="input"
                                    type="number"
                                    clear
                                    placeholder={selectField?.placeholder || `请输入${selectField?.label}`}
                                    onChange={(value) => changeValues(value)}
                                    value={currentValue}
                                    autoFocus={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                                {/* 范围异常提醒 */}
                                {
                                    remind && rangeAnnotation && rangeAnnotation.status && <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, rangeAnnotation.message)}>!</span>
                                }
                            </div>
                        )
                    //photo
                    case 'photo':
                    case 'photo-oss':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <ImagePicker
                                    ref={mPhotoRef}
                                    filesList={infoPhotos.length > 0 ? infoPhotos : photos}
                                    onChange={onPhotoChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onUpload}
                                    width="22%"
                                    onGetPreviewUrl={onGetPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={false}
                                    onDelete={onPhotoDelete}
                                />
                            </div>
                        )
                    case 'camera':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <Camera
                                    ref={mPhotoRef}
                                    filesList={infoPhotos.length > 0 ? infoPhotos : photos}
                                    onChange={onPhotoChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onUpload}
                                    width="22%"
                                    onGetPreviewUrl={onGetPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={false}
                                    onDelete={onPhotoDelete}
                                />
                            </div>
                        )
                    case 'ocr-autofill':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <OCRAutofill autoOcr={props.autoOcr} updateData={props.updateData}  updateFun={onOCRAutofillUpdateFun} dataAction={selectNoteType} formId={formId} formConfig={fieldList} formIsRead={formIsRead} data={selectField} savedValues={savedValue}  />
                            </div>
                        )
                    // video
                    case 'video':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <Video
                                    ref={mVideoRef}
                                    filesList={videos}
                                    onChange={onVideoChange}
                                    multiple={false}
                                    max={1}
                                    mode="cover"
                                    onUpload={onVideoUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetVideoPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={false}
                                    onDelete={onVideoDelete}
                                />
                                {vedioProgress && vedioProgress.pre && (
                                    <div>
                                        <div>离开页面会导致上传失败，请耐心等待上传完成</div>
                                        <div className={"item"}>剩余时间：{vedioProgress.timer}</div>
                                        <div className={"item"}>上传进度：{vedioProgress.pre}</div>
                                        <div className={"item"}>上传速度：{vedioProgress.rt}</div>
                                    </div>
                                )}
                            </div>
                        )
                    case 'file':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <FileComponent
                                    ref={mFileRef}
                                    filesList={filesData}
                                    onChange={onFileChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onFileUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetFilePreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={false}
                                    onDelete={onFileDelete}
                                />
                            </div>
                        )
                    //输入加选择:input-select
                    case 'input-select':
                        const options: any[] = Object.keys(selectField.optional).reduce((opts: any[], value)=> {
                            opts.push({
                                label: selectField.optional[value],
                                value: value
                            })
                            return opts
                        }, [])

                        return (
                            <div>
                                <div className="field_form">
                                    {
                                        inputType && inputType == 'inputrange' ?
                                            <>
                                                <InputItem
                                                    id="input"
                                    
                                                    className='inputrange-placeholder'
                                                    clear
                                                    placeholder={`最小${selectField.label}`}
                                                    onChange={(value) => { setInputMinValue(verify.checkValue(value, selectField)) }}
                                                    
                                                    value={inputMinValue}
                                                    autoFocus={true}
                                                ></InputItem>
                                                <div className='inputrange_divider'></div>
                                                <InputItem
                                                    id="input"
                                                    clear
                                                    className='inputrange-placeholder'
    
                                                    placeholder={`最大${selectField.label}`}
                                                    onChange={(value) => { setInputMaxValue(verify.checkValue(value, selectField)) }}
                                                    value={inputMaxValue}
                                                    autoFocus={true}
                                                ></InputItem>
                                            </> :
                                            <InputItem
                                                id="input"
                                                clear
                                                className='inputrange-placeholder'
                                                placeholder={`请输入${selectField.label}`}
                                                onChange={(value) => {setInputMinValue(verify.checkValue(value, selectField)) }}
                                                value={inputMinValue}
                                                autoFocus={true}
                                            ></InputItem>
                                    }
                                </div>

                                <div className="field_noFlex">
                                    {
                                        options.length > 0 && options.map((item: any, index: any) => (
                                            <RadioItem key={index} checked={item.value === selectValue} onClick={() => {
                                                setSelectValue(item.value)
                                                setOtherValue('')
                                            }}>
                                                {item.label}
                                            </RadioItem>
                                        ))
                                    }
                                    {
                                        switchOtherField()
                                    }
                                </div>
                            </div>
                        )
                    case 'decimal':
                        return (
                            <div className="field_form" style={remind && rangeAnnotation && rangeAnnotation.status ? annotationStyle : notAnnotationStyle}>
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={selectField?.placeholder || `请输入${selectField?.label}`}
                                    onChange={(value) => changeValues(value)}
                                    value={currentValue}
                                    autoFocus={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                                {/* 范围异常提醒 */}
                                {
                                    remind && rangeAnnotation && rangeAnnotation.status && <span className="field_annotation" onClick={(e: any) => onRangeAnnotation(e, rangeAnnotation.message)}>!</span>
                                }
                            </div>
                        )
                    default:
                        break;
                }
            }
        }
        //注释权限
        else if (selectNoteType === 'DataActionAnnotation') {
            return (
                <React.Fragment>
                    {
                        annotationType && annotationType.length > 0 ? < div className="field_noFlex">
                            {annotationType.map((item: any, index: any) => (
                                <RadioItem key={index} checked={item.key === annotationValue} onClick={onAnnotationChange(item.key)}>
                                    {item.text}
                                </RadioItem>
                            ))}
                        </div> : null
                    }
                </React.Fragment >
            )
        }
        // 注释只读
        else if (selectNoteType === 'DataActionAnnotationRead') {
            return (
                <React.Fragment>
                    {
                        annotationType && annotationType.length > 0 ? < div className="field_noFlex">
                            {annotationType.map((item: any, index: any) => (
                                <RadioItem key={index} checked={item.key === annotationValue} onClick={onAnnotationChange(item.key)} disabled={true}>
                                    {item.text}
                                </RadioItem>
                            ))}
                        </div> : null
                    }
                </React.Fragment >
            )
        }
        //备注权限
        else if (selectNoteType === 'DataActionRemark') {
            return (
                <div className="field_noFlex">
                    <TextareaItem
                        id="input"
                        rows={3}
                        count={1000}
                        clear
                        placeholder={`请输入备注信息`}
                        value={remarkValue}
                        onChange={(value) => { setRemarkValue(value) }}
                        autoFocus={true}
                    ></TextareaItem>
                </div>
            )
        }
        //只读权限
        else if (selectNoteType === 'DataActionRead') {
            if (selectField) {
                const type = selectField.type;
                const inputType = selectField.inputType;
                switch (type) {
                      //定位选点
                      case 'map':
                        return (   
                            <div className='field_map'>
                                <div className="field_noFlex field_content">
                                 <TextareaItem  disabled  rows={2} autoFocus={true} placeholder='请选择地址' value={currentValue} onChange={(value) => changeValues(value)}/>
                                </div>
                                <div className="field_btn">
                                     <a onClick={toMiniUrl} >{currentValue?'修改地址':'选择地址'}</a>
                                </div>
                             </div>
                        )
                    //输入框
                    case 'input':
                    case 'autocomplete':
                    case 'region-select':
                        return (
                            <div className={selectField.unit ? 'field_flex' : 'field_form'}>
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    value={currentValue}
                                    autoFocus={true}
                                    disabled={true}
                                    
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    case 'unknownDate':
                        return (
                            <div className="field_noFlex" >
                                <div>{handleUnknownDate(currentValue)}</div>
                                {/* <PickerView    value={currentValue} columns={basicColumns}  onChange={handlePickerChange} />  */}
                            </div>
                        )
                    //时间选择器
                    case 'date':
                    case 'datetime':
                        return (
                            <div className="field_noFlex">
                                <DatePickerView
                                    mode={type}
                                    value={currentValue ? new Date(currentValue) : new Date()}
                                    // maxDate={new Date()}
                                    minDate={new Date(1980, 0, 1)}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    disabled={true}
                                />
                            </div>
                        )
                    //选择
                    case 'select':
                        let selectFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            selectFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem
                                }
                            )
                        }
                        return (
                            <div className="field_noFlex">
                                {
                                    selectFilterArr.length > 0 && selectFilterArr.map((item: any, index: any) => (
                                        <RadioItem key={index} checked={item.value === currentValue} onClick={onClickSelect(item.value)} disabled={true}>
                                            {item.label}
                                        </RadioItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //checkbox
                    case 'checkbox':
                        let checkboxFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            checkboxFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem,
                                    checked: currentValue && currentValue.indexOf(optionItem) !== -1 ? true : false
                                }
                            )
                        }
                        return (
                            <div className="field_noFlex">
                                {
                                    checkboxFilterArr.length > 0 && checkboxFilterArr.map((item: any, index: any) => (
                                        <CheckboxItem checked={item.checked} key={index} onClick={onClickCheckbox(item.value)} disabled={true}>
                                            {item.label}
                                        </CheckboxItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //文本域
                    case 'textarea':
                        return (
                            <div className="field_noFlex">
                                <TextareaItem
                                    id="input"
                                    rows={3}
                                    count={1000}
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    value={currentValue}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    autoFocus={true}
                                    disabled={true}
                                ></TextareaItem>
                            </div>
                        )
                    //数字输入
                    case 'number':
                        return (
                            <div className="field_form">
                                <InputItem
                                    id="input"
                                    type="number"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setInputValue(verify.checkValue(value, selectField)) }}
                                    value={currentValue}
                                    autoFocus={true}
                                    disabled={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    //小数输入
                    case 'decimal':
                        return (
                            <div className="field_form">
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setInputValue(verify.checkValue(value, selectField)) }}
                                    value={currentValue}
                                    autoFocus={true}
                                    disabled={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    //photo         
                    case 'photo':
                    case 'photo-oss':
                    case 'ocr-autofill':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <ImagePicker
                                    filesList={photos}
                                    onChange={onPhotoChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onUpload}
                                    width="22%"
                                    onGetPreviewUrl={onGetPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={true}
                                    onDelete={onPhotoDelete}
                                />
                            </div>
                        )
                    case 'camera':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <Camera
                                    filesList={photos}
                                    onChange={onPhotoChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onUploadCamera}
                                    width="22%"
                                    onGetPreviewUrl={onGetPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={true}
                                    onDelete={onPhotoDelete}
                                />
                            </div>
                        )
                    // video
                    case 'video':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <Video
                                    filesList={videos}
                                    onChange={onVideoChange}
                                    multiple={false}
                                    max={1}
                                    mode="cover"
                                    onUpload={onVideoUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetVideoPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={true}
                                    onDelete={onVideoDelete}
                                />
                            </div>
                        )
                    case 'file':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <FileComponent
                                    filesList={filesData}
                                    onChange={onFileChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onFileUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetFilePreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={true}
                                    onDelete={onFileDelete}
                                />
                            </div>
                        )
                    //输入加选择:input-select
                    case 'input-select':
                        const options: any[] = Object.keys(selectField.optional).reduce((opts: any[], value)=> {
                            opts.push({
                                label: selectField.optional[value],
                                value: value
                            })
                            return opts
                        }, [])
                        return (
                            <div>
                                <div className="field_form">
                                    {
                                        inputType && inputType == 'inputrange' ?
                                            <>
                                                <InputItem
                                                    id="input"
                                                    clear
                                                    placeholder={`最小${selectField.label}`}
                                                    value={inputMinValue}
                                                    disabled={true}
                                                ></InputItem>
                                                <div className='inputrange_divider'></div>
                                                <InputItem
                                                    id="input"
                                                    clear
                                                    placeholder={`最大${selectField.label}`}
                                                    value={inputMaxValue}
                                                    disabled={true}
                                                ></InputItem>
                                            </> :
                                            <InputItem
                                                id="input"
                                                clear
                                                placeholder={`请输入${selectField.label}`}
                                                value={inputValue}
                                                disabled={true}
                                            ></InputItem>
                                    }
                                </div>

                                <div className="field_noFlex">
                                    {
                                        options.length > 0 && options.map((item: any, index: any) => (
                                            <RadioItem key={index} checked={item.value === selectValue} disabled={true}>
                                                {item.label}
                                            </RadioItem>
                                        ))
                                    }
                                    {
                                        switchOtherField()
                                    }
                                </div>
                            </div>
                        )
                    
                    default:
                        break;
                }
            }
        }
        //备注只读
        else if (selectNoteType === 'DataActionRemarkRead') {
            return (
                <div className="field_noFlex">
                    <TextareaItem
                        id="input"
                        rows={3}
                        count={1000}
                        clear
                        placeholder={`请输入备注信息`}
                        value={remarkValue}
                        onChange={(value) => { setRemarkValue(value) }}
                        disabled={true}
                    ></TextareaItem>
                </div>
            )
        }
        //创建/关闭质疑
        else if (selectNoteType === 'DataActionQuestion') {
            return (
                <React.Fragment>
                    <div className="question_content">
                        <div className="questionList">
                            {
                                selectFieldQuestion && selectFieldQuestion.length > 0 && selectFieldQuestion.map((item: any, index: any) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                switchQuestion(item)
                                            }
                                        </React.Fragment>
                                    )
                                })
                            }
                            {
                                !selectFieldQuestion || selectFieldQuestion.length === 0 ? <div style={{ marginTop: '10px' }}>暂无质疑</div> : null
                            }
                        </div>
                        <div className="question_title">
                            &nbsp;添加质疑
                        </div>
                        <div className="question">
                            <div className="questionForm_Item">
                                {
                                    questionType.length > 0 ?
                                        <Picker
                                            data={questionType}
                                            title="请选择检查类型"
                                            cols={1}
                                            extra="请选择(可选)"
                                            value={selectQuestionType}
                                            onOk={v => { setSelectQuestionType(v) }}
                                        >
                                            <List.Item arrow="horizontal">检查类型</List.Item>
                                        </Picker> : null
                                }
                            </div>
                            {/* <div className="questionForm_Item">
                                {
                                    questionRecipient.length > 0 ?
                                        <Picker
                                            data={questionRecipient}
                                            title="发送到"
                                            cols={1}
                                            extra="请选择(可选)"
                                            value={selectRecipient}
                                            onOk={v => { setSelectRecipient(v) }}
                                        >
                                            <List.Item arrow="horizontal">发送到</List.Item>
                                        </Picker> : null
                                }
                            </div> */}
                            <div className="questionForm_Item">
                                <TextareaItem
                                    rows={4}
                                    count={1000}
                                    clear
                                    placeholder={`请输入检查说明`}
                                    title="检查说明"
                                    value={questionInf}
                                    onChange={(value) => { setQuestionInf(value) }}
                                ></TextareaItem>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        //回复质疑
        else if (selectNoteType === 'DataActionAnswer') {
            return (
                <React.Fragment>
                    <div className="question_content">
                        <div className="questionList">
                            {
                                selectFieldQuestion && selectFieldQuestion.length > 0 && selectFieldQuestion.map((item: any, index: any) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                switchQuestion(item)
                                            }
                                        </React.Fragment>
                                    )
                                })
                            }
                            {
                                !selectFieldQuestion || selectFieldQuestion.length === 0 ? <div style={{ marginTop: '10px' }}>暂无质疑</div> : null
                            }
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        //痕迹稽查
        else if (selectNoteType === 'DataActionTrace') {
            return (
                <div className="traceTable">
                    <table width="100%">
                        <thead>
                            <tr>
                                <th>操作时间</th>
                                <th>操作类型</th>
                                <th>操作后值</th>
                                <th>操作备注</th>
                                <th>操作人</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                traceList && traceList.length > 0 && traceList.map((item: any, index: any) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.operationTime}</td>
                                            <td>{item.operationTypeText}</td>
                                            <td>{item.newValue}</td>
                                            <td>{item.remark}</td>
                                            <td>{item.operator}</td>
                                        </tr>
                                    )
                                })
                            }
                            {
                                traceList.length === 0 ? <tr>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                </tr> : null
                            }
                        </tbody>
                    </table>
                </div>
            )
        }
    }

    //选择当有other字段时对应的表单
    const switchOtherField = () => {
        if (selectField && selectField.type === 'checkbox') {

            if (selectField.other) {
                if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                    let type = selectField.other.type;
                    switch (type) {
                        //input
                        case 'input':
                            return (
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.optional[selectField.other.key]}值`}
                                    onChange={(value) => { setOtherValue(value) }}
                                    value={otherValue}
                                    autoFocus={true}
                                ></InputItem>
                            )
                            break;
                        //date
                        case 'date':
                        case 'datetime':
                            return (
                                <DatePickerView
                                    mode={type}
                                    value={otherValue ? new Date(otherValue) : new Date()}
                                    // maxDate={new Date()}
                                    minDate={new Date(1980, 0, 1)}
                                    onChange={(value) => { setOtherValue(value) }}
                                />
                            )
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                // return null;
                // setOtherValue(value)
            }
        }
        else if (selectField && selectField.type === 'input-select') {
            if(!selectField.other) {
                return null;
            }

            const { key, type } = selectField.other;

            // 用户选择了其他
            if(key !== selectValue) {
                return null;
            }
            if(type === 'input') {
                return (
                    <InputItem
                        id="input"
                        clear
                        placeholder={`请输入${selectField.optional[key]}值`}
                        onChange={(value) => { setOtherValue(value) }}
                        value={otherValue}
                        autoFocus={true}
                    ></InputItem>
                )
            }
            if(['date', 'datetime'].includes(type)) {
                return (
                    <DatePickerView
                        mode={type}
                        value={otherValue ? new Date(otherValue) : new Date()}
                        // maxDate={new Date()}
                        minDate={new Date(1920, 0, 1)}
                        onChange={(value) => { setOtherValue(value) }}
                    />
                )
            }
        }
        else if (selectField && selectField.type === 'select') {
            if (selectField.other) {
                if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                    let type = selectField.other.type;
                    switch (type) {
                        //input
                        case 'input':
                            return (
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.optional[selectField.other.key]}值`}
                                    onChange={(value) => { setOtherValue(value) }}
                                    value={otherValue}
                                    autoFocus={true}
                                ></InputItem>
                            )
                            break;
                        //date
                        case 'date':
                        case 'datetime':
                            return (
                                <DatePickerView
                                    mode={type}
                                    value={otherValue ? new Date(otherValue) : new Date()}
                                    // maxDate={new Date()}
                                    minDate={new Date(1920, 0, 1)}
                                    onChange={(value) => { setOtherValue(value) }}
                                />
                            )
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    }

    //选择对应操作按钮
    const switchActionBtn = () => {
        if (selectNoteType) {
            switch (selectNoteType) {
                //数据只读
                case 'DataActionRead':
                    return null
                //备注只读
                case 'DataActionRemarkRead':
                    return null
                //注释只读
                case 'DataActionAnnotationRead':
                    return null
                //质疑只读
                case 'DataActionQuestionRead':
                    return null
                //录入
                case 'DataActionInput':
                    if (selectField && (
                        selectField.type === 'photo' ||
                        selectField.type === 'photo-oss' ||
                        selectField.type === 'camera' ||
                        selectField.type === 'video' ||
                        selectField.type === 'video' ||
                        selectField.type === 'ocr-autofill' ||
                        selectField.type === 'file')
                    ) {
                        return null
                    }
                    else {
                        return (
                            <span onClick={onSave}>
                                <img src={saveBtn} alt="save" />
                                保存
                            </span>
                        )
                    }

                    break;
                //修改
                case 'DataActionUpdate':
                    if (selectField && (
                        selectField.type === 'ocr-autofill' ||
                        selectField.type === 'photo' ||
                        selectField.type === 'photo-oss' ||
                        selectField.type === 'camera' ||
                        selectField.type === 'video' ||
                        selectField.type === 'file')
                    ) {
                        return null
                    }
                    else {
                        return (
                            <span onClick={()=> onUpdate()}>
                                <img src={saveBtn} alt="save" />
                                修改
                            </span>
                        )
                    }
                    break;
                //备注
                case 'DataActionRemark':
                    return (
                        <span onClick={onRemark}>
                            <img src={saveBtn} alt="save" />
                            备注
                        </span>
                    )
                //注释
                case 'DataActionAnnotation':
                    return (
                        <span onClick={onAnnotation}>
                            <img src={saveBtn} alt="save" />
                            注释
                        </span>
                    )
                //创建/关闭质疑
                case 'DataActionQuestion':
                    return (
                        <span onClick={onQuestion}>
                            <img src={saveBtn} alt="save" />
                            添加质疑
                        </span>
                    )
                //回复质疑
                case 'DataActionAnswer':
                    return (
                        null
                    )
                //痕迹稽查
                case 'DataActionTrance':
                    return (
                        <span onClick={onTrance}>
                            <img src={saveBtn} alt="save" />
                            痕迹稽查
                        </span>
                    )
                default:
                    break;
            }
        }
    }

    //根据质疑操作类型选择不同操作
    const switchformByquestionAction = (item: any) => {
        if (item) {
            switch (item) {
                case 'Retain':
                    return (
                        <div className="form_content">
                            <div className="input_item">
                                <TextareaItem
                                    rows={2}
                                    count={1000}
                                    clear
                                    placeholder={`补充说明`}
                                    value={supplementInf}
                                    onChange={(value) => { setSupplementInf(value) }}
                                ></TextareaItem>
                            </div>
                            <div className="form_content_action">
                                <div className="cancel_btn" onClick={() => { setSelectQuestionItemId('') }}>
                                    <IconFont type="iconReject"></IconFont>取消
                                </div>
                                <div className="save_btn" onClick={onAnswerQuestion}>
                                    <IconFont type="iconSave"></IconFont>保存
                                </div>
                            </div>
                        </div>
                    )
                    break;
                case 'Update':
                    return (
                        <div className="form_content">
                            {switchForm('DataActionUpdate')}
                            <div className="input_item">
                                <TextareaItem
                                    rows={2}
                                    count={1000}
                                    clear
                                    placeholder={`补充说明`}
                                    value={supplementInf}
                                    onChange={(value) => { setSupplementInf(value) }}
                                ></TextareaItem>
                            </div>
                            <div className="form_content_action">
                                <div className="cancel_btn" onClick={() => { setSelectQuestionItemId('') }}>
                                    <IconFont type="iconReject"></IconFont>取消
                                </div>
                                <div className="save_btn" onClick={onAnswerQuestion}>
                                    <IconFont type="iconSave"></IconFont>保存
                                </div>
                            </div>
                        </div>
                    )
                    break;
                case 'Empty':
                    return (
                        <div className="form_content">
                            <div className="input_item">
                                <TextareaItem
                                    rows={2}
                                    count={1000}
                                    clear
                                    placeholder={`补充说明`}
                                    value={supplementInf}
                                    onChange={(value) => { setSupplementInf(value) }}
                                ></TextareaItem>
                            </div>
                            <div className="form_content_action">
                                <div className="cancel_btn" onClick={() => { setSelectQuestionItemId('') }}>
                                    <IconFont type="iconReject"></IconFont>取消
                                </div>
                                <div className="save_btn" onClick={onAnswerQuestion}>
                                    <IconFont type="iconSave"></IconFont>保存
                                </div>
                            </div>
                        </div>
                    )
                    break;
                default:
                    break;
            }
        }
    }

    //选择对应的question列表
    const switchQuestion = (item: any) => {
        const state = item.state;
        if (['DataActionAnswer', 'DataActionInput', 'DataActionUpdate', 'DataActionRead'].includes(selectNoteType)) {
            switch (state) {
                //创建
                case 'Create':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    {
                                        props.readonly !== true && selectQuestionItemId !== item.id && (
                                            <div className="answer_btn" style={{ border: '1px solid #6287EC' }} onClick={() => { setSelectQuestionItemId(item.id); }}>
                                                <IconFont type="iconAnswer"></IconFont>回复
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {
                                selectQuestionItemId === item.id ? <div className="questionAction_content">
                                    <div className="questionAction_content_taps">
                                        {
                                            answerQuestionType.length > 0 && answerQuestionType.map((item: any, index: any) => {
                                                return (
                                                    <div style={{ background: item.value === currentQuestionType ? '#6287EC' : '#ffffff', color: item.value === currentQuestionType ? '#ffffff' : '#6287EC' }} key={index} className="questionAction_content_tapItem" onClick={() => { setCurrentQuestionType(item.value); setSupplementInf(''); setQuestionModifyValue(''); }}>{item.label}</div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        props.readonly !== true && (
                                            switchformByquestionAction(currentQuestionType)
                                        )
                                    }
                                </div> : null
                            }
                        </div>
                    )
                    break;
                //重新打开
                case 'Reopen':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑已回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                {
                                    props.readonly !== true && (
                                        <div className="questionItem_right">
                                            {
                                                selectQuestionItemId !== item.id  && (
                                                    <div className="answer_btn" style={{ border: '1px solid #6287EC' }} onClick={() => { setSelectQuestionItemId(item.id) }}>
                                                        <IconFont type="iconAnswer"></IconFont>回复
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                
                            </div>
                            {
                                selectQuestionItemId === item.id ? <div className="questionAction_content">
                                    <div className="questionAction_content_taps">
                                        {
                                            answerQuestionType.length > 0 && answerQuestionType.map((item: any, index: any) => {
                                                return (
                                                    <div style={{ background: item.value === currentQuestionType ? '#6287EC' : '#ffffff', color: item.value === currentQuestionType ? '#ffffff' : '#6287EC' }} key={index} className="questionAction_content_tapItem" onClick={() => { setCurrentQuestionType(item.value); setSupplementInf(''); setQuestionModifyValue(''); }}>{item.label}</div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        props.readonly !== true && (
                                            switchformByquestionAction(currentQuestionType)
                                        )
                                    }
                                </div> : null
                            }
                        </div>
                    )
                    break;
                //已回复
                case 'Answer':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={answer_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#2A344D' }}>
                                        <img style={{ verticalAlign: 'middle' }} src={answer_question_2} alt="已修复" />
                                        已修复
                                        {/* <span style={{ color: '#6C96F7', marginLeft: '4px' }}>回复待确认</span> */}
                                        <span style={{ color: '#6C96F7', marginLeft: '4px' }}>{item.answer ? item.answer.content : ''}</span>
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    {
                                        props.readonly !== true && selectQuestionItemId !== item.id && (
                                            <div className="answer_btn" style={{ border: '1px solid #6287EC' }} onClick={() => { setSelectQuestionItemId(item.id) }}>
                                                <img src={question_modify} alt="修改" />
                                                修改
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {
                                selectQuestionItemId === item.id && (
                                    <div className="questionAction_content">
                                        <div className="questionAction_content_taps">
                                            {
                                                answerQuestionType.length > 0 && answerQuestionType.map((item: any, index: any) => {
                                                    return (
                                                        <div style={{ background: item.value === currentQuestionType ? '#6287EC' : '#ffffff', color: item.value === currentQuestionType ? '#ffffff' : '#6287EC' }} key={index} className="questionAction_content_tapItem" onClick={() => { setCurrentQuestionType(item.value); setSupplementInf(''); setQuestionModifyValue(''); }}>{item.label}</div>
                                                    )
                                                })
                                            }
                                        </div>
                                        {
                                            props.readonly !== true && (
                                                switchformByquestionAction(currentQuestionType)
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    )
                    break;
                //已关闭
                case 'Closed':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={close_question} alt="" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#2A344D' }}>
                                        <span>
                                        <img src={close_question_2} alt="" />
                                        已修复
                                        </span>
                                        <span style={{ color: '#6C96F7', marginLeft: '4px' }}>{item.answer ? item.answer.content : ''}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    break;

                default:
                    break;
            }
        }
        //质疑创建和关闭权限
        else if (selectNoteType === 'DataActionQuestion') {
            switch (state) {
                //创建
                case 'Create':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑未回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                {
                                    props.readonly !== true && (
                                        <div className="questionItem_right">
                                            <div style={{ backgroundColor: '#6287EC', border: '1px solid #6287EC', color: '#ffffff' }} className="answer_btn" onClick={closeQuestion(item.id)}>
                                                <IconFont type="iconClose"></IconFont>关闭
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )
                    break;
                //重新打开
                case 'Reopen':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                {
                                    props.readonly !== true && (
                                        <div className="questionItem_right">
                                            <div style={{ backgroundColor: '#6287EC', border: '1px solid #6287EC', color: '#ffffff' }} className="answer_btn" onClick={closeQuestion(item.id)}>
                                                <IconFont type="iconClose"></IconFont>关闭
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )
                    break;
                //已回复
                case 'Answer':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={answer_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#2A344D' }}>
                                        <img style={{ verticalAlign: 'middle' }} src={answer_question_2} alt="已修复" />
                                        <span style={{ whiteSpace: 'nowrap' }}>已修复</span>
                                        <span style={{ color: '#6C96F7', marginLeft: '4px' }}>{item.answer ? item.answer.content : ''}</span>
                                    </div>
                                </div>
                                {
                                    props.readonly !== true && (
                                        <div className="questionItem_right">
                                            <div style={{ backgroundColor: '#ffffff', border: '1px solid #6287EC', color: '#6287EC' }} className="answer_btn" onClick={reopenQuestion(item.id)}>
                                                重新打开
                                            </div>
                                            <div style={{ backgroundColor: '#6287EC', border: '1px solid #6287EC', color: '#ffffff' }} className="answer_btn" onClick={closeQuestion(item.id)}>
                                                <IconFont type="iconClose"></IconFont>关闭
                                            </div>
                                        </div>
                                    )
                                }
                            </div>

                        </div>
                    )
                    break;
                //已关闭
                case 'Closed':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={close_question} alt="" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div style={{ color: '#2A344D' }} className="questionItem_left_bottom">
                                        <span><img src={close_question_2} alt="质疑已关闭" />已修复</span>
                                        <span style={{ color: '#6C96F7', marginLeft: '4px' }}>{item.answer ? item.answer.content : ''}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    break;

                default:
                    break;
            }
        }
    }

    // 渲染质疑
    const renderAnswer = (item: any) => {
        const currentItem = savedValue.find(({dataCode}: any) => dataCode === item.dataCode);

        if (!currentItem) {
            return null
        }

        if (Array.isArray(currentItem.questions) && currentItem.questions?.length > 0) {
            // 优先 Create
            let closedLen = 0
            let curr: any = null
            for (const t of currentItem.questions) {
                if (t.state === 'Closed') {
                    closedLen += 1
                    continue
                }
                // 优先
                if (t.state === 'Create' || t.state === 'Reopen') {
                    curr = t
                    break;
                }
                if (t.state === 'Answer') {
                    curr = t
                    break;
                }
            }

            if (curr === null) {
                curr = currentItem.questions[0]
            }

            // 图标
            let stateSource = IconAnswer
            if (closedLen === currentItem.questions.length) {
                stateSource = IconAnswerClosed
            } else if(curr.state === 'Answer') {
                stateSource = IconAnswerReply
            }
            if (props.readonly != true) {
                return (
                    <>
                        {
                            currentItem.annotation && (
                                <ExclamationCircleFill width={20} height={20} color='#51C11A'/>
                            )
                        }
                        <img src={stateSource} alt='' className='IconAnswer' />
                    </>
                )
            }
            return (
                <img src={stateSource} onClick={(e)=> {
                    e.stopPropagation()
                    setVisibleQModal(true)
                    setSelectFieldQuestion(currentItem.questions)
                }} alt='' className='IconAnswer' />
            )
        }

        if (currentItem.annotation && props.readonly != true) {
            return (
                <ExclamationCircleFill width={20} height={20} color='#51C11A'/>
            )
        }
        
        return null
    }

    // 图片有缓存，需要加后缀更新
    const changedPhoto = (photos: any) => {
        photoId++;
        const urlChangePhotos = photos.map((val: Object) => {
            let _url = '';
            // @ts-ignore
            if (val.url.indexOf('?') > -1) {
                // @ts-ignore
                _url = val.url + photoId
            } else {
                // @ts-ignore
                _url = val.url + '?id=' + photoId
            }
            return {
                url: _url
            };
        });
        return urlChangePhotos;
    }

    // 敏感信息等拼接
    const getInfoTipPhoto = (photos: any) => {
        const urlChangePhotos = photos.map((val: Object, index: any) => {
            // @ts-ignore
            let _url = val.url.indexOf('?') > 0 ? val.url.split('?')[0] : val.url;
            let sensitiveInfo = matchUrlSensitive[_url] !== undefined ? "1" : "0";
            return {
                ...val,
                // @ts-ignore
                url: val.url,
                sensitiveInfo: sensitiveInfo, // "1"是敏感 "0"不是
                desensitization: isEditPhoto ? "1" : "0",// "1"是脱敏 "0"不是
                sensitiveData: matchUrlSensitive[_url]
            };
        });
        return urlChangePhotos;
    }

    // 图片有缓存，需要加后缀更新
    const filterDeletePhoto = (photos: any) => {
        const seletedPhoto = photos[currentPhotoIndex];
        let deleteIndex = 0;
        const remainUrlPhotos = photos.filter((val: Object, index: number) => {
            // @ts-ignore
            let isDeleteUrl = val.url.indexOf(seletedPhoto.url) > -1;
            if (isDeleteUrl) {
                deleteIndex = index;
            }
            // @ts-ignore
            return !isDeleteUrl;
        });

        return {
            remainPhotos: remainUrlPhotos,
            deleteIndex
        };
    }

    const updatePhoto = () => {
        let suffixPhotos = changedPhoto(photos);
        setPhotos(suffixPhotos);
        setInfoPhotos(getInfoTipPhoto(suffixPhotos));
    }

    const imgCanvasPreviewClose = (backType: String, backMsg: String, backAction: String) => {
        // @ts-ignore
        if (backMsg && (backMsg.indexOf('http') === 0)) {
            // @ts-ignore
            matchUrlSensitive[backMsg] = backMsg;
        }
        setPhotoVisible(false);
        setShowModal(true);
        if (backType === 'deleteImage' || backAction === 'deleteImage') {
            let { remainPhotos, deleteIndex } = filterDeletePhoto(photos);
            // @ts-ignore
            mPhotoRef.current.toDeletePhoto(deleteIndex);
            setPhotos(remainPhotos);
            setInfoPhotos(getInfoTipPhoto(remainPhotos));
        } else {
            updatePhoto();
        }
        // doNothing返回时，notUpdate首次进入未保存图片删除时，不需要更新入库
        if (backType !== 'doNothing' && backAction !== 'notUpdate') {
            // 保存上传提交的数据
            afterUploadSaveData();
            // 清空上传需要提交的数据
        }
        setFormUpdateParams({});
    }

    let isValidUrl = false;
    if (infoPhotos[currentPhotoIndex] && infoPhotos[currentPhotoIndex].url) {
        if (infoPhotos[currentPhotoIndex].url.indexOf('http') === 0) {
            isValidUrl = true;
        }
    }
    return (
        <div>
            {
                fieldList && fieldList.length > 0 && fieldList.map((item: any, index: any) => {
                    return (
                        <div className="formItem" key={index}>
                            {switchField(item)}
                        </div>
                    )
                })
            }
       
            {/* 质疑展示 */}
            <Modal visible={visibleQModal} animationType={"slide-up"}>
                <Card>
                    <Card.Header title="质疑查看"></Card.Header>
                    <Card.Body>
                        <div className='modalContent'>
                            <div className="question_content">
                                <div className="questionList">
                                {
                                    Array.isArray(selectFieldQuestion) && selectFieldQuestion.map((t: any)=> switchQuestion(t))
                                }
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                    <Card.Footer content={
                        <Button size="small" onClick={()=> {
                            setVisibleQModal(false)
                            setSelectFieldQuestion([])
                        }}>返回</Button>
                    }>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal visible={showModal} animationType={"slide-up"}>
                {/* <div className="closeModal">
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: selectField && selectField.label.length > 22 ? '12px' : '14px' }}>{selectField ? selectField.label : null}</div>
                    <img onClick={onCloseModal} src={close} alt="close" />
                </div> */}

                {selectField && <><div style={{ textAlign: 'left', fontSize: '16px', color: '#424347', padding: '10px', display: 'flex', lineHeight: '18px', paddingBottom: '0' }}>
                    <div style={{ width: '6px', height: '18px', background: '#6c96f7', marginRight: '4px' }}></div>
                    <div style={{ width: 'calc(100% - 12px)' }}>
                        {selectField ? selectField.label : null}
                    </div>
                </div>

                    <div className="modalContent">
                        {
                            currentFormInfo && currentFormInfo.length > 0 ? <div className="label_content">
                                {
                                    currentFormInfo.map((item: any, index: any) => {
                                        return (
                                            <span key={index}>
                                                <img src={noCollected} alt="noCollected" />{item}
                                            </span>
                                        )
                                    })
                                }
                            </div> : null
                        }
                        <div className="field_content">
                            {/* <div className="noteBtn">
                            {
                                dataAction.map((item: any, index: any) => {
                                    return (
                                        item.key == selectNoteType ? <div key={index} className="noteItem active" onClick={onClickNoteType(item.key)}>{item.label}
                                        </div> : <div key={index} className="noteItem" onClick={onClickNoteType(item.key)}>{item.label}
                                            </div>
                                    )
                                })
                            }
                        </div> */}
                            <Tabs tabs={dataAction} tabBarUnderlineStyle={{ borderColor: '#6287EC' }} tabBarBackgroundColor="transparent" tabBarInactiveTextColor="#9A9FAB" page={currentTabIndex} onChange={(tab, index) => { onChangeTab(tab, index) }} renderTab={tab => <span>{tab.label}</span>}>
                            </Tabs>
                            {
                                switchForm()
                            }
                        </div>
                        <div className="saveBtn">
                            <span onClick={() => { onCloseModal() }} style={{ marginRight: '6px', background: 'white', color: '#6287EC', border: '1px solid #6287EC' }}>
                                <IconFont style={{ padding: '0', marginRight: '4px' }} type="iconClose"></IconFont>
                                返回

                            </span>
                            {/* <span onClick={nextTopic}>{nextText}</span> */}
                            {
                                switchActionBtn()
                            }
                            {
                                currentTabIndex === 0 && <span onClick={onClear}  style={{ marginLeft: '6px', background: 'white', color: '#6287EC', border: '1px solid #6287EC' }}>
                                   <IconFont   style={{ padding: '0', marginRight: '4px' }} type="iconClose"></IconFont>
                                    清空
                               </span>
                            }
                        </div>
                    </div>

                    <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
                    <ActivityIndicator animating={uploadState} size={"small"} text={'图片正在上传中...'} toast />
                </>}
            </Modal>

            {/* 图片预览 */}
            {
                // !editPhoto && 
                // !ifEditPhoto && 
                // !isEditPhoto && 
                // 不需要OCR识别以及不需要脱敏
                !isOcr && !isEditPhoto &&
                <PhotoSlider
                    photoClosable
                    bannerVisible={true}
                    images={photos && photos.map((item: any) => ({ src: item.url }))}
                    visible={photoVisible}
                    onClose={() => { setPhotoVisible(false); setShowModal(true) }}
                    index={currentPhotoIndex}
                    introVisible={true}
                    onIndexChange={(i: any) => { setCurrentPhotoIndex(i) }}
                />
            }
            {
                props.readonly &&
                <PhotoSlider
                    photoClosable
                    bannerVisible={true}
                    images={photos && photos.map((item: any) => ({ src: item.url }))}
                    visible={photoVisible}
                    onClose={() => { setPhotoVisible(false); setTimeout(() => { document.body.style.overflow = 'auto'; }, 500); }}
                    index={currentPhotoIndex}
                    introVisible={true}
                    onIndexChange={(i: any) => { setCurrentPhotoIndex(i) }}
                />
            }
            {/* 脱敏预览 */}
            {
                // 需要OCR识别或者脱敏
                // editPhoto && photoVisible && 
                // ifEditPhoto && photoVisible && 
                // isEditPhoto && photoVisible && isValidUrl &&
                (isOcr || isEditPhoto) && photoVisible && isValidUrl &&
                <ImgCanvas
                    isOcr={isOcr}
                    isEditPhoto={isEditPhoto}
                    needOcrRecongize={needOcrRecongize}
                    itemData={itemData}
                    sensitiveData={sensitiveData[currentPhotoIndex]}
                    photos={photos}
                    fieldList={fieldList}
                    selectField={selectField}
                    formCode={formCode}
                    version={version}
                    formId={formId}
                    imgUrl={infoPhotos[currentPhotoIndex]}
                    onClose={(backType: String, backMsg: String, backAction: String) => { imgCanvasPreviewClose(backType, backMsg, backAction); }}
                />
            }
            {/* <div style={{ display: photoVisible? '' : 'none' }}>
                <ImgCanvas
                    photoVisible={photoVisible}
                    photos={photos}
                    imgUrl={photos[currentPhotoIndex]}
                    onClose={() => { setPhotoVisible(false); setShowModal(true) }}
                />
            </div> */}
        </div>
    )
}

export default forwardRef(FormField);